import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ConfirmationDialogComponent } from '@common/confirmation-dialog/confirmation-dialog.component';
import { PreviewListingComponent } from '@common/listing-preview/preview-listing/preview-listing.component';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { CalendarOptions } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import rrulePlugin from '@fullcalendar/rrule';
import timeGridPlugin from '@fullcalendar/timegrid';
import { commonImages } from '@images/common-images';
import { propertyImages } from '@images/property-images';
import { contractEmail } from '@models/contract.model';
import { ApiService } from '@services/api/api.service';
import { CalendarAPIService } from '@services/api/calendarAPI.service';
import { CommissionService } from '@services/api/commission.service';
import { shouldHideError } from '@services/helpers/server-error-silence';
import { ContractApiService } from '@services/api/contract.service';
import { HistoryService } from '@services/api/history.service';
import { LeadsService } from '@services/api/leads.service';
import { LibraryGalleryService } from '@services/api/library-gallery.service';
import { ListingApprovalService } from '@services/api/listing-approval.service';
import { ListingPropertiesService } from '@services/api/listing-properties.service';
import { PropertyService } from '@services/api/property.service';
import { SharedService } from '@services/api/shared.service';
import { StaffContactService } from '@services/api/staff-contact.service';
import { TaskService } from '@services/api/task.service';
import { WorkflowService } from '@services/api/workflow.service';
import { AuthService } from '@services/auth.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { Utils } from '@services/helpers/utils';
import { toWallClock } from '@services/helpers/wall-clock.util';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { SharedDataService } from '@services/shared-data.service';
import { MessageService } from '@services/util/message.service';
import { ReduxService } from '@state-management/redux.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { RRule } from 'rrule';
import { Observable, Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DashService } from '../../dash-board/dash.service';
import { Leads } from '../../leads-management/leads/leads';
import { ListingService } from '../listing-service';
import { ProjectService } from '@services/api/project.service';
import { SettingService } from '@services/api/setting.service';

declare var $: any;

interface itemData1 {
  activeIndexs: number;
  id: number;
  name: string;
  img: string;
  icon: string;
}
@Component({
  selector: 'app-props-rightbar',
  templateUrl: './props-rightbar.component.html',
  styleUrls: ['./props-rightbar.component.scss'],
})
export class PropsRightBarComponent implements OnInit, AfterViewInit {
  @ViewChild('previewModel') previewModel: PreviewListingComponent;
  @ViewChild('soldModalDialog') soldModalDialog: ConfirmationDialogComponent;
  @ViewChild('contractDeleteDialog') contractDeleteDialog: ConfirmationDialogComponent;
  @Input() property_id: any;
  @Input() ownersId: any;
  @Input() TaskUpdatedStatus: Observable<any> = null;
  @Input() contractList: Observable<any> = null;
  @Input() leadData: Observable<any> = null;
  @Input() contactListed: Observable<any> = null;
  @Input() isPortal: boolean = false;
  @ViewChild('fullcalendar') fullcalendar: FullCalendarComponent;
  @Output() isSaved = new EventEmitter<boolean>();
  @Output() NewLeadInformation = new EventEmitter<Object>();
  @Output() isPropertyClose = new EventEmitter<any>();
  @Input() create_contact: Observable<any> = null;
  @Input() updated_contact: Observable<any> = null;
  @Input() renderPropertyList: Observable<boolean> = null;

  /**
   * The full Leads page, handed in by whichever page hosts this drawer. It is a template rather
   * than a component reference because the Leads page itself renders `app-props-rightbar` for
   * the listing behind a lead — importing its module here would close that loop. Hosts that do
   * not pass one keep the original inline lead table.
   */
  @Input() leadsPageTemplate: TemplateRef<any> = null;

  /**
   * Fires when a lead is saved or closed from the drawer. The Leads tab is the project leads page
   * now, and it owns its own list — refetching this component's inline table would leave that page
   * showing stale rows.
   */
  leadListRefresh: Subject<boolean> = new Subject<boolean>();

  /**
   * The Leads tab drops the split layout: the leads page carries its own filters, chart and
   * table and needs the whole drawer width to be usable.
   */
  get isLeadFullPage(): boolean {
    return !!this.leadsPageTemplate && this.activeIndexs === 1;
  }

  common_images = commonImages;
  images = propertyImages;
  formAllFields: { name: string; label: string }[] = [];
  appointmentPageSize: any = 5;
  public approvalHistoryTotal: number = 0;
  contractEmail: contractEmail = new contractEmail();
  options = { types: [], componentRestrictions: { country: 'AU' } };
  @ViewChild('searchKeyword', { static: true }) searchKeyword: ElementRef;
  minimumDate = new Date();
  hours = Leads.hours;
  minutes = Leads.minutes;
  duration = ['AM', 'PM'];
  selectedStartHour = null;
  selectedStartMinutes = null;
  selectedStartDuration = 'AM';
  selectedEndHour = null;
  selectedEndMinutes = null;
  selectedEndDuration = 'AM';
  selectedAuctionStartHour = null;
  selectedAuctionStartMinutes = null;
  public selectedRelatedContact = null;
  selectedAuctionStartDuration = 'AM';
  S3Path = environment.S3 + '/';
  public saleCommission = null;
  public conjunctionDetails = null;
  calendar_views = [
    {
      value: 'timeGridDay',
      name: 'Day',
    },
    {
      value: 'timeGridWeek',
      name: 'Week',
    },
    {
      value: 'dayGridMonth',
      name: 'Month',
    },
  ];
  marketing_payable_by_array = [
    { id: 1, value: 'Upon signing of agreement' },
    { id: 1, value: 'At unconditional' },
    { id: 2, value: 'At settlement' },
    { id: 4, value: 'Payable by agent' },
    { id: 3, value: 'Refer to Notes' },
  ];
  dynamicPanelSizes: number[] = [50, 50];
  accept_decline: any[] = [{ tag_name: 'Accepted' }, { tag_name: 'Declined' }, { tag_name: 'Presented' }];
  cal_view_grid = 'timeGridWeek';
  cal_view_list = 'timeGridDay';
  statusList: any;
  isImg: boolean = false;
  loadAdmin: boolean = true;
  isDocuments: boolean = false;
  emailTemplates: any;
  properties: any;
  originalAssigns: any[] = [];
  originalAssignsAppt: any[] = [];

  fullList: any;
  selectedProperty: any;
  public userRole = Crypto.decrypt(this.localStorageService.GetItem('role'));
  submitDisable = false;
  editProperty: FormGroup;
  controls: { [key: string]: { control: AbstractControl; tabIndex: number; elementRef: ElementRef } } = {};
  columns = [
    {
      type: 'text',
      field: 'title',
      column: 'Title',
    },
    {
      type: 'text',
      field: 'jobTypeName',
      column: 'Job Type',
    },
    {
      type: 'text',
      field: 'taskStatusName',
      column: 'Task Status',
    },
    {
      type: 'text',
      field: 'due_date',
      column: 'Due Date',
    },
  ];

  ContactColumns = [
    {
      type: 'text',
      field: 'contact_type',
      column: 'Contact Type',
      width: '150px',
    },
    {
      type: 'text',
      field: 'full_name',
      column: 'Name',
      width: '200px',
    },
    {
      type: 'text',
      field: 'mobile_no',
      column: 'Mobile',
      width: '150px',
    },
    {
      type: 'text',
      field: 'email',
      column: 'Email',
      width: '230px',
    },
  ];
  attached_contacts: any;
  contact_to_delete: any;
  queryParams: any = {};
  full_attach_contact: any;
  isNewAddress = true;
  public Editor = ClassicEditor;
  availablebusy = [
    {
      name: 'Busy',
    },
    {
      name: 'Free',
    },
  ];
  available = [
    {
      name: 'private',
    },
    {
      name: 'public',
    },
  ];

  leadCalendarManagePermission: any;
  selectedActivityType: any;
  selectedContactType: any;

  selectedInspectionType: any;
  selectedInspectType: any;
  contactMethods = [
    {
      name: 'Private Inspection',
      icon: this.common_images?.email_building_icon,
    },
    {
      name: 'Call',
      icon: this.common_images?.email_call_icon,
    },
    {
      name: 'Meeting',
      icon: this.common_images?.email_user_icon,
    },
  ];
  inspectionMethods = [
    {
      name: 'Open Home',
      icon: this.images?.open_home_icon,
    },
    {
      name: 'EOI',
      icon: this.images?.open_home_icon,
    },
    {
      name: 'Auction',
      icon: this.images?.auction_icon,
    },
  ];
  AuthUser: any;
  insertEvent = {
    attendees: [],
    location: '',
    description: '',
    availablebusy: 'Busy',
    availability: 'private',
    visibility: 'private',
    startdate: null,
    enddate: null,
    starttime: null,
    endtime: null,
    agent: null,
  };
  insertEvent2 = {
    attendees: [],
    location: '',
    description: '',
    availablebusy: 'Busy',
    availability: 'private',
    visibility: 'private',
    startdate: null,
    enddate: null,
    starttime: null,
    endtime: null,
  };

  property_apt_list: any = [];
  property_inspection_list: any = [];
  copy_property_inspection_list: any = [];
  time_hour: any;
  googleAuthUrl: any;
  emailConnected: boolean = false;
  userPermission: any;
  isFetchedEvent = false;
  addNewApt: boolean = false;
  addNewAIns: boolean = false;
  isSalesAgent: boolean = false;
  isPropertyAgent: boolean = false;
  error = null;
  contact_to_update: String[] = [];

  keyword = '';
  history_keyword = '';
  pop_title = '';
  optional: CalendarOptions = {
    initialView: 'dayGridMonth',
    firstDay: 1,
    initialDate: '2022-01-31',
    headerToolbar: {
      left: 'prev,next',
      center: 'title',
      right: '',
    },
    events: [],
    editable: true,
    selectable: true,
    selectMirror: true,
    slotDuration: '01:00:00',
    scrollTime: '08:00:00',
    dayHeaderFormat: { day: 'numeric', weekday: 'short', omitCommas: true },
    titleFormat: { year: 'numeric', month: 'long' },
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, rrulePlugin],
  };
  default_view = 'grid';
  divPos = {};
  submitted = false;
  addDefaults: any = {};
  loading = false;
  event_loading = false;
  // tag manager

  numOfNotValidFields: number = 0;
  requiredErrorMessages = [];
  calendarAccessUser = [];
  activeCalendarUser: any;
  landSpecialError = false;
  buildingSpecialError = false;
  showErrorForExternalAgent = false;
  aptEventTitle = '';
  event_popup = false;
  event_popup_detail = null;
  todayDate = moment().format('ddd Do MMMM YYYY');
  tomorrowDate = moment().add(1, 'days').format('ddd Do MMMM YYYY');
  todayTasks = [];
  tomorrowTasks = [];
  closeStatusId = null;

  // commission

  public commission_applied = null;
  public isPercentage = null;
  public commission_rate = null;
  public commission_amount = null;

  constructor(
    private localStorageService: LocalStorageService,
    public lmService: LeadManagementService,
    private _leadsService: LeadsService,
    private router: Router,
    private fb: FormBuilder,
    private api: ApiService,
    private _libraryGalleryService: LibraryGalleryService,
    private toast: ToastrService,
    private Auth: AuthService,
    public sds: SharedDataService,
    private remmiConfirm: RemmiConfirmService,
    private datePipe: DatePipe,
    private elemRef: ElementRef,
    private _workflowService: WorkflowService,
    private redux: ReduxService,
    private cdr: ChangeDetectorRef,
    private dash: DashService,
    public listingService: ListingService,
    private _listingApprovalService: ListingApprovalService,
    private _listingPropertiesService: ListingPropertiesService,
    private _taskService: TaskService,
    private _staffContactService: StaffContactService,
    private _contractApiService: ContractApiService,
    private _commissionService: CommissionService,
    private _propertyService: PropertyService,
    private _historyService: HistoryService,
    private _CalendarAPIService: CalendarAPIService,
    private _sharedService: SharedService,
    private message: MessageService,
    private _settingService: SettingService,
    private _projectService: ProjectService
  ) {
    this.editProperty = this.fb.group({
      type: [null, Validators.required],
      // Which lot of the residential lot project this listing is; Residential types only.
      residential_project_lot: [null],
      // The project that lot belongs to. Was an ngModel on the old Associate Project dropdown.
      related_to_project: [null],
      property_status: [null, Validators.required],
      property_address: [null, Validators.required],
      listing_type: [null, Validators.required],
      contract_status: [null],
      agent: [null],
      secondaryagent: [null],
      other_agents: this.fb.array([]),
      brief_description: [''],
      features: [null],
      views: [''],
      office_id: [''],
      default_img: [''],

      // address
      building_name: [''],
      unit_no: [''],
      street_no: [''],
      street_name: [''],
      suburb: [''],
      state: [''],
      post_code: [''],
      startDate: [''],
      startTime: [''],
      endTime: [''],
      location: [''],
      attendees: [''],
      availablebusy: [''],
      availability: [''],
      description: [''],

      country: [''],

      beds: ['', [Validators.min(0)]],
      leaseTerms: [''],
      rentalPerWeek: [''],
      securityBond: [''],
      availableDate: [''],
      furnished: [false],
      petFriendly: [false],
      pets: [''],
      baths: [''],
      ensuite: [''],
      living_areas: [''],
      car: [''],
      pools: [''],
      study: [''],
      garage: [''],
      car_port: [''],
      heading: [''],
      description_garax: [''],
      open_spaces: [''],
      building_area: [''],
      land_area: [''],
      date: [],
      settledDate: [],
      value: [''],
      exterior: [''],
      roofing: [''],
      energy_rating: [''],
      image_copy: [false],
      isDomainCrm: [false],
      isReaCrm: [false],
      isWpPush: [false],
      market_place: [false],
      homley_portal: [false],
      real_estate_view: [false],
      isHideAddress: [false],
      project_associate: [false],

      existingproperty: [null],
      prevproperty: [''],

      building_area_type: [this.listingService.listingPropertyOption.land_building_area_type[0]],
      land_area_type: [this.listingService.listingPropertyOption.land_building_area_type[0]],
      domain_land_type: [null],

      display_price: [''],

      lot: [''],
      subdivision: [''],
      titleref: [''],
      legaladdress: [''],
      legalname: [''],
      solicitors: [''],
      solicitorscontract: [''],
      selling_agreement_start_date: [null],
      selling_agreement_end_date: [null],
      percentage_inclusive_of_gst: [null],
      amount_inclusive_of_gst: [null],
      commission_payable: [null],
      agreed_marketing_spend: [null],
      marketing_payable_by: [null],
      selling_agreement_notes: [''],
      otherEmail: [''],
      sub_office_id: [null],
      soldDate: [],
      soldPrice: [''],
      soldPriceDisplay: [true],
    });

    this.controls = {
      type: { control: this.editProperty.get('type'), tabIndex: 0, elementRef: this.elemRef },
      property_status: { control: this.editProperty.get('property_status'), tabIndex: 0, elementRef: this.elemRef },
      contract_status: { control: this.editProperty.get('contract_status'), tabIndex: 0, elementRef: this.elemRef },
      agent: { control: this.editProperty.get('agent'), tabIndex: 0, elementRef: this.elemRef },
      secondaryagent: { control: this.editProperty.get('secondaryagent'), tabIndex: 0, elementRef: this.elemRef },
      other_agents: { control: this.editProperty.get('other_agents'), tabIndex: 0, elementRef: this.elemRef },
      brief_description: { control: this.editProperty.get('brief_description'), tabIndex: 0, elementRef: this.elemRef },
      features: { control: this.editProperty.get('features'), tabIndex: 0, elementRef: this.elemRef },
      views: { control: this.editProperty.get('views'), tabIndex: 0, elementRef: this.elemRef },
      office_id: { control: this.editProperty.get('office_id'), tabIndex: 0, elementRef: this.elemRef },
      default_img: { control: this.editProperty.get('default_img'), tabIndex: 0, elementRef: this.elemRef },

      startDate: { control: this.editProperty.get('startDate'), tabIndex: 0, elementRef: this.elemRef },
      startTime: { control: this.editProperty.get('startTime'), tabIndex: 0, elementRef: this.elemRef },
      endTime: { control: this.editProperty.get('endTime'), tabIndex: 0, elementRef: this.elemRef },
      location: { control: this.editProperty.get('location'), tabIndex: 0, elementRef: this.elemRef },
      attendees: { control: this.editProperty.get('attendees'), tabIndex: 0, elementRef: this.elemRef },
      availablebusy: { control: this.editProperty.get('availablebusy'), tabIndex: 0, elementRef: this.elemRef },
      availability: { control: this.editProperty.get('availability'), tabIndex: 0, elementRef: this.elemRef },
      description: { control: this.editProperty.get('description'), tabIndex: 0, elementRef: this.elemRef },

      country: { control: this.editProperty.get('country'), tabIndex: 0, elementRef: this.elemRef },

      beds: { control: this.editProperty.get('beds'), tabIndex: 0, elementRef: this.elemRef },
      leaseTerms: { control: this.editProperty.get('leaseTerms'), tabIndex: 0, elementRef: this.elemRef },
      rentalPerWeek: { control: this.editProperty.get('rentalPerWeek'), tabIndex: 0, elementRef: this.elemRef },
      securityBond: { control: this.editProperty.get('securityBond'), tabIndex: 0, elementRef: this.elemRef },
      availableDate: { control: this.editProperty.get('availableDate'), tabIndex: 0, elementRef: this.elemRef },
      furnished: { control: this.editProperty.get('furnished'), tabIndex: 0, elementRef: this.elemRef },
      petFriendly: { control: this.editProperty.get('petFriendly'), tabIndex: 0, elementRef: this.elemRef },
      pets: { control: this.editProperty.get('pets'), tabIndex: 0, elementRef: this.elemRef },
      baths: { control: this.editProperty.get('baths'), tabIndex: 0, elementRef: this.elemRef },
      ensuite: { control: this.editProperty.get('ensuite'), tabIndex: 0, elementRef: this.elemRef },
      living_areas: { control: this.editProperty.get('living_areas'), tabIndex: 0, elementRef: this.elemRef },
      car: { control: this.editProperty.get('car'), tabIndex: 0, elementRef: this.elemRef },
      pools: { control: this.editProperty.get('pools'), tabIndex: 0, elementRef: this.elemRef },
      study: { control: this.editProperty.get('study'), tabIndex: 0, elementRef: this.elemRef },
      garage: { control: this.editProperty.get('garage'), tabIndex: 0, elementRef: this.elemRef },
      car_port: { control: this.editProperty.get('car_port'), tabIndex: 0, elementRef: this.elemRef },
      heading: { control: this.editProperty.get('heading'), tabIndex: 0, elementRef: this.elemRef },
      description_garax: { control: this.editProperty.get('description_garax'), tabIndex: 0, elementRef: this.elemRef },
      open_spaces: { control: this.editProperty.get('open_spaces'), tabIndex: 0, elementRef: this.elemRef },
      building_area: { control: this.editProperty.get('building_area'), tabIndex: 0, elementRef: this.elemRef },
      land_area: { control: this.editProperty.get('land_area'), tabIndex: 0, elementRef: this.elemRef },
      date: { control: this.editProperty.get('date'), tabIndex: 0, elementRef: this.elemRef },
      settledDate: { control: this.editProperty.get('settledDate'), tabIndex: 0, elementRef: this.elemRef },
      value: { control: this.editProperty.get('value'), tabIndex: 0, elementRef: this.elemRef },
      exterior: { control: this.editProperty.get('exterior'), tabIndex: 0, elementRef: this.elemRef },
      roofing: { control: this.editProperty.get('roofing'), tabIndex: 0, elementRef: this.elemRef },
      energy_rating: { control: this.editProperty.get('energy_rating'), tabIndex: 0, elementRef: this.elemRef },
      isDomainCrm: { control: this.editProperty.get('isDomainCrm'), tabIndex: 0, elementRef: this.elemRef },
      isReaCrm: { control: this.editProperty.get('isReaCrm'), tabIndex: 0, elementRef: this.elemRef },
      isWpPush: { control: this.editProperty.get('isWpPush'), tabIndex: 0, elementRef: this.elemRef },
      market_place: { control: this.editProperty.get('market_place'), tabIndex: 0, elementRef: this.elemRef },
      isHideAddress: { control: this.editProperty.get('isHideAddress'), tabIndex: 0, elementRef: this.elemRef },
      property_address: { control: this.editProperty.get('property_address'), tabIndex: 0, elementRef: this.elemRef },
      listing_type: { control: this.editProperty.get('listing_type'), tabIndex: 0, elementRef: this.elemRef },
      building_area_type: { control: this.editProperty.get('building_area_type'), tabIndex: 0, elementRef: this.elemRef },
      land_area_type: { control: this.editProperty.get('land_area_type'), tabIndex: 0, elementRef: this.elemRef },
      domain_land_type: { control: this.editProperty.get('domain_land_type'), tabIndex: 0, elementRef: this.elemRef },
      display_price: { control: this.editProperty.get('display_price'), tabIndex: 0, elementRef: this.elemRef },
      lot: { control: this.editProperty.get('lot'), tabIndex: 3, elementRef: this.elemRef },
      subdivision: { control: this.editProperty.get('subdivision'), tabIndex: 3, elementRef: this.elemRef },
      titleref: { control: this.editProperty.get('titleref'), tabIndex: 3, elementRef: this.elemRef },
      legaladdress: { control: this.editProperty.get('legaladdress'), tabIndex: 3, elementRef: this.elemRef },
      legalname: { control: this.editProperty.get('legalname'), tabIndex: 3, elementRef: this.elemRef },
      solicitors: { control: this.editProperty.get('solicitors'), tabIndex: 3, elementRef: this.elemRef },
      solicitorscontract: { control: this.editProperty.get('solicitorscontract'), tabIndex: 3, elementRef: this.elemRef },
      selling_agreement_start_date: {
        control: this.editProperty.get('selling_agreement_start_date'),
        tabIndex: 3,
        elementRef: this.elemRef,
      },
      selling_agreement_end_date: {
        control: this.editProperty.get('selling_agreement_end_date'),
        tabIndex: 3,
        elementRef: this.elemRef,
      },
      soldDate: { control: this.editProperty.get('soldDate'), tabIndex: 3, elementRef: this.elemRef },
      percentage_inclusive_of_gst: {
        control: this.editProperty.get('percentage_inclusive_of_gst'),
        tabIndex: 3,
        elementRef: this.elemRef,
      },
      amount_inclusive_of_gst: {
        control: this.editProperty.get('amount_inclusive_of_gst'),
        tabIndex: 3,
        elementRef: this.elemRef,
      },
      commission_payable: { control: this.editProperty.get('commission_payable'), tabIndex: 3, elementRef: this.elemRef },
      agreed_marketing_spend: {
        control: this.editProperty.get('agreed_marketing_spend'),
        tabIndex: 3,
        elementRef: this.elemRef,
      },
      marketing_payable_by: {
        control: this.editProperty.get('marketing_payable_by'),
        tabIndex: 3,
        elementRef: this.elemRef,
      },
      selling_agreement_notes: {
        control: this.editProperty.get('selling_agreement_notes'),
        tabIndex: 3,
        elementRef: this.elemRef,
      },
    };
  }

  imageHeight: number;
  imagesLiteHeight: number;
  imagesLiteWidth: number;
  onSplitterResize(e: any) {
    let round = Math.round(e?.sizes[0]);
    if (this.is_agentModel && round <= 30) {
      this.getAgentModel();
    } else {
      this.imageHeight = Math.round(e?.sizes[0]) * 6.3;
      this.imagesLiteHeight = Math.round(e?.sizes[0]) * 2;
      this.imagesLiteWidth = Math.round(e?.sizes[0]) * 2.9;
      this.dynamicPanelSizes = [Math.round(e?.sizes[0]), Math.round(e?.sizes[1])];
      // Construct panel detail object for API request
      let panel_detail = {
        user_id: this.api.getUserId(), // Current user ID
        office_id: this.api.getOfficeId(), // Current office ID
        panal_size: this.dynamicPanelSizes, // Updated panel sizes
        type: 'listing', // Type of panel detail
      };

      this._sharedService.saveUserSplitterState(panel_detail).subscribe({
        next: () => {
          this.getSplitter(); // Refresh splitter settings
        },
      });
    }

    this.refreshCalendarSize();
  }

  copyDynamicPanelSizes;
  getSplitter() {
    /**
     * Fetches the user's preferred panel sizes for the given office and type
     * and updates the dynamic panel sizes.
     *
     * @param user_id The current user ID
     * @param office_id The current office ID
     * @param type The type of panel detail to fetch
     */
    this._sharedService.getUserSplitterStateByModuleName('listing').subscribe(res => {
      this.dynamicPanelSizes = this.copyDynamicPanelSizes = res['data']?.panal_size ? res['data']?.panal_size : [50, 50];
      this.imageHeight = this.dynamicPanelSizes[0] ? this.dynamicPanelSizes[0] * 6.3 : 250;
      this.imagesLiteHeight = this.dynamicPanelSizes[0] ? this.dynamicPanelSizes[0] * 2 : 77;
      this.imagesLiteWidth = this.dynamicPanelSizes[0] ? this.dynamicPanelSizes[0] * 2.9 : 80;
    });
  }

  getAgentModel() {
    this.is_agentModel = true;
    this.dynamicPanelSizes = [30, 70];
    this.imageHeight = 250;
    this.imagesLiteHeight = 77;
    this.imagesLiteWidth = 80;

    this.cdr.detectChanges();
    this.refreshCalendarSize();
    let id = this.property_id ? this.property_id : this.insertedPropertyId;
    this.getListingDetails(id);
  }

  /**
   * Recalculates the FullCalendar layout after its container width has changed.
   *
   * The splitter applies the new panel flex-basis during change detection, so the
   * calendar must be measured on the next frame - otherwise it keeps the previous
   * width and leaves empty space on the right.
   */
  private refreshCalendarSize() {
    requestAnimationFrame(() => this.fullcalendar?.getApi()?.updateSize());
  }

  other_agent: any[] = [];
  addOtherAgent() {
    /**
     * Adds a new other agent input field
     *
     * Checks if primary and secondary agents are selected, if so, adds a new other agent input field
     * If not, shows an error message
     */
    if (this.editProperty.controls['agent'].value && this.editProperty.controls['secondaryagent'].value) {
      // Add a new other agent input field
      this.other_agent.push({ other_agents: null });
    } else {
      // Show an error message
      this.toast.error('Please select primary & secondary agent');
    }
  }
  removeAgent(index: number) {
    this.other_agent.splice(index, 1);
  }
  onRemoveAgent() {
    if (!this.editProperty.controls['agent'].value || !this.editProperty.controls['secondaryagent'].value) {
      this.other_agent = [];
    }
  }

  dayAgo(date) {
    /**
     * Calculate the number of days ago a given date was
     * @param date The date to calculate the days ago for
     * @returns A string representing the number of days ago
     */
    const createDate = new Date(date);
    const today = new Date();
    const dayDifference = Math.abs(createDate.valueOf() - today.valueOf());

    // Calculate the number of days difference
    const daysAgo = Math.round(dayDifference / (1000 * 3600 * 24));

    // Return a string representing the number of days ago
    return daysAgo == 0 ? `Today` : `Added ${daysAgo} Days ago`;
  }

  public selectedRows = [];
  contract_id = [];
  changeContractStatus(value) {
    /**
     * Get the selected contracts and update their status
     * @param value {string} The new status of the contracts
     */
    this.contract_id = [];
    this.selectedRows.forEach(x => this.contract_id.push(x?._id));
    this._contractApiService.updateContractStatusById(this.contract_id, value).subscribe(_ => {
      /**
       * If the response is successful, show a success message and get the contracts again
       */
      this.toast.success('Contract status updated successfully');
      this.getContractAccordingProperty();
    });
  }

  all_links: any;
  getLinks(event) {
    this.all_links = event;
  }

  contact_create_ele: any;
  is_agentModel: boolean = false;
  private resizeSubscription: Subscription;
  mobToggle: boolean = false;
  mobSmallToggle: boolean = false;
  tabletToggle: boolean = false;

  ngOnInit(): void {
    // this.listingService.filter_param.keyword = '';
    this.calendarOptions();
    this.listingService.getTags();
    this.listingService.getPropertyFeatures();
    this.getAgents();
    this.getSubOffices();

    this.sds.approvalNotificationUpdatedObservable.subscribe({
      next: _ => {
        if (this.property_id || this.insertedPropertyId) {
          this.getApprovalComments();
          this.getListingPermission(this.property_id);
        }
      },
    });

    this.create_contact?.subscribe(rex => {
      if (this.contact_create_ele == 'legal') {
        this.editProperty.patchValue({
          legalname: this.editProperty.controls['legalname'].value == null ? [rex] : [...this.editProperty.controls['legalname'].value, rex],
        });
      } else if (this.contact_create_ele == 'solicitor') {
        this.editProperty.patchValue({
          solicitors: this.editProperty.controls['solicitors'].value == null ? [rex] : [...this.editProperty.controls['solicitors'].value, rex],
        });
      }
    });

    this.updated_contact?.subscribe(() => {
      this.attached_contacts = [];
      this.getAttachedContacts();
    });

    this.contactListed?.subscribe(rex => {
      if (rex == true) {
        this.getAgents();
      }
    });

    this.TaskUpdatedStatus?.subscribe(res => {
      if (res) {
        this.getTasks();
        this.message.getModuleHistory(true);
      }
    });

    this.contractList?.subscribe(rex => {
      if (rex) {
        this.getContractAccordingProperty();
      }
    });

    this.renderPropertyList?.subscribe(res => {
      if (res == true) {
        this.getPropertyById();
      }
    });

    this.leadData?.subscribe(() => {
      this.leadListRefresh.next(true);
      this.getAttachedLeads(1, 30, this.property_id);
      // The Dashboard counts the same leads, so it goes stale the moment one is added or changed.
      this.dashboardStale = true;
      if (this.activeIndex === 5) {
        this.loadListingDashboard(true);
      }
    });

    this.userPermission = Crypto.decrypt(this.localStorageService.GetItem('_per'));

    this.Auth.getUser().subscribe(user => {
      this.AuthUser = user['data'];
      this.addDefaults.Owner = this.AuthUser._id;
      this.fetchEvents();
    });

    if (
      this.lmService.listing_show_div == 'add_listing_from_property' ||
      this.lmService.listing_show_div == 'add_listing_property' ||
      this.lmService.listing_show_div == 'add_listing_property_listing'
    ) {
      if (this.lmService.listing_show_div !== 'add_listing_from_property') {
        this.editProperty.reset();
        this.selectedProperty = null;
        this.fullList = null;
        this.property_id = null;
        this.editProperty.patchValue({
          building_area_type: this.listingService.listingPropertyOption.land_building_area_type[0]['name'],
          land_area_type: this.listingService.listingPropertyOption.land_building_area_type[0]['name'],
        });
        this.getPropertyById();
        this.lmService.getProperties();
      } else {
        this.editProperty.patchValue({});
        this.getPropertyById();
        this.lmService.getProperties();
      }
    } else {
      let isCache = this.localStorageService.GetItem('isListingCache');
      let cacheIds;
      if (isCache !== null && isCache !== undefined) {
        cacheIds = Crypto.decrypt(isCache);
        cacheIds.forEach((ele, idx) => {
          if (ele === this.property_id) {
            cacheIds.splice(idx, 1);
            this.localStorageService.SetItem('isListingCache', Crypto.encrypt(cacheIds));
          }
        });
      }

      if (
        this.userPermission?.includes('listing_tab.view') &&
        this.userRole !== 'administrators' &&
        this.userRole !== 'master admin' &&
        this.userRole !== 'operations manager'
      ) {
        this.is_agentModel = true;
        let id = this.property_id ? this.property_id : this.insertedPropertyId;
        this.getListingDetails(id);
      } else {
        this.existEditProperty();
      }
    }

    this.selectedActivityType = this.contactMethods[0];
    this.aptEventTitle = this.selectedActivityType.name;
    this.selectedContactType = this.contactMethods[0];
    this.selectedInspectionType = this.inspectionMethods[0];
    this.selectedInspectType = this.inspectionMethods[0];
    let dt = new Date();
    dt.setHours(9);
    dt.setMinutes(0);
    dt.setSeconds(0);

    let dt2 = new Date();
    dt2.setHours(10);
    dt2.setMinutes(0);
    dt2.setSeconds(0);

    this.insertEvent['startdate'] = null; //new Date();
    this.insertEvent['enddate'] = null; //new Date();
    this.insertEvent['starttime'] = null; //dt;
    this.insertEvent['endtime'] = null; //dt2;

    this.insertEvent2 = { ...this.insertEvent };

    this.getStatuses();
    this.insertEvent.startdate = new Date();

    this.resizeSubscription = this.dash.screenSize$.subscribe(size => {
      this.tabletToggle = size.width < 1400;
      this.mobSmallToggle = size.width < 330;
      if (size.width < 768) {
        this.mobToggle = true;
      } else {
        this.mobToggle = false;
      }
    });
    // Dashboard heads the list and is the tab the drawer opens on.
    this.selectedItem = this.items[0];
    this.activeIndex = this.items[0]?.activeIndex;

    if (!this.mobToggle) {
      this.selectedItemHistory = this.itemsHistory[0];
      this.activeHistory = this.itemsHistory[0].activeIndexs;
      this.activeIndexs = 20;
    }
  }

  closeModal() {
    this.editProperty.patchValue({
      soldDate: null,
      soldPrice: null,
      soldPriceDisplay: true,
    });
  }

  ngAfterViewInit(): void {
    this.fetchApts(this.selectedProperty);
    this.fullcalendar?.getApi()?.render();
  }

  ngOnDestroy() {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }

  getStatuses() {
    /**
     * Get the list of statuses for the task.
     *
     * A status is a label that can be assigned to a task to indicate its current state.
     *
     * The statuses are retrieved from the server and stored in the component's `statusList` property.
     *
     * A status with name 'Closed' is identified and its ID is stored in the component's `closeStatusId` property.
     *
     * The `closeStatusId` is used to mark a task as closed.
     */
    this._taskService.getStatuses({ office_id: this.api.getOfficeId() }).subscribe(response => {
      this.statusList = response.data;
      const closeStatus = this.statusList.find(st => st.name === 'Closed');
      if (closeStatus) {
        this.closeStatusId = closeStatus._id;
      }
    });
  }

  toggleCollapse(box) {
    box.isOpen = !box.isOpen;
  }

  listingCommentUnresolved: number = 0;
  listingComments: any[] = [];
  getApprovalComments(listingId: string = this.property_id || this.insertedPropertyId) {
    /**
     * Retrieves the comments for a listing from the server.
     *
     * The comments are filtered to only include those that are unresolved.
     *
     * The number of unresolved comments is stored in the `listingCommentUnresolved` property.
     *
     * @param listingId The ID of the listing to retrieve comments for.
     */
    this._listingApprovalService.getCommentsOnListingApproval(listingId).subscribe({
      next: response => {
        const { status, data } = response;
        if (status && data !== null) {
          // Filter the comments to only include those that are unresolved.
          this.listingComments = data?.listing_comments?.filter(comment => !comment?.is_resolved) || [];
          // Count the number of unresolved comments.
          this.listingCommentUnresolved = this.listingComments.length;
        } else {
          this.listingComments = [];
        }
      },
      error: () => {
        this.listingComments = [];
      },
    });
  }

  onUpdateCallBack(value: any) {
    /**
     * This function is called when the component receives an update callback.
     *
     * It checks if the update contains listing comments and if so, it updates the local state.
     *
     * If the update does not contain listing comments, it retrieves the comments from the server.
     *
     * @param value The value of the update callback.
     */
    if (value?.listing_comments) {
      this.listingComments = value?.listing_comments || [];
      /**
       * Count the number of unresolved comments.
       */
      this.listingCommentUnresolved = this.listingComments?.filter(value => value?.is_resolved === false)?.length;
    } else {
      /**
       * Retrieve the comments from the server.
       */
      this.getApprovalComments();
      /**
       * Retrieve the listing permissions from the server.
       */
      this.getListingPermission(this.property_id);
    }
  }

  approvalHistoryList: any[] = [];
  getApprovalHistory(listingId: string = this.property_id || this.insertedPropertyId, pageNo = 1, perPage = 10, bool = false) {
    /**
     * Retrieve the approval history of a listing.
     *
     * The function receives a listing ID and pagination parameters and retrieves the approval history from the server.
     *
     * If the `bool` parameter is true, it appends the retrieved records to the existing list of approval history records.
     *
     * If the `bool` parameter is false, it sets the first page of the approval history records.
     *
     * @param listingId The ID of the listing to retrieve approval history for.
     * @param pageNo The page number of the approval history records to retrieve.
     * @param perPage The number of approval history records to retrieve per page.
     * @param bool If true, it appends the retrieved records to the existing list of approval history records.
     */
    var value = this.history_keyword?.toLowerCase();
    if (listingId) {
      this._listingApprovalService.getHistoryDetailsOnListingApproval(listingId, pageNo, perPage, value).subscribe(res => {
        let aprHistory = [];
        this.isAprHistoryLoading = true;
        this.approvalHistoryTotal = res?.meta?.pagination?.total || 0;
        if (bool) {
          this.approvalHistoryList.push(...aprHistory);
          if (aprHistory.length < 10) {
            this.isAprHistoryLoading = false;
            this.aprHistoryRows = this.approvalHistoryList.length;
          } else {
            this.aprHistoryRows += 10;
          }
        } else {
          this.aprHistoryPage = 1;
          this.approvalHistoryList = aprHistory;
        }
      });
    }
  }

  select_property_id: any;
  approval_btn_text: any;
  publish_date: any;
  domain_published_at: any;
  rea_published_at: any;
  web_published_at: any;
  market_place_published_at: any;
  trueCount: any;
  domain_failure: {
    domain_push_failure: boolean;
    rea_push_failure: boolean;
    homely_push_failure: boolean;
    web_push_failure: boolean;
    market_place_push_failure: boolean;
    real_estate_view_push_failure: boolean;
  } = {
    domain_push_failure: false,
    rea_push_failure: false,
    homely_push_failure: false,
    web_push_failure: false,
    market_place_push_failure: false,
    real_estate_view_push_failure: false,
  };

  public company_website_error_set = false;
  public domain_error_set = false;
  public rea_error_set = false;
  public homely_error_set = false;
  public market_place_error_set = false;
  public real_estate_view_error_set = false;
  public domain_dialog = false;
  legal_files: any[] = [];
  receiveLinks = null; //: Subject<any> = new Subject<any>();
  existEditProperty() {
    // this function used for patch record in the form of the listing.

    this.lmService.is_new_task = false;
    this.submitDisable = true;
    this._listingPropertiesService.getListingPropertyById(this.property_id).subscribe({
      next: res => {
        this.receiveLinks = {
          video: res?.data?.video_url,
          tour1: res?.data?.online_tour1,
          tour2: res?.data?.online_tour2,
        };
        this.lmService.isPortal === true ? (this.activeIndex = 6) : this.activeIndex ? (this.activeIndex = this.activeIndex) : (this.activeIndex = 0);
        this.selectedProperty = res['data'];
        this.imageDisplayPath = res['data']?.property_images[0]?.thumbPath;
        this.commission_applied = res['data']?.commission_applied ? res['data']?.commission_applied : null;

        this.isPercentage = res?.data?.isPercentage;

        this.commission_rate = res['data']?.commission_rate ? res['data']?.commission_rate : null;
        this.commission_amount = res['data']?.commission_amount ? res['data']?.commission_amount : null;
        this.tiered_commission = res['data']?.tiered_commission ? res['data']?.tiered_commission : [];
        this.specific_commission = res['data']?.specific_commission ? res['data']?.specific_commission : [];
        this.other_agent = res['data']?.other_agents ? res['data']?.other_agents : [];
        this.company_website_error_set = res['data']?.company_website_error_set ? true : false;
        this.domain_error_set = res['data']?.domain_error_set ? true : false;
        this.rea_error_set = res['data']?.rea_error_set ? true : false;
        this.homely_error_set = res['data']?.homely_error_set ? true : false;
        this.real_estate_view_error_set = res['data']?.real_estate_view_error_set ? true : false;
        this.market_place_error_set = res['data']?.market_place_error_set ? true : false;
        this.legal_files = res['data']?.legal_files?.length > 0 ? res['data']?.legal_files : [];
        this.conjunctionDetails = res['data']?.conjunction_details ? res['data']?.conjunction_details : null;
        this.saleCommission = res['data']?.sale_commission ? res['data']?.sale_commission : null;
        this.editProperty.patchValue(res['data']);
        // The type arrives with the listing rather than through the picker's own change event, so
        // an already-Residential listing has to pull its lots here or the saved lot has no option
        // to match and the dropdown reads "No items found".
        this.loadResidentialLots();
        this.loadSavedListingProject();
        // The drawer opens on Dashboard, so its read starts as soon as the listing is known.
        this.loadListingDashboard(true);
        this.applyDefaultSubOffice();
        this.editProperty.patchValue({
          date: res['data']?.date ? new Date(res['data']?.date) : null,
          startTime: res['data']?.startTime ? new Date(res['data']?.startTime) : null,
          settledDate: res['data']?.settledDate ? new Date(res['data']?.settledDate) : null,
          selling_agreement_start_date: res['data']?.selling_agreement_start_date ? new Date(res['data']?.selling_agreement_start_date) : null,
          selling_agreement_end_date: res['data']?.selling_agreement_end_date ? new Date(res['data']?.selling_agreement_end_date) : null,
          soldDate: res['data']?.soldDate ? new Date(res['data']?.soldDate) : null,
          availableDate: res['data']?.availableDate ? new Date(res['data']?.availableDate) : null,
          existingproperty: res['data']?.Selected_property_Id,
          land_area_type: res['data']?.land_area_type?.['name'] ? res['data']?.land_area_type?.['name'] : res['data']?.land_area_type,
          building_area_type: res['data']?.building_area_type?.['name'] ? res['data']?.building_area_type?.['name'] : res['data']?.building_area_type,
        });
        this.applyDomainLandTypeDefault();
        if (res['data']?.startTime) {
          this.selectedAuctionStartHour = String(moment(res['data']?.startTime).format('h'));
          this.selectedAuctionStartMinutes = String(moment(res['data']?.startTime).format('mm'));
          this.selectedAuctionStartDuration = moment(res['data']?.startTime).format('A');
        }
        if (res['data']?.hasOwnProperty('property_status')) {
          this.propertyStatus({ tag_name: res['data']?.property_status });
        }
        let address = '';
        if (this.selectedProperty?.unit_no && this.selectedProperty?.street_no) {
          address = this.selectedProperty?.unit_no + '/' + this.selectedProperty?.street_no;
        } else {
          address = this.selectedProperty?.unit_no ? this.selectedProperty?.unit_no : '';
          address = this.selectedProperty?.street_no ? this.selectedProperty?.street_no : '';
        }
        address += address.length > 0 ? ' ' : '';
        address += this.selectedProperty?.street_name
          ? this.selectedProperty?.street_name +
            ', ' +
            this.selectedProperty?.suburb?.suburb +
            ', ' +
            this.selectedProperty?.state +
            ' ' +
            this.selectedProperty?.post_code
          : '';
        address = address.length > 0 ? address : this.selectedProperty?.property_address;
        this.selectedProperty.property_address = address;
        this.editProperty.patchValue({
          property_address: address,
        });
        this.getSplitter();
        this.checkProcessRunning(this.property_id);
        this.domain_published_at = res['data']?.domain_published_at;
        this.rea_published_at = res['data']?.rea_published_at;
        this.web_published_at = res['data']?.web_published_at;
        this.market_place_published_at = res['data']?.market_place_published_at;
        this.domain_failure = {
          ...this.domain_failure,
          domain_push_failure: res['data']?.domain_push_failure,
          rea_push_failure: res['data']?.rea_push_failure,
          homely_push_failure: res['data']?.homely_push_failure,
          web_push_failure: res['data']?.web_push_failure,
          market_place_push_failure: res['data']?.market_place_push_failure,
          real_estate_view_push_failure: res['data']?.real_estate_view_push_failure,
        }; //= res["data"];
        const propertiesToCheck = ['isWpPush', 'isDomainCrm', 'isReaCrm', 'homley_portal', 'market_place', 'real_estate_view'];
        this.trueCount = propertiesToCheck.reduce((count, property) => {
          if (this.selectedProperty[property] === true) {
            return count + 1;
          }
          return count;
        }, 0);
        let today = new Date();
        let publishDate = res['data']?.publish_date ? new Date(res['data']?.publish_date) : null;
        if (today <= publishDate) {
          const date = new Date(publishDate);
          this.publish_date = 'Activate on ' + date.toLocaleDateString();
        } else {
          if (publishDate) {
            const date = new Date(publishDate);
            if (this.trueCount) {
              this.publish_date = 'Activated on: ' + date.toLocaleDateString();
            } else {
              this.publish_date = 'Activate listing';
            }
          }
        }
        if (this.AuthUser?._id === res['data']?.agent || this.AuthUser?._id === res['data']?.secondaryagent) {
          this.approval_btn_text = 'Approve';
        } else if (this.listingComments?.length > 0) {
          if (!this.listingComments?.every(x => x?.is_resolved == true)) {
            this.approval_btn_text = 'Changes Requested';
          } else if (res['data']?.is_approved === true) {
            this.approval_btn_text = 'Approved';
          } else if (res['data']?.is_approved === false) {
            this.approval_btn_text = 'Approval Pending';
          }
        } else if (res['data']?.is_approved === true) {
          this.approval_btn_text = 'Approved';
        } else if (res['data']?.is_approved === false) {
          this.approval_btn_text = 'Approval Pending';
        } else {
          this.approval_btn_text = 'Send Approval';
        }
        this.getAttachedContacts();

        this.lmService.isPortal = false;
        this.select_property_id = res?.data?.Selected_property_Id;
        this.insertEvent.location = res?.data?.property_address;
        this.submitDisable = false;
        this.loadAdmin = true;
      },
      error: error => {
        this.submitDisable = false;
        this.toast.error(error?.error?.message);
        let tab = this.lmService.tab_levels.find(el => el.name.includes('Listing'));
        if (tab) {
          let ind = this.lmService.tab_levels.indexOf(tab);
          this.isPropertyClose.emit({ level: tab, index: ind });
        }
        this.editProperty.reset();
      },
    });
  }

  listingDetails: any = null;
  shortDetails: any;
  shortDes: boolean = true;
  longDes: boolean = false;
  isLongDescription: boolean = false;
  displayedImages = [];
  currentIndex: number = 0;
  imagesPath: any;

  getListingDetails(id) {
    // this function used for get details of the listing for agent view;
    this.listingDetails = [];
    this.imagesPath = null;
    this._listingPropertiesService.getListingPropertyDetailById(id).subscribe({
      next: response => {
        if (response.status) {
          this.listingDetails = response?.data;
          this.displayedImages = this.listingDetails?.property_images;
          this.listingDetails.land_area_type = response['data']?.land_area_type?.['name']
            ? response['data']?.land_area_type?.['name']
            : response['data']?.land_area_type;
          this.listingDetails.building_area_type = response['data']?.building_area_type?.['name']
            ? response['data']?.building_area_type?.['name']
            : response['data']?.building_area_type;
          this.shortDetails = this.listingDetails?.description_garax?.slice(0, 388);
          this.isLongDescription = this.listingDetails?.description_garax?.length > 388;
          let today = moment();
          const example = this.listingDetails?.appointments_and_inspections.filter(x => {
            const eventDate = moment(toWallClock(x?.event?.start?.dateTime));
            const eventEndDateTime = moment(toWallClock(x?.event?.end?.dateTime));
            const isFutureDate = eventDate.isAfter(today, 'day');
            const isSameDate = eventDate.isSame(today, 'day') && eventEndDateTime.isAfter(today);
            return isSameDate || isFutureDate;
          });
          this.listingDetails.appointments_and_inspections = [...example];
        } else {
          this.toast.error(response?.message);
          let tab = this.lmService.tab_levels.find(el => el.name.includes('Listing'));
          if (tab) {
            let ind = this.lmService.tab_levels.indexOf(tab);
            this.isPropertyClose.emit({ level: tab, index: ind });
          }
          this.editProperty.reset();
        }
        this.updateVisibleImages();
      },
    });
  }

  getImagePath(item) {
    this.imagesPath = null;
    this.imagesPath = item?.popupPath ? item?.popupPath : item?.thumbPath;
  }

  getImageByPath(item) {
    return item?.popupPath ? this.S3Path + item?.popupPath : this.S3Path + item?.thumbPath;
  }
  getSliderImageByPath(item) {
    return item?.popupPath ? this.S3Path + item?.popupPath : this.S3Path + item?.thumbPath;
  }
  goToNext() {
    this.currentIndex = (this.currentIndex + 1 + this.listingDetails?.property_images?.length) % this.listingDetails?.property_images?.length;
    this.updateVisibleImages();
  }
  goToPrevious() {
    this.currentIndex = (this.currentIndex - 1 + this.listingDetails?.property_images?.length) % this.listingDetails?.property_images?.length;
    this.updateVisibleImages();
  }
  updateVisibleImages() {
    const totalImages = this.listingDetails?.property_images.length || 0;
    const endIndex = this.currentIndex + 5;
    const imgPath = this.listingDetails?.property_images[this.currentIndex];
    this.imagesPath = imgPath?.popupPath || imgPath?.thumbPath;
    if (endIndex <= totalImages) {
      this.displayedImages = this.listingDetails?.property_images.slice(this.currentIndex, endIndex);
    } else {
      this.displayedImages = [
        ...this.listingDetails?.property_images.slice(this.currentIndex, totalImages),
        ...this.listingDetails?.property_images.slice(0, endIndex - totalImages),
      ];
    }
    this.cdr.detectChanges();
  }

  no_process_run: boolean = false;
  checkProcessRunning(id) {
    // Check if any process is running for the given property
    this._workflowService.GetAllProcessesByModule(id, 'Properties', 1, 10, '', 'progress').subscribe(response => {
      // If no process is running, set the flag
      this.no_process_run = !response?.data?.length ? true : false;
    });
  }

  readWritePermissions: { can_delete: boolean; can_write: boolean; can_approve: boolean; can_resolve: boolean } = {
    can_approve: false,
    can_delete: false,
    can_resolve: false,
    can_write: false,
  };

  solicitor_contact: any[] = [];
  solicitorContact(eve = null) {
    let ids = eve?.map(x => x?._id);
    this.editProperty.patchValue({
      solicitors: ids,
    });
    /**
     * Fetches the solicitor contact details from the database.
     * This function is called when the solicitor field is updated.
     * @param {string} companyId - The company ID of the solicitor.
     * @returns {void}
     */
    if (this.editProperty.controls['solicitors'].value) {
      this._staffContactService.getAssociatedContactListByCompanyId(this.editProperty.controls['solicitors'].value).subscribe(response => {
        /**
         * The solicitor contact array is cleared and updated with the new contact details.
         * @type {any[]}
         */
        this.solicitor_contact = [];
        this.solicitor_contact = response?.data;
      });
    }
  }

  getListingPermission(listingId: string = this.property_id || this.insertedPropertyId) {
    /**
     * Fetches and processes listing approval permissions for a specific listing.
     * @param {string} listingId - The ID of the listing to check permissions for.
     */
    this._listingApprovalService.getAllowedPermissionListOnListingApproval(listingId).subscribe(res => {
      // Retrieve team IDs from local storage
      let teamId = Crypto.decrypt(this.localStorageService.GetItem('teams_id'));

      // Check if the user has approval permissions
      let resultPermissionApproval = res['data']?.listing_approval_detail?.some(
        element =>
          (element?.included?.toString()?.includes(this.api.getUserId()) && element?.permission?.toString()?.includes('approval')) ||
          (element?.included?.toString()?.includes(this.api.getRoleId()) && element?.permission?.toString()?.includes('approval')) ||
          (element?.included?.some(ele => teamId?.toString()?.includes(ele)) && element?.permission?.toString()?.includes('approval'))
      );

      // Check if the user has resolve permissions
      let resultPermissionResolve = res['data']?.listing_approval_detail?.some(
        element =>
          (element?.included?.toString()?.includes(this.api.getUserId()) && element?.permission?.toString()?.includes('resolve_comments')) ||
          (element?.included?.toString()?.includes(this.api.getRoleId()) && element?.permission?.toString()?.includes('resolve_comments')) ||
          (element?.included?.some(ele => teamId?.toString()?.includes(ele)) && element?.permission?.toString()?.includes('resolve_comments'))
      );

      // Check if the user has delete permissions
      let resultPermissionDelete = res['data']?.listing_approval_detail?.some(
        element =>
          (element?.included?.toString()?.includes(this.api.getUserId()) && element?.permission?.toString()?.includes('delete_comments')) ||
          (element?.included?.toString()?.includes(this.api.getRoleId()) && element?.permission?.toString()?.includes('delete_comments')) ||
          (element?.included?.some(ele => teamId?.toString()?.includes(ele)) && element?.permission?.toString()?.includes('delete_comments'))
      );

      // Check if the user has write permissions
      let resultPermissionWrite = res['data']?.listing_approval_detail?.some(
        element =>
          (element?.included?.toString()?.includes(this.api.getUserId()) && element?.permission?.toString()?.includes('edit_comment')) ||
          (element?.included?.toString()?.includes(this.api.getRoleId()) && element?.permission?.toString()?.includes('edit_comment')) ||
          (element?.included?.some(ele => teamId?.toString()?.includes(ele)) && element?.permission?.toString()?.includes('edit_comment'))
      );

      // Check if the user is one of the listing agents
      let resultAgent = res?.listing_agents?.toString()?.includes(this.api.getUserId());

      // Determine overall permissions based on roles and specific permissions
      let isApproved =
        resultPermissionApproval ||
        resultAgent ||
        this.userRole === 'administrators' ||
        this.userRole === 'master admin' ||
        this.userRole === 'operations manager'
          ? true
          : false;
      let isDeleted =
        resultPermissionDelete ||
        resultAgent ||
        this.userRole === 'administrators' ||
        this.userRole === 'master admin' ||
        this.userRole === 'operations manager'
          ? true
          : false;
      let isResolved =
        resultPermissionResolve ||
        resultAgent ||
        this.userRole === 'administrators' ||
        this.userRole === 'master admin' ||
        this.userRole === 'operations manager'
          ? true
          : false;
      let isWritable =
        resultPermissionWrite ||
        resultAgent ||
        this.userRole === 'administrators' ||
        this.userRole === 'master admin' ||
        this.userRole === 'operations manager'
          ? true
          : false;

      // Update permissions object
      this.readWritePermissions = {
        ...this.readWritePermissions,
        can_approve: isApproved,
        can_delete: isDeleted,
        can_resolve: isResolved,
        can_write: isWritable,
      };
    });
  }

  contract_list: any[] = [];
  contract_list_copy: any[] = [];
  pendingContract: any[] = [];
  activeContract: any[] = [];
  getContractAccordingProperty() {
    /**
     * Fetches and processes contract data for the current property or inserted property.
     */
    let id = this.property_id ? this.property_id : this.insertedPropertyId;

    if (id) {
      this._contractApiService.getContractByPropertyId(id).subscribe({
        next: res => {
          // Update attached contacts
          this.getAttachedContacts();

          // Sort contracts by offer status
          this.contract_list = res.data?.sort((a, b) => (a?.offer_status > b?.offer_status ? 1 : -1));

          // Filter contracts to determine pending and active contracts
          this.pendingContract = res.data?.filter(x => x.offer_status !== 'Declined');
          this.activeContract = this.pendingContract.filter(x => x.offer_status === 'Accepted');

          // If there are active contracts, update the sold date and price
          if (this.activeContract?.length > 0) {
            this.editProperty.patchValue({
              soldDate: this.activeContract[0]?.contractDate ? new Date(this.activeContract[0]?.contractDate) : null,
              soldPrice: this.activeContract[0]?.contractPrice,
            });
          }

          // Store a copy of the contract list
          this.contract_list_copy = this.contract_list;

          // Update contract status based on selected property or first contract in list
          if (this.selectedProperty.contract_status) {
            this.editProperty.patchValue({
              contract_status: this.selectedProperty.contract_status,
            });
          } else {
            this.editProperty.patchValue({
              contract_status: res.data[0]?.contractStatus,
            });
          }
        },
        error: error => {
          // Display error message in case of API failure
          this.toast.error(error?.message);
        },
      });
      // Initialize selected rows
      this.selectedRows = [];
    }
  }

  domain_email: any;
  getDomainEmail() {
    /**
     * Retrieves the default domain portal email for the current office
     * and updates the `otherEmail` field in the edit property form.
     * @param {string} mail - The email address to use if available.
     */
    this._sharedService.getOfficeDomainEmail().subscribe({
      next: res => {
        // Update the email field in the form with the default domain email
        this.domain_email = res?.data?.email;
        this.editProperty.patchValue({
          otherEmail: this.domain_email ? this.domain_email : null,
        });
      },
      error: () => {
        // Display an error message if the API call fails
        this.toast.error('Something went wrong');
      },
    });
  }

  filterContract(event) {
    this.contract_list = this.contract_list_copy;
    if (!event?.tag_name) {
      this.contract_list = this.contract_list_copy;
    } else {
      this.contract_list = this.contract_list.filter(x => x?.offer_status === event?.tag_name);
    }
  }
  deleteContract(id, _event: Event) {
    /**
     * Deletes a contract from a listing.
     *
     * This function is called when the user clicks the delete button
     * on a contract in the contract table.
     *
     * It shows a confirmation dialog to the user and if the user
     * confirms, it sends a DELETE request to the API to delete the
     * contract.
     *
     * @param id The ID of the contract to delete.
     * @param event The event object of the delete button click.
     */
    this.remmiConfirm.delete({ title: 'Delete Contract?', message: 'This contract will be removed from this listing.' }).subscribe(isConfirmed => {
      if (!isConfirmed) return;
      /**
       * Sends a DELETE request to the API to delete the contract.
       *
       * The API call is made to the /contracts/{id} endpoint.
       *
       * After the API call is made, it shows a success message to the user.
       *
       * It also calls the getContractAccordingProperty() function to
       * update the contract table.
       */
      this._contractApiService.deleteContract(id).subscribe(res => {
        this.toast.success(res.message);
        this.getContractAccordingProperty();
      });
    });
  }

  public sendRemainder = null;
  reminder_options = ['Every 3 hours', 'Every 6 hours', 'Every 12 hours', 'Every Day', 'Every Week', 'Every Other Day'];
  public remainder = null;
  sendApproval() {
    /**
     * Sends a listing approval request to the API.
     *
     * The approval request includes the listing ID, the approval status,
     * and the user ID of the user who sent the request.
     *
     * It also sends a reminder to the user if the reminder option is selected.
     *
     * The API call is made to the /listing-approval endpoint.
     *
     * After the API call is made, it shows a success message to the user.
     *
     * It also calls the existEditProperty() function to update the property details.
     */
    let approval_param = {
      listing_id: this.property_id ? this.property_id : this.insertedPropertyId,
      is_approved: this.approval_btn_text == 'Approve' ? true : false,
      send_remainder: this.remainder,
      approval_request_by: this.api.getUserId(),
    };
    this.loading = true;
    this._listingApprovalService.up_dateListingApprovalStatus(approval_param).subscribe({
      next: () => {
        /**
         * Shows a success message to the user after the API call is made.
         *
         * It also resets the reminder option and sends a remainder to the user if the reminder option is selected.
         */
        this.toast.success('Approval send successfully');
        this.remainder = null;
        this.sendRemainder = null;
        this.existEditProperty();
      },
      complete: () => {
        /**
         * Sets the loading flag to false after the API call is completed.
         */
        this.loading = false;
      },
    });
  }

  // Commission

  commission_list: any[] = [];
  getAgentListingCommission() {
    /**
     * Gets the commission for a specific agent and listing.
     *
     * It makes a GET request to the API to retrieve the commission
     * for the agent and listing.
     *
     * The API call is made to the /get-agent-listings-commission endpoint.
     *
     * The response is stored in the commission_list variable.
     */
    this._commissionService.getCommissionListByAgentId(this.editProperty.controls['agent'].value).subscribe(res => {
      /**
       * Filters the commission list to only include the current listing.
       */
      this.commission_list = res?.data?.filter(ele => ele?._id == this.property_id);
    });
  }
  valueCopy(paramVal) {
    /**
     * Returns a formatted string with a dollar sign and commas.
     *
     * If the paramVal includes a decimal point, it splits the string into two parts
     * and formats the first part with commas and the second part as is.
     *
     * If the paramVal does not include a decimal point, it simply formats the string with commas.
     *
     * @param paramVal The value to be formatted.
     * @returns A formatted string with a dollar sign and commas.
     */
    if (paramVal) {
      if (paramVal?.toString()?.includes('.')) {
        // Split the string into two parts using the decimal point
        let parts = paramVal
          ?.toString()
          ?.replace(/[^\d.]/g, '')
          ?.split('.');
        if (parts?.length > 1) {
          // Format the first part with commas
          let comma = parts[0]?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          // Return the formatted string with a dollar sign and commas
          return '$' + comma + '.' + parts[1];
        }
      } else {
        // Format the string with commas
        let comma = paramVal?.toString()?.replace(/[^\d.]/g, '');
        return '$' + comma;
      }
    }
  }

  tiered_commission = [];
  specific_commission = [];
  commission_category = [
    { name: 'Listing', value: 'listing' },
    { name: 'Project', value: 'project' },
  ];
  overRide() {
    /**
     * Based on the value of the commission_applied select box,
     * calls either the getOfficeCommission() or getAgentCommission() functions.
     *
     * If the value of the commission_applied select box is 'default_commission', then
     * the getOfficeCommission() function is called.
     *
     * If the value of the commission_applied select box is not 'default_commission', then
     * the getAgentCommission() function is called.
     */
    let dollar_val = this.commission_applied;
    if (dollar_val == 'default_commission') {
      this.getOfficeCommission();
    } else {
      this.getAgentCommission();
    }
  }

  getAgentCommission() {
    /**
     * Fetches the agent commissions based on the agent selected in the form.
     * If the agent has a commission rate and/or amount, it updates the form with the agent's commission values.
     * If the agent has tiered commissions, it updates the form with the agent's tiered commissions.
     * If the agent has specific commissions, it updates the form with the agent's specific commissions.
     */
    this._commissionService.getCommissionListByAgentId(this.editProperty.controls['agent'].value).subscribe(res => {
      // Update the form with the agent's commission rate and/or amount
      this.commission_rate = res['data']?.commission_rate ? res['data']?.commission_rate : null;
      this.commission_amount = res['data']?.commission_amount ? res['data']?.commission_amount : null;

      // Update the form with whether the agent's commission is a percentage or a fixed amount
      this.isPercentage = res?.data?.isPercentage;

      // Update the form with the agent's tiered commissions
      this.tiered_commission = res['data']?.tiered_commission?.length > 0 ? res['data']?.tiered_commission : [];

      // Update the form with the agent's specific commissions
      let specific_user = [];
      if (res['data']?.specific_user_commission?.length > 0) {
        specific_user = res['data']?.specific_user_commission?.filter(ele => ele?.user_commission == this.editProperty.controls['agent'].value);
      }
      this.specific_commission = specific_user;
    });
  }

  getOfficeCommission() {
    /**
     * Fetches the office commissions based on the current office ID.
     * Updates the form with the office's commission rate, amount, tiered commissions,
     * and specific user commissions.
     */
    this._commissionService.getCommissionListByOfficeId().subscribe(res => {
      // Update the form with the office's commission rate and/or amount
      this.commission_rate = res['data']?.commission_rate ? res['data']?.commission_rate : null;
      this.commission_amount = res['data']?.commission_amount ? res['data']?.commission_amount : null;

      // Update the form with whether the office's commission is a percentage or a fixed amount
      this.isPercentage = res?.data?.isPercentage;

      // Update the form with the office's tiered commissions
      this.tiered_commission = res['data']?.tiered_commission ? res['data']?.tiered_commission : [];

      // Update the form with the office's specific user commissions
      let specific_user = [];
      if (res['data']?.specific_user_commission?.length > 0) {
        specific_user = res['data']?.specific_user_commission?.filter(ele => ele?.user_commission == this.editProperty.controls['agent'].value);
      }
      this.specific_commission = specific_user;
    });
  }

  updatePrice(value, param: string, index = 0) {
    console.log('value >>:', value, 'Param >>:', param);
    if (param == 'value') {
      this.editProperty.patchValue({
        value: value,
      });
    } else if (param == 'rentalPerWeek') {
      this.editProperty.patchValue({
        rentalPerWeek: value,
      });
    } else if (param == 'securityBond') {
      this.editProperty.patchValue({
        securityBond: value,
      });
    } else if (param == 'agreed_marketing_spend') {
      this.editProperty.patchValue({
        agreed_marketing_spend: value,
      });
    } else if (param == 'percentage_inclusive_of_gst') {
      this.editProperty.patchValue({
        percentage_inclusive_of_gst: value,
      });
    } else if (param == 'amount_inclusive_of_gst') {
      this.editProperty.patchValue({
        amount_inclusive_of_gst: value,
      });
    } else if (param == 'commission_amount') {
      this.commission_amount = value;
    } else if (param == 'tiered_commission_amount') {
      this.tiered_commission[index].commission_amount = value;
    } else if (param == 'specific_commission_amount') {
      this.specific_commission[index].commission_amount = value;
    }
  }

  insertedPropertyId: any;
  CreateProperty(onlyUpdateOrCreate) {
    // this function is used for create listing
    this.syncResidentialLotProject();
    this.submitted = true;
    let primary = this.editProperty.controls['agent'].value;
    let secondary = this.editProperty.controls['secondaryagent'].value;
    if (
      (primary && secondary && primary === secondary) ||
      this.other_agent?.some(el => el?.other_agents === primary || el?.other_agents === secondary)
    ) {
      this.toast.error('Duplicate agent selected');
    } else {
      if (!this.insertedPropertyId) {
        this.submitDisable = true;
        this.editProperty.patchValue({
          office_id: this.api.getOfficeId(),
        });
        if (!this.editProperty.valid) {
          let fields: any = Object.entries(this.editProperty.controls)
            .reduce((acc, [key, value]) => {
              if (value.status === 'INVALID') {
                console.log('key', key);
                acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
              }
              return acc;
            }, [])
            ?.filter(error_field => error_field !== undefined && error_field !== null);
          fields && this.validateFieldsOnRequest(fields);
          this.submitDisable = false;
          this.toast.error('Required fields must be filled in');
          return;
        } else {
          let form_data = this.editProperty.value;
          form_data['associate_property'] = false;
          if (this.lmService.is_new_listing == true) {
            let propertyId = this.editProperty.value['existingproperty'];
            form_data['Selected_property_Id'] = propertyId;
            delete this.editProperty.value['existingproperty'];
          } else {
            form_data['Selected_property_Id'] = this.prop_id ? this.prop_id : this.property_id;
          }

          this.isImg = false;
          let desc = this.editProperty.controls['description_garax'].value;
          form_data['description_garax'] = desc?.replace(/•/g, '-');
          form_data['commission_applied'] = this.commission_applied;
          form_data['isPercentage'] = this.isPercentage;
          form_data['commission_rate'] = this.commission_rate;
          form_data['commission_amount'] = this.commission_amount;
          form_data['tiered_commission'] = this.tiered_commission;
          form_data['specific_commission'] = this.specific_commission;
          form_data['sale_commission'] = this.saleCommission;
          form_data['conjunction_details'] = this.conjunctionDetails;
          form_data['other_agents'] = this.other_agent;
          this._listingPropertiesService.addListingProperty(form_data).subscribe({
            next: res => {
              this.isImage = false;
              this.isAgent = false;
              this.isPrice = false;
              this.isConfig = false;
              this.isFeature = false;
              this.previousListingDetail = null;
              this._workflowService.isWorkflowProcessTabOpened == true && this.GetListingWorkflowProcesses();
              this.toast.success('Listing added successfully');
              if (res.reaResponse == null) {
                this.toast.error('Something went wrong pushing to REA');
              } else if (res.reaResponse == 'push successfull') {
                this.toast.success('Property pushed to REA successfully');
              }
              this.isSaved.emit(true);
              this.insertedPropertyId = res?.insertedId;
              this.property_id = this.insertedPropertyId;
              this.isImg = true;
              this.existEditProperty();
              if (onlyUpdateOrCreate !== 'onlyCreate') {
                let tab = this.lmService.tab_levels.find(el => el.name.includes('Listing'));
                if (tab) {
                  let ind = this.lmService.tab_levels.indexOf(tab);
                  this.isPropertyClose.emit({ level: tab, index: ind });
                }
                this.editProperty.reset();
              }
              this.submitDisable = false;
              this.submitted = false;
              this.message.getModuleHistory(true);
              let id = this.api.getOfficeId();
              this.editProperty.patchValue({
                office_id: id,
              });
              this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
            },
            error: error => {
              this._workflowService.isWorkflowProcessTabOpened == true && this.GetListingWorkflowProcesses();
              let { fields, all_fields } = error;
              this.submitDisable = false;
              this.submitted = true;
              this.isImg = true;
              if (fields?.length > 0) {
                this.formAllFields = fields = fields
                  ?.map(error_field => {
                    let isExistsField = all_fields?.find(field => field.name === error_field);
                    if (isExistsField) {
                      error_field = { name: error_field, label: isExistsField?.label || '' };
                    }
                    return error_field;
                  })
                  ?.filter(error_field => error_field !== undefined && error_field !== null);
                this.toast.error('Required fields must be filled in');
                this.validateFieldsOnRequest(fields);
              } else {
                let message = error?.error?.message ? error?.error?.message : error?.message;
                this.toast.error(message);
              }
            },
          });
        }
      } else {
        this.submitDisable = true;
        delete this.editProperty.value['office_id'];

        if (!this.editProperty.valid) {
          this.submitDisable = false;
          return;
        } else {
          let form_data = this.editProperty.value;
          form_data['Selected_property_Id'] = this.prop_id;
          form_data['video_url'] = this.all_links?.video;
          form_data['online_tour1'] = this.all_links?.tour1;
          form_data['online_tour2'] = this.all_links?.tour2;
          form_data['other_agents'] = this.other_agent;
          form_data['commission_applied'] = this.commission_applied;
          form_data['isPercentage'] = this.isPercentage;
          form_data['commission_rate'] = this.commission_rate;
          form_data['commission_amount'] = this.commission_amount;
          form_data['tiered_commission'] = this.tiered_commission;
          form_data['specific_commission'] = this.specific_commission;
          form_data['sale_commission'] = this.saleCommission;
          form_data['conjunction_details'] = this.conjunctionDetails;
          this.isImg = false;
          this._listingPropertiesService.up_dateListingProperty(this.insertedPropertyId, form_data).subscribe({
            next: res => {
              this.toast.success('Listing updated successfully');
              if (res.reaResponse == null) {
                this.toast.error('Something went wrong pushing to REA');
              } else if (res.reaResponse == 'push successfull') {
                this.toast.success('Property pushed to REA successfully');
              }
              if (res.domainResponse == null) {
                this.toast.error('Something went wrong pushing to Domain');
              } else if (res.domainResponse == 'push successfull') {
                this.toast.success('Property pushed to Domain successfully');
              }
              this.isSaved.emit(true);
              this.existEditProperty();
              let id = this.api.getOfficeId();
              this.editProperty.patchValue({
                office_id: id,
              });
              if (onlyUpdateOrCreate !== 'onlyCreate') {
                let tab = this.lmService.tab_levels.find(el => el.name.includes('Listing'));
                if (tab) {
                  let ind = this.lmService.tab_levels.indexOf(tab);
                  this.isPropertyClose.emit({ level: tab, index: ind });
                }
                this.editProperty.reset();
              }
              this.submitDisable = false;
              this.submitted = false;
              this.isImg = true;
              this.message.getModuleHistory(true);
              this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
              // this.selectedProperty = null;
            },
            error: error => {
              let { fields, all_fields } = error;
              if (fields?.length > 0) {
                this.formAllFields = fields = fields
                  ?.map(error_field => {
                    let isExistsField = all_fields?.find(field => field.name === error_field);
                    if (isExistsField) {
                      error_field = { name: error_field, label: isExistsField?.label || '' };
                    }
                    return error_field;
                  })
                  ?.filter(error_field => error_field !== undefined && error_field !== null);
                this.toast.error('Required fields must be filled in');
                this.validateFieldsOnRequest(fields);
              } else {
                this.toast.error(error.error['message']);
              }
              this.submitDisable = false;
              this.submitted = true;
            },
          });
        }
      }
    }
  }

  saveProperty(onlyUpdateOrCreate) {
    // this function is used for create Property
    this.submitDisable = true;
    this.submitted = true;
    delete this.editProperty.value['office_id'];

    if (!this.editProperty.valid) {
      this.submitDisable = false;
      let fields: any = Object.entries(this.editProperty.controls)
        .reduce((acc, [key, value]) => {
          if (value.status === 'INVALID') {
            acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
          }
          return acc;
        }, [])
        ?.filter(error_field => error_field !== undefined && error_field !== null);
      fields && this.validateFieldsOnRequest(fields);
      this.toast.error('Required fields must be filled in');
      return;
    } else {
      let form_data = this.editProperty.value;
      form_data['Selected_property_Id'] = this.select_property_id;
      form_data['video_url'] = this.all_links?.video;
      form_data['online_tour1'] = this.all_links?.tour1;
      form_data['online_tour2'] = this.all_links?.tour2;

      let desc = this.editProperty.controls['description_garax'].value;
      form_data['description_garax'] = desc?.replace(/•/g, '-');
      form_data['commission_applied'] = this.commission_applied;
      form_data['isPercentage'] = this.isPercentage;
      form_data['commission_rate'] = this.commission_rate;
      form_data['commission_amount'] = this.commission_amount;
      form_data['tiered_commission'] = this.tiered_commission;
      form_data['specific_commission'] = this.specific_commission;
      form_data['rea_error_set'] = this.rea_error_set;
      form_data['domain_error_set'] = this.domain_error_set;
      form_data['company_website_error_set'] = this.company_website_error_set;
      form_data['market_place_error_set'] = this.market_place_error_set;
      form_data['homely_error_set'] = this.homely_error_set;
      form_data['sale_commission'] = this.saleCommission;
      form_data['conjunction_details'] = this.conjunctionDetails;
      form_data['real_estate_view_error_set'] = this.real_estate_view_error_set;
      this._listingPropertiesService.up_dateListingProperty(this.selectedProperty._id, form_data).subscribe({
        next: res => {
          this.isSaved.emit(true);
          this._workflowService.isWorkflowProcessTabOpened == true && this.GetListingWorkflowProcesses();
          this.toast.success('Listing updated successfully');
          if (res.reaResponse == null) {
            this.toast.error('Something went wrong pushing to REA');
          } else if (res.reaResponse == 'push successfull') {
            this.toast.success('Property pushed to REA successfully');
          }
          if (res.domainResponse == null) {
            this.toast.error('Something went wrong pushing to Domain');
          } else if (res.domainResponse == 'push successfull') {
            this.toast.success('Property pushed to Domain successfully');
          }
          let id = this.api.getOfficeId();
          this.editProperty.patchValue({
            office_id: id,
          });
          this.existEditProperty();
          if (onlyUpdateOrCreate !== 'onlyUpdate') {
            let tab = this.lmService.tab_levels.find(el => el.name.includes('Listing'));
            if (tab) {
              let ind = this.lmService.tab_levels.indexOf(tab);
              this.isPropertyClose.emit({ level: tab, index: ind });
            }
            // this.lmService.contact_showRightBar = false;
            this.editProperty.reset();
          }
          this.submitDisable = false;
          this.submitted = false;
          this.message.getModuleHistory(true);
          this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
          //this.selectedProperty = null;
        },
        error: error => {
          this._workflowService.isWorkflowProcessTabOpened == true && this.GetListingWorkflowProcesses();
          let { fields, all_fields } = error?.error;
          if (fields?.length > 0) {
            console.log('fields', fields);
            this.formAllFields = fields = fields
              ?.map(error_field => {
                let isExistsField = all_fields?.find(field => field.name === error_field);
                if (isExistsField) {
                  error_field = { name: error_field, label: isExistsField?.label || '' };
                }
                return error_field;
              })
              ?.filter(error_field => error_field !== undefined && error_field !== null);
            this.toast.error('Required fields must be filled in');
            this.validateFieldsOnRequest(fields);
          } else {
            this.toast.error(error.error['message']);
          }
          this.submitDisable = false;
          this.submitted = true;
        },
      });
    }
  }

  domain_name_list: any[] = [];
  updateProperty(onlyUpdateOrCreate: 'update' | 'onlyUpdate') {
    // this function is used for update listing
    this.syncResidentialLotProject();
    if (
      this.company_website_error_set == true ||
      this.domain_error_set == true ||
      this.rea_error_set == true ||
      this.homely_error_set == true ||
      this.market_place_error_set == true ||
      this.real_estate_view_error_set == true
    ) {
      this.domain_dialog = true;
      this.company_website_error_set && !this.domain_name_list.includes('Company Website')
        ? this.domain_name_list.push('Company Website')
        : !this.company_website_error_set
          ? (this.domain_name_list = this.domain_name_list?.filter(el => el !== 'Company Website'))
          : '';
      this.domain_error_set && !this.domain_name_list.includes('Domain')
        ? this.domain_name_list.push('Domain')
        : !this.domain_error_set
          ? (this.domain_name_list = this.domain_name_list?.filter(el => el !== 'Domain'))
          : '';
      this.rea_error_set && !this.domain_name_list.includes('realestate.com.au')
        ? this.domain_name_list.push('realestate.com.au')
        : !this.rea_error_set
          ? (this.domain_name_list = this.domain_name_list?.filter(el => el !== 'realestate.com.au'))
          : '';
      this.homely_error_set && !this.domain_name_list.includes('Homely')
        ? this.domain_name_list.push('Homely')
        : !this.homely_error_set
          ? (this.domain_name_list = this.domain_name_list?.filter(el => el !== 'Homely'))
          : '';
      this.market_place_error_set && !this.domain_name_list.includes('Market Place')
        ? this.domain_name_list.push('Market Place')
        : !this.market_place_error_set
          ? (this.domain_name_list = this.domain_name_list?.filter(el => el !== 'Market Place'))
          : '';
      this.real_estate_view_error_set && !this.domain_name_list.includes('Real Estate View')
        ? this.domain_name_list.push('Real Estate View')
        : !this.real_estate_view_error_set
          ? (this.domain_name_list = this.domain_name_list?.filter(el => el !== 'Real Estate View'))
          : '';
    }
    let primary = this.editProperty.controls['agent'].value;
    let secondary = this.editProperty.controls['secondaryagent'].value;
    if (
      (primary && secondary && primary === secondary) ||
      this.other_agent?.some(el => el?.other_agents === primary || el?.other_agents === secondary)
    ) {
      this.toast.error('Duplicate agent selected');
    } else {
      this.submitDisable = true;
      this.submitted = true;
      delete this.editProperty.value['office_id'];
      if (!this.editProperty.valid && !this.editProperty.controls['existingproperty']) {
        this.submitDisable = false;
        let fields: any = Object.entries(this.editProperty.controls)
          .reduce((acc, [key, value]) => {
            if (value.status === 'INVALID') {
              acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
            }
            return acc;
          }, [])
          ?.filter(error_field => error_field !== undefined && error_field !== null);
        fields && this.validateFieldsOnRequest(fields);
        this.toast.error('Required fields must be filled in');
        return;
      } else {
        if (this.editProperty.value['availableDate'] == null) this.editProperty.value['availableDate'] = '';
        let form_data = this.editProperty.value;
        form_data['Selected_property_Id'] = this.select_property_id;
        form_data['video_url'] = this.all_links?.video;
        form_data['online_tour1'] = this.all_links?.tour1;
        form_data['online_tour2'] = this.all_links?.tour2;
        let desc = this.editProperty.controls['description_garax'].value;
        form_data['description_garax'] = this.htmlToPlain(desc);
        form_data['commission_applied'] = this.commission_applied;
        form_data['isPercentage'] = this.isPercentage;
        form_data['commission_rate'] = this.commission_rate;
        form_data['commission_amount'] = this.commission_amount;
        form_data['tiered_commission'] = this.tiered_commission;
        form_data['specific_commission'] = this.specific_commission;
        form_data['rea_error_set'] = this.rea_error_set;
        form_data['domain_error_set'] = this.domain_error_set;
        form_data['company_website_error_set'] = this.company_website_error_set;
        form_data['market_place_error_set'] = this.market_place_error_set;
        form_data['homely_error_set'] = this.homely_error_set;
        form_data['real_estate_view_error_set'] = this.real_estate_view_error_set;
        form_data['other_agents'] = this.other_agent;
        form_data['sale_commission'] = this.saleCommission;
        form_data['conjunction_details'] = this.conjunctionDetails;
        this._listingPropertiesService.up_dateListingProperty(this.selectedProperty._id, form_data).subscribe({
          next: res => {
            this.isSaved.emit(true);
            this._workflowService.isWorkflowProcessTabOpened == true && this.GetListingWorkflowProcesses();
            this.toast.success('Listing updated successfully');
            if (res.reaResponse == null) {
              this.toast.error('Something went wrong pushing to REA');
            } else if (res.reaResponse == 'push successfull') {
              this.toast.success('Property pushed to REA successfully');
            }
            if (res.domainResponse == null) {
              this.toast.error('Something went wrong pushing to Domain');
            } else if (res.domainResponse == 'push successfull') {
              this.toast.success('Property pushed to Domain successfully');
            }
            let id = this.api.getOfficeId();
            this.editProperty.patchValue({
              office_id: id,
            });
            this.existEditProperty();
            if (onlyUpdateOrCreate !== 'onlyUpdate') {
              let tab = this.lmService.tab_levels.find(el => el.name.includes('Listing'));
              if (tab) {
                let ind = this.lmService.tab_levels.indexOf(tab);
                this.isPropertyClose.emit({ level: tab, index: ind });
              }
              this.editProperty.reset();
            }
            this.submitDisable = false;
            this.submitted = false;
            this.listingEditMode = false;
            this.message.getModuleHistory(true);
            this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
          },
          error: error => {
            this._workflowService.isWorkflowProcessTabOpened == true && this.GetListingWorkflowProcesses();
            let { fields, all_fields } = error?.error;
            if (fields?.length > 0) {
              this.formAllFields = fields = fields
                ?.map(error_field => {
                  let isExistsField = all_fields?.find(field => field.name === error_field);
                  if (isExistsField) {
                    error_field = { name: error_field, label: isExistsField?.label || '' };
                  }
                  return error_field;
                })
                ?.filter(error_field => error_field !== undefined && error_field !== null);
              this.toast.error('Required fields must be filled in');
              this.validateFieldsOnRequest(fields);
            } else {
              this.toast.error(error.error['message']);
            }
            this.submitDisable = false;
            this.submitted = true;
          },
        });
      }
    }
  }

  htmlToPlain(html) {
    /**
     * Converts HTML content into plain text by removing certain HTML tags
     * and replacing them with appropriate plain text representations.
     *
     * @param html The HTML string to be converted to plain text.
     * @returns A plain text string with HTML tags replaced.
     */
    let plain = html;

    // Remove ordered list tags
    plain = plain?.replace(/<ol>/g, '');
    plain = plain?.replace(/<\/ol>/g, '');

    // Replace unordered list tags with spaces
    plain = plain?.replace(/<ul>/g, ' ');
    plain = plain?.replace(/<\/ul>/g, '');

    // Replace list item tags with dashes and line breaks
    plain = plain?.replace(/<li>/g, '- ');
    plain = plain?.replace(/<\/li>/g, '</br>');

    // Replace bullet points with dashes
    plain = plain?.replace(/•/g, '- ');

    return plain;
  }

  validateInput(event: Event, controlName: string): void {
    /**
     * This function is used to validate the input field for negative numbers.
     * @param event The event object of the input field.
     * @param controlName The name of the form control.
     */
    const input = event.target as HTMLInputElement;
    const value = parseInt(input.value, 10);
    if (value < 0) {
      // If the value is negative, then set the value to 0
      this.editProperty.controls[controlName].setValue(0);
    }
  }

  validateFieldsOnRequest(fields: any[] = []) {
    /**
     * This function is used to validate the input fields and highlight the fields
     * which have errors.
     * @param fields The array of fields which have errors.
     */
    if (fields?.length > 0) {
      // Loop through the fields which have errors and add the required validator to
      // the fields which have errors.
      fields?.forEach(field_error => {
        if (field_error.name === 'price') {
          field_error.name = 'value';
        }
        if (field_error.name === 'property_type') {
          field_error.name = 'type';
        }
        this.editProperty?.controls?.[field_error?.name]?.setValidators([Validators.required]);
        this.editProperty?.controls?.[field_error?.name]?.updateValueAndValidity();
      });
      // Reset the count of invalid fields.
      this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
      // Loop through the controls of the form and check if any of the controls have
      // errors.
      for (let prop in this.editProperty.controls) {
        if (this.editProperty.controls[prop].errors) {
          // Create an object which contains the field name and the error message.
          let fieldReqObj = {
            field: prop,
            message: `${fields?.find(tempfile => tempfile.name === prop)?.label || ''}`,
          };
          // Add the object to the array of error messages.
          this.requiredErrorMessages.push(fieldReqObj);
          // Increment the count of invalid fields.
          this.numOfNotValidFields++;
        }
      }
    }
  }

  getTasks() {
    /**
     * This function is used to get the tasks related to the current property.
     */
    this._taskService.getTaskListByPropertyId(this.property_id).subscribe(res => {
      /**
       * Get all the tasks related to the property.
       */
      this.fullList = res.data;

      /**
       * Filter out the tasks which are not in the "Closed" status.
       */
      this.fullList = this.fullList.filter(el => el.taskStatusName !== 'Closed');

      /**
       * Get the tasks which are due today.
       */
      this.todayTasks = this.fullList.filter(item => {
        if (moment(item?.due_date).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD') && item?.taskStatusName != 'Closed') {
          return item;
        }
      });

      /**
       * Get the tasks which are due tomorrow.
       */
      this.tomorrowTasks = this.fullList.filter(
        item => moment(item?.due_date).format('YYYY-MM-DD') == moment().add(1, 'days').format('YYYY-MM-DD') && item?.taskStatusName != 'Closed'
      );

      console.log('tomorrowTasks >>', this.tomorrowTasks);
    });
  }

  select_id: any;
  getPropertyById() {
    // this function is used for get property detail and patch to the form
    let id = this.prop_id ? this.prop_id : this.property_id;
    this._propertyService.getPropertyById(id).subscribe(res => {
      this.select_id = res?.data?._id;
      this.editProperty.patchValue({
        baths: res?.data?.baths,
        beds: res?.data?.beds,
        building_area: res?.data?.building_area,
        building_area_type: res?.data?.building_area_type || null,
        building_name: `"${res?.data?.building_name}"`,
        car: res?.data?.car,
        car_port: res?.data?.car_port,
        description_garax: res?.data?.description_garax,
        country: res?.data?.country,
        energy_rating: res?.data?.energy_rating,
        ensuite: res?.data?.ensuite,
        exterior: res?.data?.exterior,
        features: res?.data?.features,
        property_images: res?.data?.property_images,
        garage: res?.data?.garage,
        isHideAddress: res?.data?.isHideAddress,
        project_associate: res?.data?.project_associate,
        land_area: res?.data?.land_area,
        land_area_type: res?.data?.land_area_type || null,
        living_areas: res?.data?.living_areas,
        open_spaces: res?.data?.open_spaces,
        pools: res?.data?.pools,
        post_code: res?.data?.post_code,
        properties_module: res?.data?.properties_module,
        property_address: res?.data?.property_address.replace('Australia', ''),
        legalname: this.ownersId,
        roofing: res?.data?.roofing,
        state: res?.data?.state,
        street_name: res?.data?.street_name,
        street_no: res?.data?.street_no,
        study: res?.data?.study,
        suburb: res?.data?.suburb,
        unit_no: res?.data?.unit_no,
        views: res?.data?.views,
        type: res?.data?.type,
      });
      this.onPropertyTypeChange();
      this.applyDomainLandTypeDefault();
    });
  }

  isSearchTrue = false;
  filteredProperty: any[] = [];
  filteredListing: any[] = [];
  isImage = false;
  isAgent = false;
  isPrice = false;
  isConfig = false;
  isFeature = false;
  copyDialog: boolean = false;

  filterPropertyListing() {
    /**
     * Filter the property listing based on the search keyword.
     * This function is triggered when the user types something in the search bar.
     * It filters the property listing based on the search keyword and updates the `filteredProperty` and `filteredListing` arrays.
     */

    this.isSearchTrue = true;
    let val = this.editProperty.controls['property_address'].value;
    if (val) {
      this._sharedService.getDropDownItems('property', val, true).subscribe({
        next: response => {
          this.filteredProperty = response['data'];
        },
      });
      this._sharedService.getDropDownItems('listings', val, true, true).subscribe({
        next: response => {
          this.filteredListing = response['data'];
        },
      });
    }

    // // Filter the property listing based on the search keyword
    // // Filter the listing based on the search keyword
  }

  previousListingDetail = null;
  previousPropertyId = null;

  selectFilterItem(item, param) {
    /**
     * This function is called when the user selects a property from the search result dropdown.
     * It is used to either copy the selected property or select it as the property for the current listing.
     * @param item The selected property
     * @param param The type of the selected property (listing or property)
     */
    if (param == 'listing') {
      // If the selected property is a listing, then copy the property details into the current listing form
      this.isSearchTrue = false;
      this.editProperty.patchValue({
        property_address: item.property_address.replace('Australia', ''),
        prevproperty: item._id,
        existingproperty: null,
      });
      // Get the property details from the backend
      this._listingPropertiesService.getListingPropertyById(item?._id).subscribe({
        next: res => {
          // Update the previous listing detail with the selected property
          res.data['prevproperty'] = item._id;
          this.previousListingDetail = res?.data;
          // Open the copy dialog
          this.copyDialog = true;
        },
      });
    } else {
      // If the selected property is a property, then select it as the property for the current listing
      this.isSearchTrue = false;
      this.propertySelection(item);
      this.editProperty.patchValue({
        property_address: item.property_address.replace('Australia', ''),
        existingproperty: item?._id,
      });
    }
  }

  emptySearch() {
    this.isSearchTrue = false;
    this.filteredProperty = [];
    this.filteredListing = [];
    this.previousListingDetail = null;
    this.previousListing = [];
    this.isImg = false;
    this.imgNotFoundList = [];
    this.imageDisplayPath = null;
    this.isImage = false;
    this.isAgent = false;
    this.isPrice = false;
    this.isConfig = false;
    this.isFeature = false;
    this.editProperty.reset();
    this.selectedProperty = null;
    this.property_id = null;
    this.insertedPropertyId = null;
    this.isImg = false;
    this.isDocuments = false;
    this.editProperty.patchValue({
      image_copy: false,
    });
  }

  prop_id: any;
  getManualHistory = [];
  ownerExists = true;
  previousListing: any[] = [];
  propertySelection(e) {
    /**
     * This function is used to select a property for the current listing.
     * It gets the manual history of the property and previous listings of the property.
     * If the property doesn't have an owner, it shows an error message.
     * @param e The selected property
     */
    this.prop_id = e?._id;
    if (e?._id) {
      // Get the manual history of the property
      this._historyService.getManualHistoryByPropertyId(e?._id).subscribe({
        next: response => {
          // Filter out the history items that are not meant to be shown
          this.getManualHistory = response?.data.filter(x => x?.is_show_in_history !== false);
          // If there are no owners in the history, show an error message
          if (!this.getManualHistory[0]?.buyer?.length) {
            this.ownerExists = true;
            this.toast.error('Please add an owner to the property before saving this listing.');
            this.getPropertyById();
          } else {
            this.ownersId = this.getManualHistory[0]?.buyer?.map(x => x?._id);
            this.getPropertyById();
          }
        },
      });
    }
    if (e?._id) {
      // Get the previous listings of the property
      this.previousListing = [];
      this._listingPropertiesService.getListingListAgainstPropertyId(e?._id).subscribe(res => {
        this.previousListing = res?.data;
      });
    }
  }

  copyDetail(param) {
    /**
     * This function is used to copy the details of the previous listing.
     * If the param is 'yes', it patches the current listing with the details of the previous listing.
     * If the param is 'no', it just closes the dialog.
     * @param param A string indicating whether to copy the details of the previous listing or not.
     */
    if (param == 'yes') {
      // Close the dialog
      this.copyDialog = false;
      // Patch the current listing with the details of the previous listing
      this.patchListingDetails(this.previousListingDetail);
    } else {
      // Close the dialog
      this.copyDialog = false;
    }
  }

  patchPrevListing(e) {
    this.previousPropertyId = this.editProperty.controls['prevproperty'].value;
    this.previousListingDetail =
      this.previousListing?.length > 0 ? this.previousListing?.find(ele => ele?._id == this.previousPropertyId) : this.previousListingDetail;

    this.property_id = this.previousPropertyId;

    if (e == 'patch') {
      this.copyDialog = true;
    } else if (e == 'image') {
      if (this.isImage == true) {
        this.isImg = true;
        this.imageDisplayPath = this.previousListingDetail?.property_images[0]?.thumbPath;
        this.editProperty.patchValue({
          image_copy: true,
        });
      } else {
        this.isImg = false;
        this.imgNotFoundList = [];
        this.imageDisplayPath = null;
        this.editProperty.patchValue({
          image_copy: false,
        });
      }
    }
    if (e == 'agent') {
      if (this.isAgent == true) {
        this.editProperty.patchValue({
          agent: this.previousListingDetail?.agent,
          secondaryagent: this.previousListingDetail?.secondaryagent,
        });
      } else {
        this.editProperty.patchValue({
          agent: null,
          secondaryagent: null,
        });
      }
    }
    if (e == 'price') {
      if (this.isPrice == true) {
        this.editProperty.patchValue({
          value: this.previousListingDetail?.value,
        });
      } else {
        this.editProperty.patchValue({
          value: null,
        });
      }
    }
    if (e == 'confige') {
      if (this.isConfig == true) {
        this.editProperty.patchValue({
          beds: this.previousListingDetail?.beds,
          baths: this.previousListingDetail?.baths,
          car: this.previousListingDetail?.car,
          car_port: this.previousListingDetail?.car_port,
          ensuite: this.previousListingDetail?.ensuite,
          living_areas: this.previousListingDetail?.living_areas,
          pools: this.previousListingDetail?.pools,
          open_spaces: this.previousListingDetail?.open_spaces,

          building_area: this.previousListingDetail?.building_area,
          building_area_type: this.previousListingDetail?.building_area_type,
          land_area: this.previousListingDetail?.land_area,
          land_area_type: this.previousListingDetail?.land_area_type,
        });
      } else {
        this.editProperty.patchValue({
          beds: null,
          baths: null,
          car: null,
          car_port: null,
          ensuite: null,
          living_areas: null,
          pools: null,
          open_spaces: null,

          building_area: null,
          building_area_type: null,
          land_area: null,
          land_area_type: null,
        });
      }
    }
    if (e == 'feature') {
      if (this.isFeature == true) {
        this.editProperty.patchValue({
          features: this.previousListingDetail?.features,
          energy_rating: this.previousListingDetail?.energy_rating,
          views: this.previousListingDetail?.views,
          roofing: this.previousListingDetail?.roofing,
          exterior: this.previousListingDetail?.exterior,
        });
      } else {
        this.editProperty.patchValue({
          features: null,
          energy_rating: null,
          views: null,
          roofing: null,
          exterior: null,
        });
      }
    }
  }

  patchListingDetails(selectedList) {
    this.isImage = true;
    this.isAgent = true;
    this.isPrice = true;
    this.isConfig = true;
    this.isFeature = true;
    this.isImg = true;

    this.editProperty.patchValue(selectedList);
    this.imageDisplayPath = selectedList?.property_images[0]?.thumbPath;
    this.commission_applied = selectedList?.commission_applied ? selectedList?.commission_applied : null;
    this.isPercentage = selectedList?.isPercentage;
    this.commission_rate = selectedList?.commission_rate ? selectedList?.commission_rate : null;
    this.commission_amount = selectedList?.commission_amount ? selectedList?.commission_amount : null;
    this.tiered_commission = selectedList?.tiered_commission ? selectedList?.tiered_commission : null;
    this.specific_commission = selectedList?.specific_commission ? selectedList?.specific_commission : [];
    this.other_agent = selectedList?.other_agents ? selectedList?.other_agents : [];
    this.company_website_error_set = selectedList?.company_website_error_set ? true : false;
    this.domain_error_set = selectedList?.domain_error_set ? true : false;
    this.rea_error_set = selectedList?.rea_error_set ? true : false;
    this.homely_error_set = selectedList?.homely_error_set ? true : false;
    this.real_estate_view_error_set = selectedList?.real_estate_view_error_set ? true : false;
    this.market_place_error_set = selectedList?.market_place_error_set ? true : false;
    this.legal_files = selectedList?.legal_files?.length > 0 ? selectedList?.legal_files : [];
    let address = '';
    if (selectedList?.unit_no && selectedList?.street_no) {
      address = selectedList?.unit_no + '/' + selectedList?.street_no;
    } else {
      address = selectedList?.unit_no ? selectedList?.unit_no : '';
      address = selectedList?.street_no ? selectedList?.street_no : '';
    }
    address += address.length > 0 ? ' ' : '';
    address += selectedList?.street_name
      ? selectedList?.street_name + ', ' + selectedList?.suburb?.suburb + ', ' + selectedList?.state + ' ' + selectedList?.post_code
      : '';
    address = address.length > 0 ? address : selectedList?.property_address;
    this.editProperty.patchValue({
      property_address: address,
      image_copy: true,
      prevproperty: selectedList?.prevproperty ? selectedList?.prevproperty : this.previousPropertyId,
      existingproperty: selectedList?.Selected_property_Id ? selectedList?.Selected_property_Id : this.prop_id,
      date: selectedList?.date ? new Date(selectedList?.date) : null,
      startTime: selectedList?.startTime ? new Date(selectedList?.startTime) : null,
      settledDate: selectedList?.settledDate ? new Date(selectedList?.settledDate) : null,
      selling_agreement_start_date: selectedList?.selling_agreement_start_date ? new Date(selectedList?.selling_agreement_start_date) : null,
      selling_agreement_end_date: selectedList?.selling_agreement_end_date ? new Date(selectedList?.selling_agreement_end_date) : null,
      soldDate: selectedList?.soldDate ? new Date(selectedList?.soldDate) : null,
      availableDate: selectedList?.availableDate ? new Date(selectedList?.availableDate) : null,
      legalname: this.getManualHistory[0]?.buyer?.length > 0 ? [this.getManualHistory[0]?.buyer[0]?._id] : [this.getManualHistory[0]?.seller[0]?._id],
    });

    // The copied type arrives by patch, not through the picker's change event, so the lot options
    // and the project behind them have to be pulled here or the Lot dropdown copies over empty.
    // `false` because the copied association is the source listing's; loading options must not
    // rewrite it.
    this.loadResidentialLots();
    this.loadSavedListingProject();
  }
  getAgents() {
    let url = '/users/byoffice?office=' + this.api.getOfficeId() + '&show=staff';
    this.redux.getSetProjectInfo(true, 'byOffice', url).subscribe({
      next: response => {
        // Maps the retrieved staff data and constructs the full name
        this.originalAssigns = JSON.parse(JSON.stringify(response.data));
        if (
          this.lmService.listing_show_div == 'add_listing_from_property' ||
          this.lmService.listing_show_div == 'add_listing_property' ||
          this.lmService.listing_show_div == 'add_listing_property_listing'
        ) {
          let active_staff = this.originalAssigns?.filter(el => el?.deactive !== true);
          this.originalAssigns = active_staff
            ?.map(i => {
              i.full_name = i.first_name + ' ' + i.last_name;
              return i;
            })
            .sort((a, b) => a?.full_name.localeCompare(b?.full_name));
          this.originalAssignsAppt = [...this.originalAssigns, ...this.lmService.shortContactCompany];
        } else {
          this.originalAssigns = this.originalAssigns
            ?.map(i => {
              i.full_name = i.first_name + ' ' + i.last_name;
              return i;
            })
            .sort((a, b) => a?.full_name.localeCompare(b?.full_name));
          this.originalAssignsAppt = [...this.originalAssigns, ...this.lmService.shortContactCompany];
        }
      },
    });
  }

  subOfficeList: any[] = [];
  private subOfficeListLoaded = false;
  getSubOffices() {
    this._settingService.getSubOfficeList().subscribe({
      next: response => {
        this.subOfficeList = response?.data || [];
        this.subOfficeListLoaded = true;
        this.applyDefaultSubOffice();
      },
    });
  }

  /** The header reads the sub office as a chip, so the Portals tab only shows its picker to edit. */
  get subOfficeName(): string {
    const officeId = this.editProperty?.controls['sub_office_id']?.value;
    return this.subOfficeList?.find(office => office._id === officeId)?.office_name || '';
  }

  domainLandTypes = [
    { label: 'Development Site', value: 'developmentSite' },
    { label: 'New Land', value: 'newLand' },
    { label: 'Vacant Land', value: 'vacantLand' },
  ];

  /** Property types come from office tags, so compare without case. */
  get isLandType(): boolean {
    return (this.editProperty?.controls['type']?.value || '').toString().trim().toLowerCase() === 'land';
  }

  /** Land defaults to Vacant Land; any other type carries no Domain land type. */
  applyDomainLandTypeDefault(): void {
    const control = this.editProperty.get('domain_land_type');
    if (!this.isLandType) {
      control?.setValue(null, { emitEvent: false });
    } else if (!control?.value) {
      control?.setValue('vacantLand', { emitEvent: false });
    }
  }

  /**
   * Defaults the Portals tab's Sub Office field to the first option, same as the other office
   * pickers. Called both once the list loads and once `existEditProperty`'s patch lands, since
   * whichever finishes second would otherwise leave (or reset) the field empty.
   */
  applyDefaultSubOffice() {
    if (!this._settingService.isSubOfficeAutoDefaultEnabled()) {
      return;
    }
    if (!this.subOfficeListLoaded || !this.subOfficeList.length) return;
    if (!this.editProperty.get('sub_office_id')?.value) {
      this.editProperty.get('sub_office_id')?.setValue(this.subOfficeList[0]._id);
    }
  }

  fetchEvents(listingId: string = this.property_id || this.insertedPropertyId) {
    this._CalendarAPIService.getCalendarEventsByLeadId(listingId).subscribe({
      next: response => {
        this.leadCalendarManagePermission = response.leadCalendarmanage;
        if (response.connected == true) {
          this.emailConnected = true;
        } else {
          this.googleAuthUrl = response.data + '&state=' + this.api.getUserId();
        }
      },
    });
    setTimeout(() => {
      this.message.getModuleHistory(true);
    }, 300);
    this.selectedProperty?.agentData.forEach(agent => {
      if (!this.insertEvent.attendees.includes(agent.email)) this.insertEvent.attendees.push(agent.email);
    });
    this.attached_contacts?.forEach(itm => {
      if (!this.insertEvent.attendees.includes(itm.contact.email)) this.insertEvent.attendees.push(itm.contact.email);
    });
    this.isFetchedEvent = false;
    this._CalendarAPIService.checkGoogleCalendarConnectedStatus().subscribe({
      next: response => {
        this.leadCalendarManagePermission = response.leadCalendarmanage;
        if (response.connected == true) {
          this.emailConnected = true;
        } else {
          this.googleAuthUrl = response.data + '&state=' + this.api.getUserId();
        }
      },
    });
  }

  changeViewGrid() {
    if (this.cal_view_grid == 'dayGridMonth') {
      this.optional.dayHeaderFormat = { weekday: 'short' };
    } else {
      this.optional.dayHeaderFormat = { day: 'numeric', weekday: 'short', omitCommas: true };
    }

    this.fullcalendar?.getApi()?.render();
    this.fullcalendar?.getApi()?.changeView(this.cal_view_grid || 'timeGridWeek');
  }

  user_event = [];
  user_cal = null;
  getUserCalendarDetail(record, callFromDropdown = false, cal_detail = null, removeId = null, isToast = false) {
    this.user_cal = removeId ? this.user_cal?.filter(ele => ele?._id !== removeId) : cal_detail;
    this.isFetchedEvent = false;
    let userId = this.activeCalendarUser?.filter(el => el != record?._id);
    this._CalendarAPIService.getCalendarEventsByUserIds(userId ? userId : this.api.getUserId(), 'Property').subscribe({
      next: res => {
        if (res.status) {
          this.time_hour = res.data;
          isToast && this.toast.success('Google Calendar refreshed');
          if (this.time_hour?.tasks_lists[0]?.tasks?.items?.length > 0) {
            this.time_hour.tasks_lists[0].tasks.items = this.time_hour?.tasks_lists[0]?.tasks?.items?.filter(item => {
              if (item?.hasOwnProperty('title')) {
                return item?.title?.indexOf(this.selectedProperty._id) >= 0;
              } else {
                return false;
              }
            });
            this.time_hour?.tasks_lists[0]?.tasks?.items?.forEach(element => {
              this.time_hour.events.items.push({
                start: { dateTime: element.due },
                end: { dateTime: element.due },
                summary: element.title,
              });
            });
          }
          this.optional.events = [];
          this.user_event = [];
          if (this.time_hour?.events?.length > 0) {
            this.time_hour?.events?.forEach(ele => {
              this.user_cal.forEach(user => {
                if (ele.summary == user?.email) {
                  ele['color'] = user?.color;
                }
              });
              if (ele?.items?.length > 0) {
                ele.items.forEach(itm => {
                  let rule = itm?.recurrence?.length > 0 ? RRule.fromString(itm?.recurrence[0]) : {};
                  let dated = new Date(itm?.start?.dateTime);
                  let hours = dated.getHours();
                  let min = dated.getMinutes();
                  let second = dated.getSeconds();
                  let ruled = {
                    ...rule['options'],
                    dtstart: dated,
                    byhour: [hours],
                    byminute: [min],
                    bysecond: [second],
                  };

                  if (rule['options']?.freq !== undefined) {
                    this.user_event.push({
                      title: itm.summary,
                      date: itm?.start?.dateTime,
                      time: `${this.formatTimeRange(itm?.start?.dateTime, itm?.end?.dateTime)}`,
                      start_time: `${this.startTimeRange(itm?.start?.dateTime)}`,
                      rrule: ruled,
                      extendedProps: { ...itm, user_id: ele?.user_id },
                      allDay: false,
                      backgroundColor: ele?.color || '#e9f4f1',
                    });
                  } else {
                    this.user_event.push({
                      title: itm.summary,
                      date: itm?.start?.dateTime,
                      time: `${this.formatTimeRange(itm?.start?.dateTime, itm?.end?.dateTime)}`,
                      start_time: `${this.startTimeRange(itm?.start?.dateTime)}`,
                      extendedProps: { ...itm, user_id: ele?.user_id },
                      allDay: false,
                      backgroundColor: ele?.color || '#e9f4f1',
                    });
                  }
                });
              }
            });
          }
          if (callFromDropdown == true) {
            this.listing_event = this.copy_listing_event;
            let event_list = [...this.listing_event, ...this.user_event];
            this.optional = { ...this.optional, events: [...this.optional.events, ...(event_list || [])] };
            console.log('this.optional >>:', this.optional);
            this.fullcalendar?.getApi()?.render();
          }
        } else {
          this.toast.error(res.message);
        }
      },
    });
  }

  past_inspection: any[] = [];
  copy_listing_event: any[] = [];
  listing_event: any[] = [];
  fetchApts(record) {
    console.log('record >>:', record);

    if (record?._id) {
      this._CalendarAPIService.getCalendarEventsByModuleName(record?._id, 'property_id').subscribe({
        next: res => {
          this.optional.events = [];
          this.copy_listing_event = this.listing_event = [];

          res.data.forEach(itm => {
            const startDateTime = toWallClock(itm?.event?.start?.dateTime);
            const endDateTime = toWallClock(itm?.event?.end?.dateTime);

            this.listing_event.push({
              title: itm?.event?.summary,
              backgroundColor: '#229276',
              date: startDateTime,
              time: `${this.formatTimeRange(startDateTime, endDateTime)}`,
              start_time: `${this.startTimeRange(startDateTime)}`,
              extendedProps: { ...itm?.event, _id: itm?._id },
            });
          });

          this.copy_listing_event = this.listing_event;
          this.optional = { ...this.optional, events: [...this.optional.events, ...(this.listing_event || [])] };
          console.log('this.optional >>:', this.optional);
          this.fullcalendar?.getApi()?.render();
          let apts = res.data;
          if (this.time_hour?.events?.items != null) {
            this.time_hour?.events?.items.forEach(event => {
              if (event.summary.indexOf('Private Inspection') > 0 || event.summary.indexOf('Auction') > 0 || event.summary.indexOf('Open Home')) {
              } else {
                apts.push({ event: event, type: event.summary });
              }
            });
          }

          this.property_apt_list = apts.filter(itm => {
            let d = new Date();
            d.setDate(d.getDate() - 1);
            return new Date(toWallClock(itm?.event?.end?.dateTime)) >= d;
          });
          this.property_apt_list.sort((x, y) => +new Date(toWallClock(x.event.start.dateTime)) - +new Date(toWallClock(y.event.start.dateTime)));

          let insp = res.data;
          if (insp.length > 0) {
            insp = insp.filter(e => {
              if (e.hasOwnProperty('isInspection') == true && e.isInspection == true) {
                return e;
              }
            });
          }
          this.isFetchedEvent = true;
          this.copy_property_inspection_list = this.property_inspection_list = insp
            .filter(itm => {
              let d = new Date();
              d.setDate(d.getDate() - 1);
              return new Date(toWallClock(itm?.event?.end?.dateTime)) >= d;
            })
            .sort((x, y) => +new Date(toWallClock(x.event.start.dateTime)) - +new Date(toWallClock(y.event.start.dateTime)));
          let today = moment();
          this.property_inspection_list = this.copy_property_inspection_list?.filter(ins => {
            const eventDate = moment(toWallClock(ins?.event?.start?.dateTime));
            const eventEndDateTime = moment(toWallClock(ins?.event?.end?.dateTime));
            const isFutureDate = eventDate.isAfter(today, 'day');
            const isSameDate = eventDate.isSame(today, 'day') && eventEndDateTime.isAfter(today);
            return isSameDate || isFutureDate;
          });
          console.log('property_inspection_list >>', this.property_inspection_list);

          this.past_inspection = this.copy_property_inspection_list?.filter(ins => {
            const eventDate = moment(toWallClock(ins?.event?.start?.dateTime));
            const eventEndDateTime = moment(toWallClock(ins?.event?.end?.dateTime));
            const isPastDate = eventDate.isBefore(today, 'day');
            const isSameDate = eventDate.isSame(today, 'day');
            const isFutureTime = isSameDate && eventEndDateTime.isBefore(today);
            return isPastDate || isFutureTime;
          });
        },
      });
    }
  }

  /** Google Calendar instants reach this too, so callers pass the value through `toWallClock` — it must not be applied here. */
  startTimeRange(startTime: string): string {
    const start = moment(startTime);
    const startFormat = start.minutes() > 0 ? 'h:mma' : 'ha';
    return `${start.format(startFormat)}`;
  }

  /** Google Calendar instants reach this too, so callers pass the value through `toWallClock` — it must not be applied here. */
  formatTimeRange(startTime: string, endTime: string): string {
    const start = moment(startTime);
    const end = moment(endTime);

    const startFormat = start.minutes() > 0 ? 'h:mm' : 'h';
    const endFormat = end.minutes() > 0 ? 'h:mma' : 'ha';

    return `${start.format(startFormat)} - ${end.format(endFormat)}`;
  }

  deleteCalendarEvent(event) {
    this.remmiConfirm
      .delete({
        title: 'Delete Event?',
        message: 'This event will be removed from the calendar.',
        subject: event?.summary?.split('|')[0],
      })
      .subscribe(isConfirmed => isConfirmed && this.removeCalendarEvent(event));
  }

  private removeCalendarEvent(event) {
    /**
     * Delete a calendar event.
     * If the event was created by a different user, then the event is deleted from the calendar of the other user.
     * If the event was created by the current user, then the event is deleted from the calendar of the current user.
     * @param event The event to delete
     */
    if (event?.creator) {
      // If the event was created by a different user, then the event is deleted from the calendar of the other user.
      this._CalendarAPIService.removeEventFromCalendarByUserId(event?.user_id, event?.id).subscribe({
        next: () => {
          // If the event is deleted successfully, then the loading spinner is hidden, the event popup is closed, and a success message is displayed.
          this.event_loading = false;
          this.event_popup = false;
          this.toast.success('Event deleted successfully');
          // The cache is reset so that the event list is reloaded from the server.
          this.fetchApts(this.selectedProperty);
        },
        // If there is an error, then the loading spinner is hidden, the event popup is closed, and an error message is displayed.
        error: () => {
          this.event_loading = false;
          this.editingApt = false;
          this.event_popup = false;
          this.toast.error('Please connect the listing agent Gsuite account');
        },
      });
    } else {
      // If the event was created by the current user, then the event is deleted from the calendar of the current user.
      let payload = {
        user_id: this.api.getUserId(),
        appt_id: event._id,
      };
      this._CalendarAPIService.removeCalendarById(payload).subscribe({
        next: () => {
          // If the event is deleted successfully, then the loading spinner is hidden, the event popup is closed, and a success message is displayed.
          this.event_loading = false;
          this.event_popup = false;
          this.toast.success('Event deleted successfully');
          // The cache is reset so that the event list is reloaded from the server.
          this.fetchApts(this.selectedProperty);
        },
      });
    }
  }

  getBgColor(i) {
    /**
     * Returns a CSS style object for the given index i.
     * @param i The index of the event
     * @returns A CSS style object with the background color, text color and border color
     */
    let ind = parseInt(i);
    if (i) {
      // If the index is valid, return a CSS style object with the background color, text color and border color
      return {
        'background-color': this.time_hour?.colors?.event[ind]['background'],
        color: this.time_hour?.colors?.event[ind]['foreground'],
        border: '1px solid' + this.time_hour?.colors?.event[ind]['background'],
      };
    } else {
      // If the index is invalid, return a CSS style object with a default background color, text color and border color
      return {
        'background-color': '#F8F8F8 ',
        color: '#000',
        border: '1px solid #F8F8F8 ',
      };
    }
  }

  dateDiffToString(a, b) {
    /**
     * Calculate the difference between two dates and return a string in the format:
     * <number of days>d <number of hours>h <number of minutes>m <number of seconds>s
     * @param a The first date
     * @param b The second date
     * @returns A string representing the difference between the two dates
     */
    var diff = Math.abs(a - b);

    // Calculate the milliseconds
    var ms = diff % 1000;

    // Calculate the seconds
    diff = (diff - ms) / 1000;
    var ss = diff % 60;

    // Calculate the minutes
    diff = (diff - ss) / 60;
    var mm = diff % 60;

    // Calculate the hours
    diff = (diff - mm) / 60;
    var hh = diff % 24;

    // Calculate the days
    var days = (diff - hh) / 24;

    // Return the result as a string
    return days * 24 + hh + ':' + mm + ':' + ss;
  }

  insertEventAppointment() {
    if (this.isEndTimeAfterStartTime(this.insertEvent.starttime, this.insertEvent.endtime)) {
      this.event_loading = true;
      var startdate = new Date(this.insertEvent.startdate);
      if (!this.insertEvent.starttime) {
        this.toast.error('Please add a start time');
        this.event_loading = false;
        return;
      }
      startdate.setHours(this.insertEvent.starttime.getHours());
      startdate.setMinutes(this.insertEvent.starttime.getMinutes());
      startdate.setSeconds(this.insertEvent.starttime.getSeconds());
      if (this.selectedActivityType?.name == 'Task') {
        var timeString = new Date(startdate).toISOString();
        var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        var startDate = new Date(timeString);
        var isoStartDate = new Date(startDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];

        let summaryName = '';
        let summaryPropertyAddress = '';
        if (this.selectedActivityType?.name) {
          summaryName = this.selectedActivityType?.name;
        }
        if (this.selectedProperty?.property_address) {
          summaryPropertyAddress = this.selectedProperty?.property_address;
        }

        let task = {
          due: isoStartDate + 'Z',
          notes: this.insertEvent.description,
          title: `Remmi: ${summaryName}: ${summaryPropertyAddress}`,
        };
        let agentId = this.selectedProperty?.agent_id;
        if (this.selectedProperty?.agentData?.length > 0) {
          if (this.selectedProperty?.agentData[0].googleToken != null && this.selectedProperty?.agentData[0].googleToken != undefined) {
            this.api
              .post('/googletask/insert-property-task', {
                object_type: 'Property',
                object_reference: this.selectedProperty._id,
                user_id: agentId,
                task: task,
                tasklist: this.time_hour?.tasks_lists[0].id,
                edit: this.editingApt,
                isInspection: false,
              })
              .subscribe({
                next: () => {
                  this.toast.success('Task added successfully! ');
                  this.insertEvent = {
                    attendees: [],
                    location: '',
                    description: '',
                    availablebusy: 'Busy',
                    availability: 'private',
                    visibility: 'private',
                    startdate: null,
                    enddate: null,
                    starttime: null,
                    endtime: null,
                    agent: null,
                  };
                  this.insertEvent.attendees = [];
                  this.event_loading = false;
                  let dt = new Date();
                  dt.setHours(9);
                  dt.setMinutes(0);
                  dt.setSeconds(0);

                  let dt2 = new Date();
                  dt2.setHours(10);
                  dt2.setMinutes(0);
                  dt2.setSeconds(0);

                  this.insertEvent['startdate'] = new Date();
                  this.insertEvent['enddate'] = new Date();
                  this.insertEvent['starttime'] = dt;
                  this.insertEvent['endtime'] = dt2;

                  this.fetchApts(this.selectedProperty);
                  this.addNewApt = false;
                },
              });
          } else {
            this.toast.error('Please connect the listing agent Gsuite account');
            this.event_loading = false;
          }
        } else {
          this.toast.error('Please connect the listing agent Gsuite account');
          this.event_loading = false;
        }
      } else {
        var enddate = new Date(this.insertEvent.startdate);

        enddate.setHours(this.insertEvent.endtime.getHours());
        enddate.setMinutes(this.insertEvent.endtime.getMinutes());
        var timeString = new Date(startdate).toISOString();
        var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        var duration = this.dateDiffToString(startdate, enddate);

        var startDate = new Date(timeString);
        var msDuration = (Number(duration.split(':')[0]) * 60 * 60 + Number(duration.split(':')[1]) * 60 + Number(duration.split(':')[2])) * 1000;
        var endDate = new Date(startDate.getTime() + msDuration);
        var isoStartDate = new Date(startDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];
        var isoEndDate = new Date(endDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];

        let summaryPropertyAddress = '';

        if (this.selectedProperty?.property_address) {
          summaryPropertyAddress = this.selectedProperty?.property_address;
        }
        let event = {
          summary: `Remmi: ${this.aptEventTitle}: ${summaryPropertyAddress}`,
          description: this.insertEvent.description,
          start: {
            dateTime: isoStartDate,
            timeZone: timeZone,
          },
          end: {
            dateTime: isoEndDate,
            timeZone: timeZone,
          },

          visibility: this.insertEvent.availability != null ? this.insertEvent.availability : 'private', // "public" // private
          availablebusy: this.insertEvent.availablebusy,
          location: this.insertEvent.location,
        };

        if (this.selectedActivityType.name == 'Meeting' || this.selectedActivityType.name == 'Call') {
          event['conferenceData'] = {
            createRequest: {
              conferenceSolutionKey: {
                type: 'hangoutsMeet',
              },
              requestId: 'Remmi: ' + new Date().getTime(),
            },
          };
        }

        event['attendees'] = [];
        this.insertEvent.attendees.forEach(itm => {
          // if (!this.insertEvent.attendees.includes(itm))
          event['attendees'].push({ email: itm });
        });
        event['sendNotifications'] = true;

        if (this.insertEvent.availablebusy?.toLowerCase() == 'free') {
          event['transparency'] = 'transparent'; // when selected free
        }
        let agent = this.insertEvent.agent;
        this.api
          .post('/calendar/insert-property-event', {
            object_type: 'Property',
            object_reference: this.selectedProperty._id,
            office_id: this.api.getOfficeId(),
            user_id: agent?.length > 0 ? agent : [this.api.getUserId()],
            push_to_calendar: agent?.length > 0 ? true : false,
            event: event,
            type: this.selectedActivityType?.name,
            title: this.aptEventTitle,
            edit: this.editingApt,
            isInspection: false,
          })
          .subscribe({
            next: () => {
              this.toast.success('Event added to calendar successfully');
              this.fetchApts(this.selectedProperty);
              this.insertEvent.description = '';
              this.insertEvent.startdate = '';
              this.insertEvent.starttime = '';
              this.insertEvent.endtime = '';
              this.insertEvent.availablebusy = 'Busy';
              this.insertEvent.availability = 'private';
              this.insertEvent.attendees = [];
              this.selectedStartHour = null;
              this.selectedStartMinutes = null;
              this.selectedStartDuration = 'AM';
              this.selectedEndHour = null;
              this.selectedEndMinutes = null;
              this.selectedEndDuration = 'AM';
              this.addNewAIns = false;
              this.insertEvent.startdate = new Date();
              this.addNewApt = false;
              this.event_loading = false;
            },
            error: () => {
              this.event_loading = false;
              this.toast.error('Please connect the listing agent Gsuite account');
            },
          });
      }
    } else {
      this.toast.error('Start time must be before end time');
    }
  }

  /**
   * The Add Inspection card doubles as the edit form: picking a row fills it in, and the button
   * changes that inspection instead of adding another one.
   * `/calendar/insert-property-event` already takes the record being changed as `edit`.
   */
  editingInspection: any = null;
  isAddInspectionOpen: boolean = true;

  editInspection(inspection: any): void {
    this.editingInspection = inspection;
    this.isAddInspectionOpen = true;
    this.selectedInspectionType = this.inspectionMethods.find(method => method.name === inspection?.type) ?? this.selectedInspectionType;
    this.insertEvent.description = inspection?.event?.description || '';
    this.insertEvent.startdate = new Date(toWallClock(inspection?.event?.start?.dateTime));
    this.applyInspectionTime(new Date(toWallClock(inspection?.event?.start?.dateTime)), 'start');
    this.applyInspectionTime(new Date(toWallClock(inspection?.event?.end?.dateTime)), 'end');
  }

  /** Fills one edge's hour, minute and meridiem pickers, which is what composes the time itself. */
  private applyInspectionTime(value: Date, edge: 'start' | 'end'): void {
    const hours = value.getHours();
    const meridiem = hours >= 12 ? 'PM' : 'AM';
    const pickedHour = String(hours % 12 === 0 ? 12 : hours % 12);
    const pickedMinutes = String(value.getMinutes()).padStart(2, '0');

    if (edge === 'start') {
      this.selectedStartHour = pickedHour;
      this.selectedStartMinutes = pickedMinutes;
      this.selectedStartDuration = meridiem;
      this.startHourChange();
      return;
    }

    this.selectedEndHour = pickedHour;
    this.selectedEndMinutes = pickedMinutes;
    this.selectedEndDuration = meridiem;
    this.endHourChange();
  }

  cancelInspectionEdit(): void {
    this.editingInspection = null;
    this.insertEvent.description = '';
    this.insertEvent.startdate = '';
    this.insertEvent.starttime = '';
    this.insertEvent.endtime = '';
  }

  insertEventInspection() {
    if (this.isEndTimeAfterStartTime(this.insertEvent.starttime, this.insertEvent.endtime)) {
      this.event_loading = true;
      if (!this.insertEvent.startdate) {
        this.toast.error('Please add a date');
        this.event_loading = false;
        return;
      }

      if (!this.insertEvent.starttime) {
        this.toast.error('Please add a start time');
        this.event_loading = false;
        return;
      }

      if (this.selectedInspectionType?.name == 'Task') {
        var timeString = new Date(startdate).toISOString();
        var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        var startDate = new Date(timeString);
        var isoStartDate = new Date(startDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];
        let summaryName = '';
        let summaryPropertyAddress = '';
        if (this.selectedInspectionType?.name) {
          summaryName = this.selectedInspectionType?.name;
        }
        if (this.selectedProperty?.property_address) {
          summaryPropertyAddress = this.selectedProperty?.property_address;
        }
        let task = {
          due: isoStartDate + 'Z',
          notes: this.insertEvent.description,
          title: `Remmi: ${summaryName}: ${summaryPropertyAddress}`,
        };
        let agentId = this.selectedProperty?.agent_id;
        if (this.selectedProperty?.agentData?.length > 0) {
          if (this.selectedProperty?.agentData[0].googleToken != null && this.selectedProperty?.agentData[0].googleToken != undefined) {
            this.api
              .post('/googletask/insert-property-task', {
                object_type: 'Property',
                object_reference: this.selectedProperty._id,
                user_id: agentId,
                task: task,
                tasklist: this.time_hour?.tasks_lists[0].id,
                edit: null,
              })
              .subscribe({
                next: () => {
                  this.toast.success('Task added successfully! ');
                  this.insertEvent = {
                    attendees: [],
                    location: '',
                    description: '',
                    availablebusy: 'Busy',
                    availability: 'private',
                    visibility: 'private',
                    startdate: null,
                    enddate: null,
                    starttime: null,
                    endtime: null,
                    agent: null,
                  };
                  this.insertEvent.attendees = [];
                  this.event_loading = false;
                  let dt = new Date();
                  dt.setHours(9);
                  dt.setMinutes(0);
                  dt.setSeconds(0);
                  let dt2 = new Date();
                  dt2.setHours(10);
                  dt2.setMinutes(0);
                  dt2.setSeconds(0);
                  this.insertEvent['startdate'] = new Date();
                  this.insertEvent['enddate'] = new Date();
                  this.insertEvent['starttime'] = dt;
                  this.insertEvent['endtime'] = dt2;
                  this.fetchEvents();
                  this.addNewAIns = false;
                },
              });
          } else {
            this.toast.error('Please connect the listing agent Gsuite account');
            this.event_loading = false;
          }
        } else {
          this.toast.error('Please connect the listing agent Gsuite account');
          this.event_loading = false;
        }
      } else {
        var startdate = new Date(this.insertEvent.startdate);
        startdate.setHours(this.insertEvent.starttime.getHours());
        startdate.setMinutes(this.insertEvent.starttime.getMinutes());
        startdate.setSeconds(this.insertEvent.starttime.getSeconds());
        var enddate = new Date(this.insertEvent?.startdate);
        enddate.setHours(this.insertEvent?.endtime?.getHours());
        enddate.setMinutes(this.insertEvent?.endtime?.getMinutes());
        enddate.setSeconds(this.insertEvent?.endtime?.getSeconds());
        var timeString = new Date(startdate)?.toISOString();
        var timeZone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
        var duration = this.dateDiffToString(startdate, enddate);
        var startDate = new Date(timeString);
        var msDuration = (Number(duration.split(':')[0]) * 60 * 60 + Number(duration.split(':')[1]) * 60 + Number(duration.split(':')[2])) * 1000;
        var endDate = new Date(startDate.getTime() + msDuration);
        var isoStartDate = new Date(startDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];
        var isoEndDate = new Date(endDate.getTime() - new Date().getTimezoneOffset() * 60 * 1000).toISOString().split('.')[0];
        let summaryName = '';
        let summaryPropertyAddress = '';
        if (this.selectedInspectionType?.name) {
          summaryName = this.selectedInspectionType?.name;
        }
        if (this.selectedProperty?.property_address) {
          summaryPropertyAddress = this.selectedProperty?.property_address;
        }
        let event = {
          summary: `Remmi: ${summaryName}: ${summaryPropertyAddress}`,
          //'location': '800 Howard St., San Francisco, CA 94103',
          description: this.insertEvent.description,
          start: {
            dateTime: isoStartDate,
            timeZone: timeZone,
          },
          end: {
            dateTime: isoEndDate,
            timeZone: timeZone,
          },
          visibility: this.insertEvent.availability != null ? this.insertEvent.availability : 'private', // "public" // private
          availablebusy: this.insertEvent.availablebusy,
          location: this.insertEvent.location,
        };
        if (this.selectedInspectionType.name == 'Meeting' || this.selectedInspectionType.name == 'Call') {
          event['conferenceData'] = {
            createRequest: {
              conferenceSolutionKey: {
                type: 'hangoutsMeet',
              },
              requestId: 'Remmi: ' + new Date().getTime(),
            },
          };
        }
        event['attendees'] = [];
        this.insertEvent.attendees.forEach(itm => {
          event['attendees'].push({ email: itm });
        });
        event['sendNotifications'] = true;
        if (this.insertEvent.availablebusy?.toLowerCase() == 'free') {
          event['transparency'] = 'transparent'; // when selected free
        }
        this.api
          .post('/calendar/insert-property-event', {
            object_type: 'Property',
            object_reference: this.selectedProperty._id,
            user_id: this.api.getUserId(),
            office_id: this.api.getOfficeId(),
            event: event,
            type: this.selectedInspectionType?.name,
            edit: this.editingInspection,
            isInspection: true,
          })
          .subscribe({
            next: () => {
              this.toast.success(this.editingInspection ? 'Inspection updated successfully' : 'Event added to calendar successfully');
              this.editingInspection = null;
              this.fetchApts(this.selectedProperty);
              this.event_loading = false;
              this.insertEvent.description = '';
              this.insertEvent.startdate = '';
              this.insertEvent.starttime = '';
              this.insertEvent.endtime = '';
              this.insertEvent.availablebusy = 'Busy';
              this.insertEvent.availability = 'private';
              this.insertEvent.attendees = [];
              this.selectedStartHour = null;
              this.selectedStartMinutes = null;
              this.selectedStartDuration = 'AM';
              this.selectedEndHour = null;
              this.selectedEndMinutes = null;
              this.selectedEndDuration = 'AM';
              this.addNewAIns = false;
              this.insertEvent.startdate = new Date();
            },
          });
      }
    } else {
      this.toast.error('Start time must be before end time');
    }
  }

  isEndTimeAfterStartTime(startTime, endTime) {
    const start = new Date(startTime);
    const end = new Date(endTime);
    return end > start;
  }

  selectActivityType(type) {
    this.selectedActivityType = type;
    this.aptEventTitle = this.selectedActivityType?.name;
  }

  onReadyDes(editor) {
    editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
  }

  transformPrice(_event, field) {
    /**
     * Formats the price fields by adding commas as thousand separators.
     *
     * This function checks the specified field and formats its value by adding commas.
     * For the 'rentalPerWeek' field, a dollar sign is prefixed to the formatted value.
     *
     * @param event The event triggering the function.
     * @param field The field to format.
     */
    if (field === 'display_price' || field === 'value' || field === 'amount_inclusive_of_gst' || field === 'soldPrice' || field === 'rentalPerWeek') {
      // Retrieve the value from the specified field.
      let value = this.editProperty.get(field).value;

      // Remove all non-digit characters and add commas as thousand separators.
      let comma = value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      // If the field is 'rentalPerWeek', prepend a dollar sign to the formatted value.
      if (field === 'rentalPerWeek') {
        comma = '$' + comma;
      }

      // Update the form field with the formatted value.
      this.editProperty.patchValue({ [field]: comma });
    }
  }
  createNewProperty() {
    // Open the right sidebar for creating a new property
    // and add a new tab in the levels component with the name "Property"
    // and the id "createnew".
    this.lmService.addTabInLevels('Property', 'createnew');
    // Set the property_show_div variable to "add_property" to show the
    // add property form in the right sidebar.
    this.lmService.property_show_div = 'add_property';
    // Set the showRightBar variable to true to show the right sidebar.
    this.lmService.showRightBar = true;
  }

  editRecord(record) {
    this.openRightModal(record, 'edit_contact');
  }

  openRightModal(contact, addOrEdit) {
    if (addOrEdit === 'edit_contact') {
      let contact_id = contact?.contact?._id ? contact?.contact?._id : contact?._id;
      if (this.mobToggle == true) {
        this.router.navigate(['/setting/office-contact'], { queryParams: { id: contact_id } });
      } else {
        this.lmService.reload_add_contacts = false;
        let contacts = contact?.contact ? contact?.contact : contact;
        this.lmService.isEdit_show_div = addOrEdit;
        let name = contact?.contact?.full_name
          ? contact?.contact?.full_name
          : contact?.full_name
            ? contact?.full_name
            : contact?.name
              ? contact?.name
              : '';
        this.lmService.addTabInLevels(`Contact-${name}`, contact_id, contacts, {}, 'contact');
        this.lmService.contact_showRightBar = true;
        this.lmService.cont_id = contact_id;
        setTimeout(() => {
          this.lmService.reload_add_contacts = true;
        }, 500);
      }
    } else if (addOrEdit === 'add_contact') {
      if (this.mobToggle == true) {
        this.router.navigate(['/setting/office-contact'], { queryParams: { id: 'createnew' } });
      } else {
        this.lmService.contact_show_div = addOrEdit;
        this.lmService.addTabInLevels('Contact', 'createnew', null, {}, 'contact');
        // this.lmService.showRightBar = true;
        this.lmService.cont_id = null;
      }
    } else if (addOrEdit === 'add_leads') {
      if (this.mobToggle == true) {
        this.router.navigate(['/leads'], { queryParams: { id: 'createnew' } });
      } else {
        this.lmService.contract_show_div = addOrEdit;
        this.lmService.addTabInLevels('Lead', 'createnew', null);
      }
    } else if (addOrEdit === 'edit_leads') {
      this.editLead(contact);
    } else if (addOrEdit === 'add_contract') {
      if (this.mobToggle == true) {
        this.router.navigate(['/contracts'], { queryParams: { id: 'createnew' } });
      } else {
        setTimeout(() => {
          this.lmService.contract_show_div = addOrEdit;
          this.lmService.addTabInLevels('Contract', null, null);
          this.lmService.propertyId = this.property_id ? this.property_id : this.insertedPropertyId;
          this.lmService.contractId = null;
          this.lmService.isListingContract = true;
          this.isImg = false;
          this.isDocuments = false;
        }, 50);
        // }
      }
    } else if (addOrEdit == 'edit_contract') {
      if (
        this.userPermission.includes('contract.manage') ||
        this.userPermission.includes('contract.edit') ||
        this.userRole === 'administrators' ||
        this.userRole == 'master admin'
      ) {
        if (this.mobToggle == true) {
          this.router.navigate(['/contracts'], { queryParams: { id: contact?._id } });
        } else {
          let name: any;
          this.lmService.contract_show_div = addOrEdit;
          if (contact?.buyer) {
            name = contact?.buyer[0];
          }
          let street =
            contact?.street_no && contact?.street_name
              ? contact?.street_no + ' ' + contact?.street_name
              : contact?.street_no
                ? contact?.street_no
                : contact?.street_name
                  ? contact?.street_name
                  : '';
          let exactName = name ? name : '';
          this.lmService.addTabInLevels('Contract' + ' - ' + exactName + ' - ' + street, contact?._id, contact);
          this.lmService.contractId = contact?._id;
          this.lmService.propertyId = null;
          // this.lmService.showRightBar = true;
          this.isImg = false;
          this.isDocuments = false;
        }
      } else {
        this.toast.error('Access denied');
      }
    } else if (addOrEdit === 'edit_property') {
      let id = this.select_property_id ? this.select_property_id : this.select_id;
      if (this.mobToggle == true) {
        this.router.navigate(['/property/properties'], { queryParams: { id: id } });
      } else {
        this.isImg = false;
        this.isDocuments = false;
        this.lmService.property_show_div = addOrEdit;
        this.lmService.addTabInLevels('Property' + ' - ' + contact, id);
      }
    }
  }
  changeStatus(taskId: number, statusId: number) {
    /**
     * Change the status of a task and handle the response.
     *
     * @param {number} taskId - The ID of the task to change status for.
     * @param {number} statusId - The new status ID to set for the task.
     */
    this._taskService.changeTaskStatus(taskId, statusId).subscribe({
      next: () => {
        // Notify the user of a successful status change
        this.toast.success('Task status has changed');
        // Refresh the task list to reflect the updated status
        this.getTasks();
      },
      error: error => {
        // Capture errors and display appropriate error messages
        this.error = Array.of(error.error.errors);
        if (error.message && error.status_code !== 500) {
          // Display specific error message if available
          this.toast.error(this.error, error.error.message);
        } else {
          // Display a generic error message for server errors
          this.toast.error('Something wrong with the form. Please check and try again.');
        }
      },
    });
  }

  contactSelection(element) {
    this.full_attach_contact = element;
    this.queryParams.property_id = this.selectedProperty?._id ? this.selectedProperty?._id : this.insertedPropertyId;
    this.queryParams.contact_id = element;
  }

  deleteAttachedContact(id) {
    this.remmiConfirm
      .delete({ title: 'Remove Contact?', message: 'This contact will be removed from this listing.', confirmLabel: 'Remove' })
      .subscribe(isConfirmed => isConfirmed && this.deleteContactNow(id));
  }
  deleteContactNow(id) {
    /**
     * Deletes the contact from the listing.
     *
     * This function sends a DELETE request to remove the contact associated with the
     * property and refreshes the attached contacts and history upon success.
     */
    this._staffContactService.deleteAssociatedListingContactByUserId(id).subscribe({
      next: () => {
        // Refresh the list of attached contacts
        this.getAttachedContacts();

        // Refresh the history records
        this.message.getModuleHistory(true);

        // Display success message
        this.toast.success('Contact deleted successfully');
      },
    });
  }

  isAssociateDisable: boolean = false;
  attachContact() {
    this.isAssociateDisable = true;
    let prop_id = this.selectedProperty?._id ? this.selectedProperty?._id : this.insertedPropertyId;
    if (prop_id) {
      if (!this.queryParams.contact_id) {
        this.toast.error('Please select contact first');
        this.isAssociateDisable = false;
        // return;
      } else {
        let findContact = this.attached_contacts?.find(item => item?.contact?._id == this.full_attach_contact);
        if (findContact) {
          this.toast.error('Contact is already associate to this property');
          this.isAssociateDisable = false;
          // as" + ' ' + findContact?.type
          return;
        } else {
          this.queryParams.type = [];
          this._staffContactService.associateContactWithListingProperty(this.queryParams).subscribe({
            next: () => {
              this.selectedRelatedContact = null;
              this.message.sendMessage({
                isClearItems: true,
              });
              this.queryParams = {};
              this.queryParams.type = 'Buyer';
              this.toast.success('Contact attached successfully');
              this.isAssociateDisable = false;
              this.getAttachedContacts();
              this.message.getModuleHistory(true);
            },
          });
        }
      }
    } else {
      this.toast.error('First create listing');
      this.isAssociateDisable = true;
    }
  }
  sortField: string | null = null;
  sortOrder = 1;
  sortData(field: string) {
    /**
     * Sort the attached contacts by the specified field.
     *
     * @param field The field to sort by.
     */
    /**
     * Sort the array in ascending or descending order based on the sortOrder.
     *
     * @param a The first element to compare.
     * @param b The second element to compare.
     * @returns The result of the comparison.
     */
    const compare = (a: any, b: any) => (a[field] > b[field] ? this.sortOrder : -this.sortOrder);
    this.attached_contacts.sort(compare);
  }

  sortLead(field) {
    console.log('field >>', field);
    console.log('all_leads >>', this.all_leads);
  }

  all_leads: any[] = [];
  getAttachedLeads(
    page = 1,
    per_page = 30,
    listing = this.property_id || this.insertedPropertyId,
    project = this.editProperty.controls['related_to_project'].value || null
  ) {
    /**
     * Get all leads
     *
     * Get all the leads associated with the property. The request is paginated
     * and the page number and number of records per page can be specified.
     *
     * The parameters are:
     *
     * - listing_or_project: An array of two strings. The first string is the ID of the
     *   property, and the second string is the ID of the project.
     * - project: The ID of the project (not used)
     * - listing: The ID of the property (not used)
     * - keyword: A keyword to search for in the leads (not used)
     * - filter: An array of filters. Each filter is an object with the following
     *   properties:
     *   - name: The name of the filter
     *   - value: The value of the filter
     *   - operator: The operator to use for the filter
     * - lead_type: The type of lead (not used)
     * - status_type: The status type of the lead (not used)
     * - lead_status: The status of the lead (not used)
     * - agent_responsible: The agent responsible for the lead (not used)
     * - min_beds: The minimum number of bedrooms (not used)
     * - max_beds: The maximum number of bedrooms (not used)
     * - min_price: The minimum price (not used)
     * - max_price: The maximum price (not used)
     * - price_range: The price range (not used)
     * - time_frame: The time frame (not used)
     * - is_active: Whether the lead is active or not (not used)
     */

    // One id, never both: a listing associated with a project has its leads raised against that
    // project, a listing with no project against itself.
    let records = [project || listing].filter(item => item !== null && item !== undefined);
    let cols = [
      'listing_project',
      'first_name',
      'last_name',
      'full_name',
      'email',
      'mobile_phone',
      'lead_status',
      'lead_source',
      'status_type',
      'agent_responsible',
      'created_at',
    ];
    let payload = {
      office_id: this.api.getOfficeId(),
      listing_or_project: records,
      columns: cols,
      page: page,
      per_page: per_page,
      sort_order: { field: '_id', sort_order: false },
      lot_id: this.residentialLotIds(),
    };
    this._leadsService.getAllNewLeads(payload).subscribe({
      next: response => {
        this.all_leads = response?.data;
      },
    });
  }

  /** The listing's own lot, as the leads API wants it: an array, empty when there is none. */
  residentialLotIds(): string[] {
    const lot = this.editProperty.controls['residential_project_lot'].value;
    return lot ? [lot] : [];
  }

  getAttachedContacts() {
    /**
     * Get attached contacts
     *
     * Get the contacts associated with the property
     *
     * If the contact has a type, then add it to the list of contacts
     * sorted by type. If the contact does not have a type, then add
     * it to the list of contacts that do not have a type.
     *
     * For each contact, check if the contact's email is already in the
     * list of attendees. If it is not, then add it to the list of
     * attendees.
     */
    this.attached_contacts = [];
    let prop_id = this.selectedProperty?._id ? this.selectedProperty?._id : this.insertedPropertyId;
    this._staffContactService.getAssociatedContactListByListingId(prop_id).subscribe(res => {
      const type_exist = res?.data?.filter(con => con?.type?.length > 0);
      const no_type_exist = res?.data?.filter(con => !con?.type?.length);
      this.attached_contacts = [...type_exist.sort((a, b) => a?.type?.toString().localeCompare(b?.type?.toString())), ...no_type_exist];
      this.attached_contacts?.forEach(itm => {
        if (!this.insertEvent.attendees.includes(itm.contact.email)) this.insertEvent.attendees.push(itm.contact.email);
      });
    });
  }

  addNewAppointment() {
    /**
     * Add new appointment
     *
     * If the user is a master admin, then add the master admin as an assignee
     * to the appointment.
     */
    this.addNewApt = true;
    if (this.AuthUser.role == 'administrators' || this.AuthUser.role == 'Operations Manager' || this.AuthUser.role == 'Master Admin') {
      // Push the master admin as an assignee to the appointment
      this.originalAssignsAppt.push({
        _id: this.AuthUser._id,
        full_name: this.AuthUser.full_name,
      });
      // Set the agent of the appointment to the master admin
      this.insertEvent['agent'] = [this.AuthUser._id];
    } else {
      // Set the agent of the appointment to the current user
      this.insertEvent['agent'] = [this.AuthUser._id];
    }
  }

  editingApt = null;
  editAppointment(apt) {
    this.editingApt = apt;
    this.addNewApt = true;
    this.selectedActivityType = this.contactMethods
      .filter(n => {
        return n.name.toLocaleLowerCase() == apt.type.toLocaleLowerCase();
      })
      .shift();
    this.selectedContactType = this.contactMethods
      .filter(n => {
        return n.name.toLocaleLowerCase() == apt.type.toLocaleLowerCase();
      })
      .shift();
    this.aptEventTitle = apt.title;
    this.insertEvent = {
      attendees: apt.event.attendees,
      location: apt.event.location,
      description: apt.event.description,
      availablebusy: apt.event.availablebusy,
      availability: apt.event.availability,
      visibility: apt.event.availability,
      startdate: null,
      enddate: null,
      starttime: null,
      endtime: null,
      agent: null,
    };
    this.insertEvent.attendees = [];

    const dt = new Date(toWallClock(apt?.event?.start?.dateTime));
    const dt2 = new Date(toWallClock(apt?.event?.end?.dateTime));
    this.insertEvent['startdate'] = new Date(toWallClock(apt?.event?.start?.dateTime));
    this.insertEvent['enddate'] = new Date(toWallClock(apt?.event?.end?.dateTime));
    this.insertEvent['starttime'] = dt;
    this.insertEvent['endtime'] = dt2;
  }
  cancelAppointment() {
    this.addNewApt = false;
    this.insertEvent2 = { ...this.insertEvent2 };
    this.editingApt = null;
  }
  deleteAppointment(itm, type = null) {
    this.remmiConfirm
      .delete({ title: 'Delete Appointment?', message: 'This appointment will be removed from the calendar.' })
      .subscribe(isConfirmed => isConfirmed && this.removeAppointment(itm, type));
  }

  private removeAppointment(itm, type = null) {
    /**
     * Delete a calendar entry: either one of our own appointments or a synced Google event.
     * @param {object} itm The entry to delete.
     * @param {string} type Pass `'apt'` for one of our appointments; omit it for a Google event.
     */
    let query = {};
    if (type) {
      // One of our appointments, so delete it by its own ID
      query = { user_id: this.AuthUser._id, itm: itm, appt_id: itm?._id };
    } else {
      // A Google event, so delete it by its calendar event ID
      query = { user_id: this.AuthUser._id, itm: itm, event_id: itm?.id };
    }

    this._CalendarAPIService.removeCalendarById(query).subscribe({
      next: () => {
        this.toast.success('Event removed successfully');
        // Reload the appointments for the selected property
        this.fetchApts(this.selectedProperty);
      },
    });
  }

  isLoad: boolean = false;

  addNewTask(task, new_or_edit) {
    /**
     * Navigate to the new task page if the task is new or edit task page if the task exists.
     * @param {boolean} new_or_edit - Whether this is a new task or an existing one.
     * @param {any} task - The task object.
     */
    this.lmService.is_new_task = true;
    if (this.mobToggle) {
      const taskId = new_or_edit ? 'createnew' : task?._id;
      this.router.navigate(['/tasks/all-tasks'], { queryParams: { id: taskId } });
    }
    // Add a new tab in the levels if the task is new
    if (new_or_edit == true) {
      this.lmService.addTabInLevels('Task', this.property_id, null, { extra: 'Property' });
    }
    // Add a new tab in the levels if the task exists
    else if (new_or_edit == false) {
      this.lmService.addTabInLevels(`Task:` + ' REM-' + task?.id, task?._id, task);
    }
  }

  newLead(isNew) {
    /**
     * Emits the new lead information to the parent component.
     * @param {boolean} isNew - Whether this is a new lead or an existing one.
     */
    this.NewLeadInformation.emit({ addDefaults: this.addDefaults });
    // Set the default values for a new lead
    this.addDefaults.property = this.selectedProperty?._id;
    this.addDefaults.listing = this.selectedProperty?._id;
    this.addDefaults.listing_type = this.selectedProperty?.type;
    this.addDefaults.value = this.selectedProperty?.value;
    this.addDefaults.beds = this.selectedProperty?.beds;
    this.addDefaults.baths = this.selectedProperty?.baths;
    this.addDefaults.pools = this.selectedProperty?.pools;
    this.addDefaults.external_area = this.selectedProperty?.land_area;
    this.addDefaults.internal_size = this.selectedProperty?.building_area;
    this.addDefaults.agent_responsible = this.selectedProperty?.agent;
    this.addDefaults.lead_status = 'New';

    // A listing that belongs to a project raises its leads against that project — the same rule the
    // lead query follows. Only a listing with no project opens on the Listing purpose.
    const listingProject = this.editProperty.controls['related_to_project'].value;
    this.addDefaults.project = listingProject || null;
    this.addDefaults.lead_create = listingProject ? 'project' : 'listing';

    // The lot only comes along where the project is the one that keeps lots.
    const lotId = this.editProperty.controls['residential_project_lot'].value;
    const isLotProject = !!listingProject && listingProject === this.residentialLotProjectId && !!lotId;
    this.addDefaults.residential_project_lot = isLotProject ? lotId : null;
    this.addDefaults.residential_project_lot_name = isLotProject ? this.residentialLotName : null;
    if (isNew == true && !this.mobToggle) {
      // Add the lead to the levels
      this.lmService.addTabInLevels('Lead', this.api.getOfficeId(), null, { extra: 'Lead' });
    } else {
      // Navigate to the leads page
      this.router.navigate(['/leads'], { queryParams: { id: 'createnew' } });
    }
  }

  drop(event: CdkDragDrop<any[]>, task) {
    /**
     * Handles the event of dragging and dropping a tag onto a contact.
     * If the tag is already associated to the contact, show an error message.
     * If the tag is not already associated, add it to the contact's tags.
     * If the tag is moved within the contact's tags, move it to the new position.
     * @param event - The drag and drop event.
     * @param task - The task to which the tag is being added.
     */
    if (task.type) {
      this.contact_to_update = task.type;
    } else {
      this.contact_to_update = [];
    }
    if (task?.type?.includes(event.item.data)) {
      this.toast.error('Tag is already associate to this contact');
      return;
    } else {
      if (event.previousContainer === event.container) {
        moveItemInArray(this.contact_to_update, event.previousIndex, event.currentIndex);
      } else {
        this.addField(event.item.data, event.currentIndex, task);
      }
    }
  }

  addField(fieldType: string, index: number, task) {
    this.contact_to_update?.splice(index, 0, fieldType);
    this.updateAssociatedContactStatus(task);
  }

  updateAssociatedContactStatus(contact) {
    /**
     * Updates the contact type for a specific task and refreshes related data.
     *
     * @param contact The contact containing the contact to update.
     */
    this._staffContactService.updateAssociatedContactStatusById(contact?._id, { type: this.contact_to_update }).subscribe({
      next: res => {
        // Check if the updated contact type includes 'seller solicitor' and perform additional actions if true
        if (this.contact_to_update?.toString()?.toLowerCase()?.includes('seller solicitor')) {
          this.existEditProperty();
        }
        // Display success message
        this.toast.success(res.message);
        // Clear the contact update type and refresh cached data
        this.contact_to_update = [];
        // Fetch updated attached contacts and history
        this.getAttachedContacts();
        this.message.getModuleHistory(true);
      },
      error: error => {
        // Display error message on failure
        this.toast.error(error.error.message);
      },
    });
  }
  removeTag(tag, task) {
    this.remmiConfirm
      .ask({
        title: 'Remove Tag?',
        message: 'This tag will be removed from the contact straight away.',
        subject: tag,
        confirmLabel: 'Remove',
        tone: 'warning',
      })
      .subscribe(isConfirmed => {
        if (!isConfirmed) {
          this.getAttachedContacts();
          return;
        }
        this.contact_to_update = task?.type?.filter(item => item !== tag);
        setTimeout(() => {
          this.updateAssociatedContactStatus(task);
        }, 50);
      });
  }
  openContactPopup(contact) {
    this.openRightModal({ contact: contact }, 'edit_contact');
  }

  getConnectedTo() {
    /**
     * Gets the list of connected contacts (i.e., the contacts that are attached to the current property)
     * and returns them as an array of strings, where each string is prefixed with "s_" and contains the contact's _id.
     * This is used to filter out the connected contacts from the list of all contacts.
     * @returns {string[]} An array of strings, where each string represents a connected contact.
     */
    if (this.attached_contacts?.length) {
      const myArr = [...this?.attached_contacts];
      const mee = myArr.map(a => 's_' + a._id.toString());
      return mee;
    }
  }
  gsuiteLogin() {
    /**
     * Opens a new window to initiate Google authentication and polls for URL changes.
     * Closes the window and fetches events when authentication is complete.
     */
    var win = window.open(this.googleAuthUrl, 'windowname1', 'width=800, height=600');

    // Polling interval to check if the redirected URL indicates successful authentication
    var pollTimer = setInterval(() => {
      try {
        // Check if the window's URL has changed to a known post-authentication path
        if (win.document.URL.indexOf('api/v1/google/redirect') !== -1 || win.document.URL.indexOf('leads/lead-overview-board') !== -1) {
          // Stop polling and mark the email as connected
          clearInterval(pollTimer);
          this.emailConnected = true;
          // Close the authentication window
          win.close();
          // Fetch events for the selected property
          this.fetchEvents(this.selectedProperty);
        }
      } catch (e) {
        // Catch and silently handle any cross-origin errors
      }
    }, 100);
  }

  isSameWeek(dates) {
    /**
     * Determines if all dates in the array fall within the same week.
     * @param {Date[]} dates - The array of dates to evaluate.
     * @returns {boolean} A boolean indicating if all dates are in the same week.
     */
    var minAndMax = this.getMinAndMax(dates),
      dayOfWeek = {};
    dayOfWeek['min'] = minAndMax['min'].getDay();
    dayOfWeek['max'] = minAndMax['max'].getDay();
    if (
      // If the difference between the maximum and minimum dates is greater than 6 days.
      minAndMax['max'] - minAndMax['min'] > 518400000 ||
      // If the day of the week for the minimum date is greater than the day of the week for the maximum date.
      dayOfWeek['min'] > dayOfWeek['max']
    ) {
      return false;
    }
    return true;
  }
  getMinAndMax(dates) {
    /**
     * Determines the minimum and maximum dates from an array of dates.
     * @param {Date[]} dates - The array of dates to evaluate.
     * @returns {object} An object containing the minimum and maximum dates.
     */
    var result = {};
    for (var index in dates) {
      var fullDate = dates[index];
      // Update max date if the current date is greater than the current max
      if (!result['max'] || fullDate > result['max']) {
        result['max'] = fullDate;
      }
      // Update min date if the current date is less than the current min
      if (!result['min'] || fullDate < result['min']) {
        result['min'] = fullDate;
      }
    }
    return result;
  }

  addDays(date, days) {
    /**
     * Adds the specified number of days to the given date.
     * @param {Date} date The date to add days to.
     * @param {number} days The number of days to add.
     * @returns {Date} The new date with the days added.
     */
    // Create a copy of the original date to avoid modifying it
    const copy = new Date(Number(date));
    // Add the specified number of days to the copy
    copy.setDate(date.getDate() + days);
    // Return the new date
    return copy;
  }

  isNextWeek(date) {
    /**
     * Checks if the given date is in the next week.
     * @param {Date|string} date The date to check. Can be a Date object or a string in the ISO 8601 format.
     * @returns {boolean} True if the date is in the next week, otherwise false.
     */
    var minAndMax = this.thisWeekMinMax(); // Get the current week's min and max dates
    const newMinDate = this.addDays(minAndMax['min'], this.weeks); // Calculate the minimum date for the next week
    const newMaxDate = this.addDays(minAndMax['max'], this.weeks); // Calculate the maximum date for the next week
    if (new Date(date) > new Date(newMinDate) && new Date(date) < new Date(newMaxDate)) {
      return true;
    }
  }
  isPrevWeek(date) {
    /**
     * Checks if the given date is in the previous week.
     * @param date The date to check.
     * @returns {boolean} True if the date is in the previous week, otherwise false.
     */
    var minAndMax = this.thisWeekMinMax(); // Get the current week's min and max dates
    const newMinDate = this.addDays(minAndMax['min'], this.weeks); // Calculate the minimum date for the previous week
    const newMaxDate = this.addDays(minAndMax['max'], this.weeks); // Calculate the maximum date for the previous week
    if (new Date(date) > new Date(newMinDate) && new Date(date) < new Date(newMaxDate)) {
      return true; // Date is within the previous week
    }
    return false; // Date is not within the previous week
  }

  thisWeekMinMax() {
    /**
     * Gets the minimum and maximum dates for the current week.
     * @returns {object} Object with min and max properties containing the minimum and maximum dates for the current week.
     */
    var result = {};
    var current = new Date();
    // Get the first day of the week (Monday)
    var weekStart = current.getDate() - current.getDay() + 1;
    // Get the last day of the week (Sunday)
    var weekend = weekStart + 6;
    // Get the Monday and Sunday dates for the current week
    var monday = new Date(current.setDate(weekStart));
    var sunday = new Date(current.setDate(weekend));
    // Set the minimum and maximum dates for the current week
    result['min'] = monday;
    result['max'] = sunday;
    return result;
  }

  calendarOptions() {
    this.optional = {
      firstDay: 1,
      initialView: 'timeGridWeek',
      initialDate: new Date(),
      headerToolbar: {
        left: 'prev,next',
        center: 'title',
        right: '',
      },
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, rrulePlugin],
      nowIndicator: true,
      expandRows: true,
      now: new Date(),
      events: [],
      editable: false,
      selectable: false,
      selectMirror: false,
      slotDuration: '01:00:00',
      scrollTime: '08:00:00',
      dayHeaderFormat: { day: 'numeric', weekday: 'short', omitCommas: true },
      titleFormat: { year: 'numeric', month: 'long' },
      dayMaxEvents: true,
      // eventMouseEnter: event => this.eventMouseOver(event),
      // eventMouseLeave: event => (this.pop_title = ''),
      eventClick: event => {
        console.log('eve_eve:', event);
        this.event_popup = true;
        this.event_popup_detail = event.event.extendedProps;
        console.log('eve_del:', this.event_popup_detail);
        let creator_name = '';
        let findCreator = this.originalAssigns.filter(item => item._id == this.event_popup_detail?.extendedProperties?.private?.user_id);
        if (findCreator && findCreator.length > 0) {
          this.event_popup_detail.creator.full_name = findCreator[0].full_name;
        } else {
          this.event_popup_detail.creator.full_name = creator_name;
        }
      },
      eventContent: (arg: any) => {
        const viewType = arg.view.type; // e.g., 'dayGridMonth', 'timeGridWeek', etc.
        if (viewType === 'dayGridMonth') {
          // --- Month View Styling ---
          const eventTime = arg.event.extendedProps.start_time || '';
          const titleText = `${eventTime} ${arg.event.title}`;

          const container = document.createElement('div');
          container.classList.add('custom-month-event');

          const dot = document.createElement('span');
          dot.classList.add('event-dot');
          dot.style.backgroundColor = arg.backgroundColor || '#229276';

          const title = document.createElement('span');
          title.classList.add('event-title');
          title.innerText = titleText;
          container.appendChild(dot);
          container.appendChild(title);
          return { domNodes: [container] };
        }

        // --- Default rendering for week/day views ---
        const title = document.createElement('div');
        title.innerText = arg.event.title;
        title.classList.add('fc-event-title-truncate');

        const time = document.createElement('div');
        time.innerText = arg.event.extendedProps.time;
        time.classList.add('fc-event-time');

        const container = document.createElement('div');
        container.appendChild(title);
        container.appendChild(time);

        return { domNodes: [container] };
      },
      eventMouseEnter: info => {
        const tooltip = document.createElement('div');
        tooltip.innerHTML = info.event.title;
        tooltip.className = 'fc-tooltip'; // Custom class
        tooltip.style.position = 'absolute';
        tooltip.style.top = `${info.jsEvent.pageY + 10}px`;
        tooltip.style.left = `${info.jsEvent.pageX + 10}px`;
        tooltip.style.background = '#229276';
        tooltip.style.color = '#fff';
        tooltip.style.padding = '5px 10px';
        tooltip.style.borderRadius = '4px';
        tooltip.style.zIndex = '1000';
        document.body.appendChild(tooltip);
        info.el.setAttribute('data-tooltip-id', tooltip.id);
      },
      eventMouseLeave: () => {
        const tooltip = document.querySelector('.fc-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      },

      moreLinkClick: () => {
        const parentPopup = document.querySelectorAll('.fc-popover');
        if (parentPopup.length > 0) {
          for (let i = 0; i < parentPopup.length; i++) {
            parentPopup[i].remove();
            const calendarApi = this.fullcalendar?.getApi();
            if (calendarApi) {
              calendarApi.refetchEvents();
            }
          }
        }

        setTimeout(() => {
          // Changes for more link popup show
          const popoverBody = document.querySelector('.fc-popover-body');

          if (popoverBody) {
            // Select all event titles inside the popover
            const eventNodes = popoverBody.querySelectorAll('.fc-daygrid-event');
            eventNodes.forEach(node => {
              const timeElement = node.querySelector('.fc-event-time');
              const titleElement = node.querySelector('.fc-event-title');
              // Clean time format
              if (timeElement) {
                let timeText = timeElement.textContent || '';
                if (timeText.match(/^\d+a$/)) {
                  timeText = timeText.replace(/a$/, 'am');
                } else if (timeText.match(/^\d+p$/)) {
                  timeText = timeText.replace(/p$/, 'pm');
                }
                timeElement.textContent = timeText;
              }
              // Remove unnecessary ID from the title
              if (titleElement) {
                let titleText = titleElement.textContent || '';
                titleText = titleText.replace(/\s\|\s\(\{[^\}]+\}\)/, ''); // Remove ID pattern
                titleElement.textContent = titleText;
              }
            });
          }

          // For closing the more link popup button
          const closeButton = document.querySelector('.fc-popover-close');
          if (closeButton) {
            closeButton.addEventListener('click', () => {
              const parentPopup = document.querySelector('.fc-popover');
              if (parentPopup) {
                parentPopup.remove(); // Remove parent popup
                const calendarApi = this.fullcalendar?.getApi();
                if (calendarApi) {
                  calendarApi.refetchEvents();
                }
              }
            });
          }
        }, 10); // Ensure DOM is updated
      },

      dayMaxEventRows: true, // for all non-TimeGrid views
      views: {
        timeGrid: {
          dayMaxEventRows: 1, // adjust to 6 only for timeGridWeek/timeGridDay
        },
      },
    };
  }

  activePopup: any = null;

  eventsCopy: any[];
  eventsCopy2: any[];
  days = 0;
  months = 0;
  weeks = 0;
  nextList() {
    // Increase the day, month, and week counters
    this.days++;
    this.months++;
    this.weeks += 7;

    // Get the current date
    let date1 = new Date();

    // Filter events based on the selected calendar view and the updated counters
    this.time_hour.events.items = this.eventsCopy.filter(itm => {
      // Get the event date
      let t = new Date(itm.start.dateTime);

      // Check if the event falls within the selected calendar view
      switch (this.cal_view_list) {
        case 'timeGridDay':
          // Check if the event date matches the current date plus the day counter
          return t.getDate() === date1.getDate() + this.days;
          break;
        case 'timeGridWeek':
          // Check if the event falls within the next week
          return this.isNextWeek(t);
          break;
        case 'dayGridMonth':
          // Check if the event month matches the current month plus the month counter
          return t.getMonth() === date1.getMonth() + this.months;
          break;
      }
    });
  }

  prevList() {
    // Decrease the day, month, and week counters
    this.days--;
    this.months--;
    this.weeks -= 7;

    // Get the current date
    let date1 = new Date();

    // Filter events based on the selected calendar view and the updated counters
    this.time_hour.events.items = this.eventsCopy.filter(itm => {
      // Get the event date
      let t = new Date(itm.start.dateTime);

      // Check if the event falls within the selected calendar view
      switch (this.cal_view_list) {
        case 'timeGridDay':
          // Check if the event date matches the current date minus the day counter
          return t.getDate() - this.days === date1.getDate();
          break;
        case 'timeGridWeek':
          // Check if the event falls within the previous week
          return this.isPrevWeek(t);
          break;
        case 'dayGridMonth':
          // Check if the event month matches the current month minus the month counter
          return t.getMonth() - this.months === date1.getMonth();
          break;
      }
    });
  }
  changeViewList() {
    /**
     * Resets the time view filters and updates the events to display based on the current calendar view.
     */
    this.days = 0;
    this.months = 0;
    this.weeks = 0;
    let date1 = new Date();

    // Filter events based on the selected calendar view
    this.time_hour.events.items = this.eventsCopy.filter(itm => {
      let t = new Date(itm.start.dateTime);
      switch (this.cal_view_list) {
        case 'timeGridDay':
          // Check if the event date matches the current date
          return t.getDate() === date1.getDate();
        case 'timeGridWeek':
          // Check if the event falls within the current week
          return this.isSameWeek([t, date1]);
        case 'dayGridMonth':
          // Check if the event month matches the current month
          return t.getMonth() === date1.getMonth();
      }
    });
  }

  isGridView(view) {
    this.default_view = view;
  }
  eventMouseOver(event) {
    /**
     * Shows the popup when the user hovers over an event on the calendar.
     * @param event The full calendar event object.
     */
    if (
      // Check if the target element is an event on the calendar
      event.jsEvent.target.className.includes('fc-timegrid-event') ||
      event.jsEvent.target.className.includes('fc-event-main') ||
      event.jsEvent.target.className.includes('fc-daygrid-event')
    ) {
      // Set the title of the popup to the event title
      this.pop_title = event?.jsEvent?.target?.innerText;

      // Calculate the position of the popup
      let docWidth = $(document).width();
      this.divPos = {
        left:
          // If the popup would go off the right edge of the screen, move it to the left edge
          event?.jsEvent.clientX + 350 >= docWidth ? docWidth - 380 : event?.jsEvent.clientX,
        top: event?.jsEvent.clientY,
      };

      // Set the style of the popup to the calculated position
      $('.pop-ov').css({ top: this.divPos['top'], left: this.divPos['left'] });
    } else {
      // If the target element is not an event, return
      return;
    }
  }

  getConfirm(_event: Event, gEvent) {
    this.remmiConfirm
      .delete({ title: 'Delete Event?', message: 'This Google Calendar event will be removed.' })
      .subscribe(isConfirmed => isConfirmed && this.removeAppointment(gEvent));
  }
  editLead(lead) {
    if (
      lead.agent_responsible != this.AuthUser.full_name &&
      this.AuthUser?.role !== 'administrators' &&
      this.AuthUser?.role !== 'Operations Manager' &&
      this.AuthUser.role !== 'Master Admin'
    ) {
      return false;
    } else {
      if (this.mobToggle == true) {
        this.router.navigate(['/leads'], { queryParams: { id: lead?._id } });
      } else {
        this.lmService.addTabInLevels('Lead' + ' - ' + lead?.first_name + ' ' + lead?.last_name, lead?._id, lead, null, 'lead');
      }
    }
  }

  removeAssignment(lead) {
    /**
     * Checks if the current user has the right to remove the assignment of a lead to a property.
     * If the user is not the agent responsible, not an Operations Manager and not a Master Admin, the function returns false.
     * If the user has the right, the function sends a request to the API to remove the assignment and handles the response.
     *
     * @param lead - The lead object containing the lead ID to be removed from the property assignment.
     */
    if (
      lead.agent != this.AuthUser._id &&
      this.AuthUser?.role !== 'administrators' &&
      this.AuthUser.role !== 'Operations Manager' &&
      this.AuthUser.role !== 'Master Admin'
    )
      return false;
    this.remmiConfirm
      .delete({
        title: 'Remove From Listing?',
        message: 'This lead will no longer be assigned to this listing.',
        subject: [lead?.first_name, lead?.last_name].filter(Boolean).join(' '),
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (!isConfirmed) return;
        this._leadsService.getAssignment(lead._id, 'property').subscribe({
          next: (response: any) => {
            this.getAttachedLeads();
            this.toast.success(response?.message);
          },
        });
      });
  }

  duplicateRecords(lead) {
    /**
     * Duplicates a lead by sending a request to the API and handles the response.
     *
     * @param lead - The lead object containing the lead ID to be duplicated.
     */
    this._leadsService.createLeadDuplication(lead._id, { is_read: false }).subscribe({
      next: () => {
        // Handle successful duplication response
        this.toast.success('Duplicated!'); // Show success message
        this.getAttachedLeads();
      },
      // Handle error response
      error: () => {
        this.toast.error('Something has gone wrong'); // Show error message
      },
    });
  }

  libraryDataEmitter: [] = [];
  imageDisplayPath: String = '';

  GetLibraryData(event) {
    this.libraryDataEmitter = event;
  }

  imagesUploadErrorMessage = true;
  imgNotFoundList: any[] = [];
  imagesUploadError(event) {
    this.imgNotFoundList = event;
  }

  ActivateTabIndexByError(message: string) {
    /**
     * This function takes an error message and parses it to see if it matches a form control name.
     * If it does, it sets the active index to that of the control and scrolls it into view.
     * If the control is a popup modal, it will open the modal.
     * @param message - The error message
     */
    let space_serrated: string[] = message?.split(' ');
    if (space_serrated?.[0]?.trim()?.length > 0) {
      Object.keys(this.controls || {})?.forEach((key: string) => {
        if (key === space_serrated?.[0]?.trim()) {
          this.activeIndex = this.controls?.[key]?.tabIndex;
          if (key === 'rentalPerWeek') {
            key = 'property_status';
          }
          // Scroll the control into view after 500ms
          setTimeout(() => {
            const element = this.controls?.[key]?.elementRef.nativeElement.querySelector(`[formControlName="${space_serrated?.[0]?.trim()}"]`)
              ? this.controls?.[key]?.elementRef.nativeElement.querySelector(`[formControlName="${space_serrated?.[0]?.trim()}"]`)
              : this.controls?.[key]?.elementRef.nativeElement.querySelector(`[name="${space_serrated?.[0]?.trim()}"]`)
                ? this.controls?.[key]?.elementRef.nativeElement.querySelector(`[name="${space_serrated?.[0]?.trim()}"]`)
                : this.controls?.[key]?.elementRef.nativeElement.querySelector(`[id="${space_serrated?.[0]?.trim()}"]`);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }, 500);
        }
      });
    }
  }

  onChangeDomain(event) {
    /**
     * Handles the Domain toggle event and updates the property form accordingly.
     * If the form is invalid, disable the submit button and show an error message.
     * @param event - The DOM event triggered by the checkbox toggle action.
     */
    if (!this.editProperty.valid) {
      this.submitDisable = false;
      // Collect all fields with validation errors
      let fields: any = Object.entries(this.editProperty.controls)
        .reduce((acc, [key, value]) => {
          if (value.status === 'INVALID') {
            acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
          }
          return acc;
        }, [])
        ?.filter(error_field => error_field !== undefined && error_field !== null);

      // Validate fields and show an error message if there are invalid fields
      fields && this.validateFieldsOnRequest(fields);
      this.toast.error('Required fields must be filled in');
      return;
    }

    // Update the error state of the Domain field based on the checkbox state
    if (event?.target?.checked === false) {
      this.domain_error_set = false;
    }

    // Patch the form with the checkbox state
    this.editProperty.patchValue({
      isDomainCrm: event?.target?.checked,
    });
  }

  onChangeRea(event) {
    /**
     * Handles the REA toggle event and updates the property form accordingly.
     * If the form is invalid, disable the submit button and show an error message.
     * @param event - The DOM event triggered by the checkbox toggle action.
     */
    if (!this.editProperty.valid) {
      // Disable the submit button if the form is invalid
      this.submitDisable = false;

      // Collect all fields with validation errors
      let fields: any = Object.entries(this.editProperty.controls)
        .reduce((acc, [key, value]) => {
          if (value.status === 'INVALID') {
            acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
          }
          return acc;
        }, [])
        .filter(error_field => error_field !== undefined && error_field !== null);

      // Validate fields and show an error message if there are invalid fields
      fields && this.validateFieldsOnRequest(fields);
      this.toast.error('Required fields must be filled in');
      return;
    }

    // Update the REA error state based on the checkbox state
    if (event?.target?.checked === false) {
      this.rea_error_set = false;
    }

    // Patch the form with the checkbox state
    this.editProperty.patchValue({
      isReaCrm: event?.target?.checked,
    });
  }
  onChangeWp(event) {
    /**
     * Handles the WordPress toggle event and updates the property form accordingly.
     * If the form is invalid, disable the submit button and show an error message.
     * @param event - The DOM event triggered by the checkbox toggle action.
     */
    if (!this.editProperty.valid) {
      // Disable the submit button if the form is invalid
      this.submitDisable = false;
      // Collect all fields with validation errors
      const fields = Object.entries(this.editProperty.controls)
        .reduce((acc, [key, value]) => {
          if (value.status === 'INVALID') {
            acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
          }
          return acc;
        }, [])
        ?.filter(error_field => error_field !== undefined && error_field !== null);
      // Validate fields and show an error message if there are invalid fields
      fields && this.validateFieldsOnRequest(fields);
      this.toast.error('Required fields must be filled in');
      return;
    }
    // Update the error state of the WordPress field based on the checkbox state
    if (event?.target?.checked === false) {
      this.company_website_error_set = false;
    }
    // Patch the form with the checkbox state
    this.editProperty.patchValue({
      isWpPush: event?.target?.checked,
    });
  }
  onMarketPlace(event) {
    /**
     * Handles the market place toggle event and updates the property form accordingly.
     * If the form is invalid, disable the submit button and show an error message.
     * @param event - The DOM event triggered by the checkbox toggle action.
     */
    if (!this.editProperty.valid) {
      // Disable the submit button if the form is invalid
      this.submitDisable = false;

      // Collect all fields with validation errors
      let fields: any = Object.entries(this.editProperty.controls)
        .reduce((acc, [key, value]) => {
          if (value.status === 'INVALID') {
            acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
          }
          return acc;
        }, [])
        ?.filter(error_field => error_field !== undefined && error_field !== null);

      // Show an error message if there are any validation errors
      fields && this.validateFieldsOnRequest(fields);
      this.toast.error('Required fields must be filled in');
      return;
    }
    // Update the form with the new value
    if (event?.target?.checked === false) {
      this.market_place_error_set = false;
    }
    this.editProperty.patchValue({
      market_place: event?.target?.checked,
    });
  }
  onHomley(event) {
    /**
     * Handles the homely portal toggle event and updates the property form accordingly.
     * If the form is invalid, disable the submit button and show an error message.
     * @param event - The DOM event triggered by the checkbox toggle action.
     */
    if (!this.editProperty.valid) {
      // Disable the submit button if the form is invalid
      this.submitDisable = false;

      // Collect all fields with validation errors
      let fields: any = Object.entries(this.editProperty.controls)
        .reduce((acc, [key, value]) => {
          if (value.status === 'INVALID') {
            acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
          }
          return acc;
        }, [])
        .filter(error_field => error_field !== undefined && error_field !== null);

      // Validate fields and show an error message if there are invalid fields
      fields && this.validateFieldsOnRequest(fields);
      this.toast.error('Required fields must be filled in');
      return;
    }

    // Update the homely portal error state based on the checkbox state
    if (event?.target?.checked === false) {
      this.homely_error_set = false;
    }

    // Patch the form with the checkbox state
    this.editProperty.patchValue({
      homley_portal: event?.target?.checked,
    });
  }
  onRealEstateView(event) {
    /**
     * Handles the real estate view toggle event and updates the property form accordingly.
     * @param event - The DOM event triggered by the checkbox toggle action.
     */
    if (!this.editProperty.valid) {
      // Disable the submit button if the form is invalid
      this.submitDisable = false;

      // Collect all fields with validation errors
      let fields: any = Object.entries(this.editProperty.controls)
        .reduce((acc, [key, value]) => {
          if (value.status === 'INVALID') {
            acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
          }
          return acc;
        }, [])
        .filter(error_field => error_field !== undefined && error_field !== null);

      // Validate fields and show an error message if there are invalid fields
      fields && this.validateFieldsOnRequest(fields);
      this.toast.error('Required fields must be filled in');
      return;
    }

    // Update the real estate view error state based on the checkbox state
    if (event?.target?.checked === false) {
      this.real_estate_view_error_set = false;
    }

    // Patch the form with the checkbox state
    this.editProperty.patchValue({
      real_estate_view: event?.target?.checked,
    });
  }

  getTimeFormat(dateTime) {
    return moment(toWallClock(dateTime)).format('hh:mm a');
  }

  getTimed(date: Date) {
    /**
     * Formats a given date object into a human-readable time string.
     * @param date The date object to format.
     * @returns A formatted time string in the format 'h:mm am/pm'.
     */
    const parsedDatetime = new Date(date);
    // Transform the date to extract the hour in 12-hour format.
    let formattedTime = this.datePipe.transform(parsedDatetime, 'h');

    // Get the minutes from the parsed date.
    const minutes = parsedDatetime.getMinutes();
    // Append minutes to the formatted time, ensuring two digits.
    if (minutes !== 0) {
      formattedTime += ':' + ('0' + minutes).slice(-2);
    } else {
      formattedTime += ':' + '00';
    }

    // Append the period (am/pm) to the formatted time in lowercase.
    formattedTime += this.datePipe.transform(parsedDatetime, 'a')?.toLowerCase();

    return formattedTime;
  }

  clear(item, nameType) {
    /**
     * Clears the specified item from the relevant array based on the nameType.
     * Updates the form controls or class properties accordingly.
     * @param item The item to be removed.
     * @param nameType The type indicating which array to update.
     */
    let localArray = [];
    switch (nameType) {
      case 'legalName':
        // Filter out the item from the 'legalname' form control and update the control's value.
        localArray = this.editProperty.controls['legalname'].value.filter(x => x !== item);
        this.editProperty.controls['legalname'].setValue(localArray);
        break;
      case 'company':
        // Filter out the item from the 'solicitors' form control and update the control's value.
        localArray = this.editProperty.controls['solicitors'].value.filter(x => x !== item);
        this.editProperty.controls['solicitors'].setValue(localArray);
        break;
      case 'S_C':
        // Filter out the item from the 'solicitorscontract' form control and update the control's value.
        localArray = this.editProperty.controls['solicitorscontract'].value.filter(x => x !== item);
        this.editProperty.controls['solicitorscontract'].setValue(localArray);
        break;
      case 'appt_agent':
        // Filter out the item from the 'agent' array in insertEvent and update it.
        localArray = this.insertEvent.agent.filter(x => x !== item);
        this.insertEvent.agent = localArray;
        break;
      case 'calendar':
        // Filter out the item from the 'activeCalendarUser' array and update it.
        localArray = this.activeCalendarUser.filter(x => x !== item);
        this.activeCalendarUser = localArray;
        break;
      default:
        // No action needed for unsupported nameType.
        break;
    }
  }

  forLease: boolean = true;
  otherLabel: boolean = false;
  propertyStatus(event) {
    if (event?.tag_name === 'For Lease' || event?.tag_name === 'Deposit Taken' || event?.tag_name == 'Leased') {
      this.forLease = false;
      this.otherLabel = true;
    } else {
      this.forLease = true;
      this.otherLabel = false;
    }
  }
  soldStatus(event) {
    if (event?.tag_name === 'Sold') {
      this.soldModalDialog.show();
    }
  }

  GetListingWorkflowProcesses() {
    /**
     * Get the workflow processes for the selected property.
     * If the request is successful, set the ActiveProcessList and pagination.
     * If the request fails, set the ActiveProcessList to an empty array.
     */
    this._workflowService.isWorkflowProcessTabOpened = true;
    this._workflowService.ActiveProcessList = [];
    this._workflowService.processRecordId = this.property_id;
    this._workflowService.active_module_name = 'properties';
    this._workflowService
      .GetAllProcessesByModule(this.property_id, this._workflowService.module_array?.find(res => res.name === 'Listing')?.module_value)
      .subscribe(response => {
        try {
          const { status, data, meta } = response;
          if (status) {
            // If there are no processes, set no_process_run to true and isStop to true
            !data?.length
              ? ((this.no_process_run = true), (this._workflowService.module_isStop = true))
              : ((this.no_process_run = false), (this._workflowService.module_isStop = false));

            // Set the ActiveProcessList and pagination
            this._workflowService.ActiveProcessList = data?.map(
              result => (result = { ...result, module: Utils.capitalizePhrase(result?.module?.split('_')?.join(' ')?.trim() || '') })
            );
            this._workflowService.centralizedProcessPagination = {
              ...this._workflowService.centralizedProcessPagination,
              per_page: 10,
              total_pages: Math.ceil(meta?.pagination?.total / 10),
              total: meta?.pagination?.total,
              numberOfRecords: this._workflowService.ActiveProcessList?.length > 10 ? 10 : this._workflowService.ActiveProcessList?.length,
            };
          } else {
            // If the request fails, set the ActiveProcessList to an empty array
            this._workflowService.ActiveProcessList = [];
          }
        } catch (error) {
          // If the request fails, set the ActiveProcessList to an empty array
          this._workflowService.ActiveProcessList = [];
        }
      });
  }
  startHourChange() {
    /**
     * When the start time hour is changed, update the start time.
     * @param this.selectedStartMinutes the start time minutes
     * @param this.selectedStartHour the start time hour
     * @param this.selectedStartDuration the start time duration (AM/PM)
     */
    if (this.selectedStartMinutes == null || this.selectedStartMinutes == '---') {
      this.selectedStartMinutes = '00';
    }
    if (this.selectedStartHour == null || this.selectedStartHour == '') {
      this.selectedStartHour = '9';
    }
    let startTime = moment().format();
    // If the duration is PM and the hour is not 12, add 12 to the hour
    if (this.selectedStartDuration == 'PM' && this.selectedStartHour != '12') {
      startTime = moment()
        .hour(Number(this.selectedStartHour) + 12)
        .minute(this.selectedStartMinutes)
        .format();
    } else {
      // If the duration is AM and the hour is 12, subtract 12 from the hour
      if (this.selectedStartHour == '12' && this.selectedStartDuration == 'AM') {
        startTime = moment()
          .hour(Number(this.selectedStartHour) + 12)
          .minute(this.selectedStartMinutes)
          .format();
      } else {
        // If the duration is AM and the hour is not 12, set the hour as it is.
        startTime = moment().hour(this.selectedStartHour).minute(this.selectedStartMinutes).format();
      }
    }
    this.insertEvent.starttime = new Date(startTime);
    // Set the end time to be 30 minutes after the start time.
    this.insertEvent.endtime = new Date(moment(this.insertEvent.starttime).add(30, 'm').format());

    // Set the end time hour, minutes and duration based on the updated end time.
    this.selectedEndHour = String(moment(this.insertEvent.endtime).format('h'));
    this.selectedEndMinutes = String(moment(this.insertEvent.endtime).format('mm'));
    this.selectedEndDuration = moment(this.insertEvent.endtime).format('A');
  }
  startMinuteChange() {
    /**
     * When the start time minutes are changed, update the start time and end time.
     * @param this.selectedStartMinutes the start time minutes
     * @param this.selectedStartHour the start time hour
     * @param this.selectedStartDuration the start time duration (AM/PM)
     */
    if (this.selectedStartMinutes != null && this.selectedStartMinutes != '---') {
      let startTime = moment().format();
      if (this.selectedStartHour == null || this.selectedStartHour == '') {
        // If the hour is not selected, set it to 9 by default.
        this.selectedStartHour = '9';
      }
      // If the duration is PM and the hour is not 12, add 12 to the hour.
      if (this.selectedStartDuration == 'PM' && this.selectedStartHour != '12') {
        startTime = moment()
          .hour(Number(this.selectedStartHour) + 12)
          .minute(this.selectedStartMinutes)
          .format();
      } else {
        // If the hour is 12 and the duration is AM, add 12 to the hour.
        if (this.selectedStartHour == '12' && this.selectedStartDuration == 'AM') {
          startTime = moment()
            .hour(Number(this.selectedStartHour) + 12)
            .minute(this.selectedStartMinutes)
            .format();
        } else {
          // Otherwise, set the hour to the selected hour.
          startTime = moment().hour(this.selectedStartHour).minute(this.selectedStartMinutes).format();
        }
      }
      // Update the start time of the event.
      this.insertEvent.starttime = new Date(startTime);
      // Update the end time of the event by adding 30 minutes to the start time.
      this.insertEvent.endtime = new Date(moment(this.insertEvent.starttime).add(30, 'm').format());

      // Update the end time hour, minutes, and duration fields.
      this.selectedEndHour = String(moment(this.insertEvent.endtime).format('h'));
      this.selectedEndMinutes = String(moment(this.insertEvent.endtime).format('mm'));
      this.selectedEndDuration = moment(this.insertEvent.endtime).format('A');
    }
  }

  endHourChange() {
    /**
     * When the end time hour is changed, update the end time.
     * @param this.selectedEndMinutes the end time minutes
     * @param this.selectedEndHour the end time hour
     * @param this.selectedEndDuration the end time duration (AM/PM)
     */
    if (this.selectedEndMinutes == null || this.selectedEndMinutes == '---') {
      this.selectedEndMinutes = '00';
    }
    if (this.selectedEndHour == null || this.selectedEndHour == '') {
      this.selectedEndHour = '9';
    }
    let endTime = moment().format();
    // If the duration is PM and the hour is not 12, add 12 to the hour
    if (this.selectedEndDuration == 'PM' && this.selectedEndHour != '12') {
      endTime = moment()
        .hour(Number(this.selectedEndHour) + 12)
        .minute(this.selectedEndMinutes)
        .format();
    } else {
      // If the hour is 12 and the duration is AM, add 12 to the hour
      if (this.selectedEndHour == '12' && this.selectedEndDuration == 'AM') {
        endTime = moment()
          .hour(Number(this.selectedEndHour) + 12)
          .minute(this.selectedEndMinutes)
          .format();
      } else {
        // Otherwise, set the hour to the selected hour
        endTime = moment().hour(this.selectedEndHour).minute(this.selectedEndMinutes).format();
      }
    }
    // Update the end time in the insert event
    this.insertEvent.endtime = new Date(endTime);
    // Update the selected end time hour, minutes, and duration
    this.selectedEndHour = String(moment(this.insertEvent.endtime).format('h'));
    this.selectedEndMinutes = String(moment(this.insertEvent.endtime).format('mm'));
    this.selectedEndDuration = moment(this.insertEvent.endtime).format('A');
  }
  endMinuteChange() {
    /**
     * When the end time minutes are changed, update the end time.
     */
    if (this.selectedEndMinutes != null && this.selectedEndMinutes != '---') {
      let endTime = moment().format();
      // If the hour is not provided, default to 9
      if (this.selectedEndHour == null || this.selectedEndHour == '') {
        this.selectedEndHour = '9';
      }
      // Convert the hour to 12/24 hour format
      if (this.selectedEndDuration == 'PM' && this.selectedEndHour != '12') {
        endTime = moment()
          .hour(Number(this.selectedEndHour) + 12)
          .minute(this.selectedEndMinutes)
          .format();
      } else {
        // If the hour is 12 and the duration is AM, add 12 to the hour
        if (this.selectedEndHour == '12' && this.selectedEndDuration == 'AM') {
          endTime = moment()
            .hour(Number(this.selectedEndHour) + 12)
            .minute(this.selectedEndMinutes)
            .format();
        } else {
          // Otherwise, use the hour as is
          endTime = moment().hour(this.selectedEndHour).minute(this.selectedEndMinutes).format();
        }
      }
      // Update the end time with the new value
      this.insertEvent.endtime = new Date(endTime);
    }
  }

  activeIndex: any = 0;
  /** Which of the drawer's right-hand tabs is open; the Leads tab (1) is the full-page one. */
  activeIndexs: any = 20;

  /**
   * The project whose lots a new Residential listing is picked from. Matched on the name rather
   * than an id because the same project carries a different id in each office/environment.
   */
  readonly residentialLotProjectName = 'YPM Residential Listings';

  /** Options for the Lot picker; empty until a Residential type is chosen. */
  residentialLots: any[] = [];

  /** Resolved alongside the lots; sent as `related_to_project` when the type is Residential. */
  residentialLotProjectId: string = null;

  /** Guards the two-request lookup below so picking Residential twice does not refetch. */
  private residentialLotsLoaded = false;

  /** Only Residential listings sit in the lot project, so only they get the picker. */
  get isResidentialType(): boolean {
    return this.editProperty?.controls['type']?.value === 'Residential';
  }

  /** Every listing can be picked from; Residential is the one that is fixed to the lot project. */
  listingProjects: any[] = [];
  private listingProjectsLoaded = false;

  /**
   * Property Type only forces the project for Residential, which must sit in the residential lot
   * project. Any other type keeps whatever project it is associated with — clearing it here would
   * drop the association of every listing that merely changed type.
   */
  onPropertyTypeChange(): void {
    this.loadListingProjects();
    if (!this.isResidentialType) {
      return;
    }
    // The listing is moving to the residential lot project, so any lot it holds belongs to the
    // project it is leaving. Drop it, and the options with it, rather than showing another
    // project's lots under this one's name.
    this.editProperty.patchValue({ residential_project_lot: null });
    this.residentialLots = [];
    this.loadResidentialLots();
  }

  /**

   * A saved listing arrives with its project already on it, so the picker needs the options before

   * it can show which one — and, outside Residential, that project's lots too.

   */

  private loadSavedListingProject(): void {
    // `loadListingProjects` reads the lots itself once its list lands, and does nothing on a second
    // call — so an already-loaded list needs the same read triggered here.
    this.loadListingProjects();
    if (this.listingProjects?.length) {
      this.syncLotOptions();
    }
  }

  /** The options for the Project picker, fetched once per drawer. */
  loadListingProjects(): void {
    if (this.listingProjectsLoaded) {
      return;
    }
    this.listingProjectsLoaded = true;

    this._projectService.getProjectList().subscribe({
      next: (response: any) => {
        this.listingProjects = (response?.data || []).sort((a: any, b: any) =>
          (a?.Project_Name || '').trim().localeCompare((b?.Project_Name || '').trim())
        );
        // A saved listing's project can only be recognised as the lot project once the list is
        // here, so the lots are read after it rather than before.
        this.syncLotOptions();
      },
      error: () => {
        this.listingProjectsLoaded = false;
      },
    });
  }

  /** The residential lot project is the only one that keeps lots, and it is known by its name. */
  private isLotProject(projectId: string): boolean {
    const project = this.listingProjects?.find(item => item?._id === projectId);
    return project?.Project_Name?.trim() === this.residentialLotProjectName;
  }

  /** True while the chosen project is that one — the only time a Lot can be picked. */
  get isResidentialLotProject(): boolean {
    const projectId = this.editProperty?.controls['related_to_project']?.value;
    return !!projectId && projectId === this.residentialLotProjectId;
  }

  /**
   * Lots belong to the residential lot project alone. Any other project has none to offer, so the
   * options are dropped rather than filled with lots the picker should never show.
   */
  private syncLotOptions(): void {
    const projectId = this.editProperty.controls['related_to_project'].value;
    if (projectId && this.isLotProject(projectId)) {
      this.residentialLotProjectId = projectId;
      this.getResidentialLots(projectId);
      return;
    }
    this.residentialLots = [];
  }

  /**
   * A project chosen by hand. The lot belongs to the project, so changing one clears the other and
   * pulls that project's lots — a listing in a project with lots can then say which lot it is.
   */
  onListingProjectChange(): void {
    const projectId = this.editProperty.controls['related_to_project'].value || null;
    this.editProperty.patchValue({
      project_associate: !!projectId,
      residential_project_lot: null,
    });
    this.syncLotOptions();
  }

  /**
   * Resolves the lot project by name, then pulls its lots. Both responses are config-cached. The
   * project goes onto the listing as soon as it resolves, since a Residential listing belongs to it
   * by type — opening one is as good a reason to fill it in as picking the type by hand.
   */
  private loadResidentialLots(): void {
    if (!this.isResidentialType) {
      return;
    }
    if (this.residentialLotsLoaded) {
      this.syncResidentialLotProject();
      if (this.residentialLotProjectId) {
        this.getResidentialLots(this.residentialLotProjectId);
      }
      return;
    }
    this.residentialLotsLoaded = true;

    this._projectService.getProjectList().subscribe({
      next: (response: any) => {
        const project = (response?.data || []).find(item => item?.Project_Name?.trim() === this.residentialLotProjectName);
        if (!project?._id) {
          // The office does not have that project — leave the picker empty rather than guessing.
          this.residentialLotsLoaded = false;
          return;
        }
        this.residentialLotProjectId = project._id;
        this.syncResidentialLotProject();
        this.getResidentialLots(project._id);
      },
      error: () => {
        this.residentialLotsLoaded = false;
      },
    });
  }

  /**
   * A Residential listing belongs to the residential lot project because of its type, not because
   * of its lot — the lot only says which part of that project it is. So the project is filled in as
   * soon as it resolves, which is what the read-only Project picker shows. `project_associate`
   * stays the boolean the backend validates ("Invalid Project Associate value." for anything else);
   * the project id itself goes in `related_to_project`, which already took an id.
   */
  syncResidentialLotProject(): void {
    // Outside Residential the project stands on its own — it is picked directly, and a listing
    // with no lot is still associated.
    if (!this.isResidentialType || !this.residentialLotProjectId) {
      return;
    }
    this.editProperty.patchValue({
      project_associate: true,
      related_to_project: this.residentialLotProjectId,
    });
  }

  private getResidentialLots(projectId: string): void {
    const payload = {
      office_id: this.api.getOfficeId(),
      user_id: this.api.getUserId(),
      project: [projectId],
      page: 1,
      per_page: 9999,
      columns: ['lot_name'],
      sort_order: { field: 'lot_name', sort_order: true },
      is_filter: false,
    };

    this._projectService.getProjectLotList(payload).subscribe({
      next: (response: any) => {
        this.residentialLots = response?.data || [];
      },
      error: () => {
        this.residentialLotsLoaded = false;
      },
    });
  }

  /**
   * Saving belongs to the tabs that edit the listing form — Listing, Legal and Portals.
   * The rest manage their own records and save themselves, so the header buttons would be a trap.
   */
  get canSaveListing(): boolean {
    return [0, 3, 6].includes(this.activeIndex);
  }

  /** The listing's lot by name. Only this component holds the options to resolve the id against. */
  get residentialLotName(): string {
    const id = this.editProperty?.controls['residential_project_lot']?.value;
    return this.residentialLots?.find(lot => lot?._id === id)?.lot_name ?? '';
  }

  /** The header shows car spaces as one number; the form keeps garage, carport and open apart. */
  get carSpaceTotal(): number {
    const count = (value: any) => Number(value) || 0;
    return (
      count(this.editProperty?.controls['garage']?.value) +
      count(this.editProperty?.controls['car_port']?.value) +
      count(this.editProperty?.controls['open_spaces']?.value)
    );
  }

  /**
   * The Project cell. A Residential listing belongs to the project the Lot picker draws from, so
   * it is named as soon as that project resolves — picking a lot is not what makes it true.
   * Any other type only knows that an association exists.
   */
  get headerProjectLabel(): string {
    const projectId = this.editProperty?.controls['related_to_project']?.value;
    if (!projectId) {
      return 'Not associated';
    }
    if (this.isResidentialType && this.residentialLotProjectId) {
      return this.residentialLotProjectName;
    }
    // Name it where the options have loaded; "Associated" is only the fallback while they have not.
    return this.listingProjects?.find(project => project?._id === projectId)?.Project_Name || 'Associated';
  }

  /** Every agent on the listing for the header strip — primary, secondary, then any added after. */
  get headerAgents(): string[] {
    const ids = [
      this.editProperty?.controls['agent']?.value,
      this.editProperty?.controls['secondaryagent']?.value,
      ...(this.other_agent || []).map(entry => entry?.other_agents),
    ].filter(Boolean);
    return ids.map(id => this.originalAssigns?.find(agent => agent?._id === id)?.full_name).filter(Boolean);
  }

  /**
   * Both strips are a single row over one column of panes, so opening a tab has to close the
   * other strip's pane. 20 and 30 are the drawer's own "nothing selected" values for the two.
   */
  /**
   * The tabs open read-only, the way the lead page reads, and only turn into the form once the
   * user asks to edit.
   */
  listingEditMode: boolean = false;

  /** A listing being created has nothing to read yet, so it is always the form. */
  get isCreatingListing(): boolean {
    return ['add_listing_from_property', 'add_listing_property', 'add_listing_property_listing'].includes(this.lmService.listing_show_div);
  }

  get isListingReadOnly(): boolean {
    return !this.listingEditMode && !this.isCreatingListing;
  }

  toggleListingEdit(): void {
    this.listingEditMode = !this.listingEditMode;
  }

  openListingTab(index: number): void {
    this.activeIndex = index;
    this.activeIndexs = 20;
    if (index === 5) {
      // Re-read when something it counts has changed since it was last drawn.
      this.loadListingDashboard(this.dashboardStale);
    }

    // The Images tab is where images are added and removed, so the dashboard's own Images card
    // cannot be trusted once the user has been in there.
    if (index === 1) {
      this.dashboardStale = true;
    }
  }

  /* ------------------------------------------------------------------ Dashboard tab */

  /** The whole tab comes from one read; `sections` lets a panel be refreshed on its own. */
  listingDashboard: any = null;
  /** Set when a lead, contract or inspection changes, so re-opening the tab re-reads instead of
   * showing what was true when it was first opened. */
  private dashboardStale: boolean = false;
  dashboardLoading: boolean = false;
  dashboardError: string = null;
  dashboardLeadsLoading: boolean = false;

  /** The Leads panel's own dropdown. The keys are the ones the endpoint accepts. */
  dashboardLeadPeriod: string = '7d';
  dashboardLeadPeriods: { key: string; label: string }[] = [
    { key: 'today', label: 'Today' },
    { key: '7d', label: 'Last 7 Days' },
    { key: '30d', label: 'Last 30 Days' },
    { key: '90d', label: 'Last 90 Days' },
    { key: '12m', label: 'Last 12 Months' },
    { key: 'all', label: 'All' },
  ];

  private dashboardListingId: string = null;

  get isDashboardManager(): boolean {
    return ['administrators', 'master admin', 'operations manager'].includes(this.userRole);
  }

  /**
   * Read once per listing. Opening the tab again shows what is already there rather than asking
   * for it a second time; `refresh` is for after a save, when the figures have moved.
   */
  loadListingDashboard(refresh: boolean = false): void {
    const listingId = this.property_id || this.insertedPropertyId;
    if (!listingId) {
      return;
    }
    if (!refresh && this.listingDashboard && this.dashboardListingId === listingId) {
      return;
    }

    this.dashboardListingId = listingId;
    this.dashboardLoading = true;
    this.dashboardError = null;

    this._listingPropertiesService
      .getListingDashboard(listingId, {
        leadPeriod: this.dashboardLeadPeriod,
        isProjectManager: this.isDashboardManager,
      })
      .subscribe({
        next: (response: any) => {
          this.listingDashboard = response?.data || null;
          this.dashboardStale = false;
          this.dashboardLoading = false;
        },
        error: error => {
          if (!shouldHideError(error)) {
            this.dashboardError = error?.error?.message || 'Could not load the dashboard right now.';
          }
          this.dashboardLoading = false;
        },
      });
  }

  /**
   * The three figures the Leads panel leads with. A tile whose metric is missing renders a dash
   * rather than a zero, so an absent figure is never read as "none".
   */
  get dashboardLeadMetrics(): { label: string; metric: any }[] {
    const leads = this.listingDashboard?.leads;
    return [
      { label: 'New', metric: leads?.new_leads },
      { label: 'Total', metric: leads?.total_leads },
      { label: 'Overdue', metric: leads?.overdue_follow_ups },
    ];
  }

  /** Only the Leads panel changes with the period, so only the Leads panel is re-read. */
  onDashboardLeadPeriodChange(): void {
    const listingId = this.property_id || this.insertedPropertyId;
    if (!listingId) {
      return;
    }

    this.dashboardLeadsLoading = true;
    this._listingPropertiesService
      .getListingDashboard(listingId, {
        leadPeriod: this.dashboardLeadPeriod,
        sections: ['leads'],
        isProjectManager: this.isDashboardManager,
      })
      .subscribe({
        next: (response: any) => {
          if (response?.data?.leads) {
            this.listingDashboard = { ...this.listingDashboard, leads: response.data.leads };
          }
          this.dashboardLeadsLoading = false;
        },
        error: () => {
          this.dashboardLeadsLoading = false;
        },
      });
  }

  /* Each panel says what it is waiting for when it has nothing to show, rather than drawing an
     empty table or a column of dashes. */

  /** "None" is what the design shows for a row with nothing in it. */
  private dashboardValueOrNone(value: any): string {
    const named = (entry: any): string => {
      const name = entry?.full_name || entry?.name || entry;
      // A contact that came back as a bare id has no name to show — printing the id would be worse
      // than printing nothing.
      return typeof name === 'string' && /^[0-9a-f]{24}$/i.test(name) ? '' : name;
    };

    if (Array.isArray(value)) {
      const names = value.map(named).filter(Boolean);
      return names.length ? names.join(', ') : 'None';
    }
    // A count of nought is a figure the row should print, not an empty row.
    if (typeof value === 'number') {
      return String(value);
    }
    return named(value) || 'None';
  }

  /**
   * The people on the contract, in the design's order. `contacts` is the endpoint's own block for
   * them; `buyers` is the one part of it that already existed, so it is the fallback for the Buyer
   * row. Rows the endpoint does not fill yet read "None".
   */
  get dashboardContacts(): { label: string; value: string }[] {
    const contract = this.listingDashboard?.contract;
    const contacts = contract?.contacts;
    return [
      // The endpoint's own `contacts` block first, then the contract itself — which sends these
      // snake_cased (`seller_solicitor`), while the contract record stores them camelCased
      // (`sellerSolicitor`), so both spellings are read before a row falls back to "None".
      { label: 'Seller', value: this.dashboardValueOrNone(contacts?.seller ?? contract?.seller) },
      {
        label: 'Seller Solicitor',
        value: this.dashboardValueOrNone(contacts?.seller_solicitor ?? contract?.seller_solicitor ?? contract?.sellerSolicitor),
      },
      { label: 'Buyer', value: this.dashboardValueOrNone(contacts?.buyer ?? contract?.buyers ?? contract?.buyer) },
      {
        label: 'Buyer Solicitor',
        value: this.dashboardValueOrNone(contacts?.buyer_solicitor ?? contract?.buyer_solicitor ?? contract?.buyerSolicitor),
      },
    ];
  }

  get dashboardCriticalDates(): { label: string; value: string }[] {
    const contract = this.listingDashboard?.contract;
    const issued = contract?.key_dates?.contract_issued;
    const contract_date = contract?.key_dates?.contract_date;

    return [
      { label: 'Contract Date', value: contract_date ? moment(contract_date).format('D MMM YYYY') : 'None' },
      { label: 'Contract Issued', value: issued ? moment(issued).format('D MMM YYYY') : 'None' },
      { label: 'Previous Offers', value: this.dashboardValueOrNone(contract?.previous_offers) },
      { label: 'Contract Status', value: contract?.status || 'None' },
      { label: 'Offer Status', value: contract?.offer_status || 'None' },
      { label: 'Existing Deals', value: this.dashboardValueOrNone(contract?.existing_deals) },
    ];
  }

  get hasNoImages(): boolean {
    return !this.listingDashboard?.images?.total;
  }

  /** The card only falls back to its empty state when there is no portal to list at all. */
  get hasNoPortalRows(): boolean {
    return !this.dashboardPortals?.length;
  }

  /** The four the design shows; Company Website and Market Place come back too. */
  private readonly dashboardPortalKeys = ['domain', 'rea', 'homely', 'realestateview'];

  get dashboardPortals(): any[] {
    return (this.listingDashboard?.portals?.items || []).filter((portal: any) => this.dashboardPortalKeys.includes(portal?.key));
  }

  /**
   * The endpoint sends both a ready URL and the raw library key; the key is the fallback for an
   * older response that carried no URL.
   */
  dashboardImageUrl(image: any): string {
    return image?.thumb_url || image?.url || (image?.thumbPath ? this.S3Path + image.thumbPath : null);
  }

  openWorkTab(index: number): void {
    this.activeIndexs = index;
    this.activeIndex = 30;
  }

  showMenu = false;
  selectedIndex: any;
  selectedItem: any;
  items: any[] = [
    { id: 0, activeIndex: 5, name: 'Dashboard', icon: 'pi pi-th-large', img: null, activeIndexs: 30 },
    { id: 1, activeIndex: 0, name: 'Listing', img: this.common_images?.home, activeIndexs: 30 },
    { id: 2, activeIndex: 1, name: 'Images', img: this.common_images?.light_img_icon, activeIndexs: 30 },
    { id: 3, activeIndex: 2, name: 'Inspection', img: this.images?.eye_icon, activeIndexs: 30 },
    { id: 4, activeIndex: 3, name: 'Legal', img: this.common_images?.gavel_icon, activeIndexs: 30 },
    { id: 5, activeIndex: 4, name: 'Documents', img: this.images?.document_icon, activeIndexs: 30 },
    { id: 6, activeIndex: 6, name: 'Portals', img: this.images?.laptop_icon, activeIndexs: 30 },

    { id: 8, activeIndexs: 1, name: 'Leads', icon: null, img: this.images?.listing_lead_icon, activeIndex: 20 },
    { id: 9, activeIndexs: 2, name: 'Calendar', icon: 'pi pi-calendar', img: null, activeIndex: 20 },
    // { id: 11, activeIndexs: 4, name: 'Tasks', icon: null, img: this.images?.listing_task, activeIndex: 20 },
    { id: 12, activeIndexs: 5, name: 'Related', icon: null, img: this.images?.listing_related, activeIndex: 20 },
    // { id: 13, activeIndexs: 6, name: 'Approval', icon: null, img: this.images?.approval_icon, activeIndex: 20 },
    // { id: 14, activeIndexs: 7, name: 'Commission', icon: null, img: this.common_images?.conjunction_icon, activeIndex: 20 },
    { id: 15, activeIndexs: 8, name: 'Conjunction', icon: null, img: this.common_images?.conjunction_icon, activeIndex: 20 },
    { id: 16, activeIndexs: 9, name: 'Notes', icon: null, img: this.common_images?.notes, activeIndex: 20 },
    { id: 17, activeIndexs: 10, name: 'History', icon: null, img: this.images?.listing_history, activeIndex: 20 },
  ];
  itemClear() {
    this.selectedItem = false;
    this.activeIndex = 0;
  }
  selectItem(item: any) {
    console.log('item >>', item);
    this.selectedItem = item;
    this.activeIndex = item.activeIndex;
    this.activeIndexs = item.activeIndexs;
    this.showMenu = false;
    if (this.activeIndex === 2) {
      this.fetchApts(this.selectedProperty);
    }
    if (this.activeIndex === 4) {
      this.isDocuments = true;
      this.isImg = false;
    } else if (this.activeIndex === 1) {
      this.isDocuments = false;
      this.isImg = true;
    } else {
      this.isDocuments = false;
      this.isImg = false;
    }
  }
  // Second menu
  itemsHistory: itemData1[] = [
    { id: 2, activeIndexs: 1, name: 'Leads', icon: null, img: this.images?.listing_lead_icon },
    { id: 3, activeIndexs: 2, name: 'Calendar', icon: 'pi pi-calendar', img: null },
    { id: 5, activeIndexs: 4, name: 'Tasks', icon: null, img: this.images?.listing_task },
    { id: 6, activeIndexs: 5, name: 'Related', icon: null, img: this.images?.listing_related },
    { id: 7, activeIndexs: 6, name: 'Approval', icon: null, img: this.images?.approval_icon },
    { id: 8, activeIndexs: 7, name: 'Commission', icon: null, img: this.common_images?.conjunction_icon },
    { id: 9, activeIndexs: 8, name: 'Conjunction', icon: null, img: this.common_images?.conjunction_icon },
    { id: 10, activeIndexs: 9, name: 'Notes', icon: null, img: this.common_images?.notes },
    { id: 11, activeIndexs: 10, name: 'History', icon: null, img: this.images?.listing_history },
  ];
  selectedItemHistory: any;
  showMenuHistory = false;
  activeHistory = 0;
  selectHistory(item: any) {
    this.selectedItemHistory = item;
    this.activeHistory = item.activeIndexs;
    this.activeIndexs = item.activeIndexs;
    this.showMenuHistory = false;
    if (this.activeIndexs === 2) {
      this.fetchApts(this.selectedProperty);
    }
  }
  itemClearHistory() {
    this.selectedItemHistory = false;
    this.activeHistory = 0;
  }

  calendarAccessUsers() {
    this.api.get(`/users/calendar-access-received/${this.api.getUserId()}`).subscribe(res => {
      this.calendarAccessUser = [];
      const usersToAdd = [
        { _id: this.AuthUser._id, full_name: this.AuthUser.full_name, color: this.AuthUser.color, email: this.AuthUser.email },
        { _id: this.selectedProperty._id, full_name: 'Listing', color: '#229276' },
      ];

      if (res?.data?.length > 0) {
        res.data?.forEach(element => {
          if (element.users) {
            this.calendarAccessUser.push(element.users);
          }
        });
        this.calendarAccessUser.push(...usersToAdd);
        this.activeCalendarUser = [this.selectedProperty._id];
      } else {
        this.calendarAccessUser = usersToAdd;
        this.activeCalendarUser = [this.selectedProperty._id];
      }
    });
  }

  allowOnlyNumberAndDecimal(event: KeyboardEvent) {
    const charCode = event.key;

    // Allow numbers (0-9)
    if (/^[0-9]$/.test(charCode)) {
      return;
    }

    // Allow only one decimal point
    if (charCode === '.') {
      const input = event.target as HTMLInputElement;

      if (input.value.includes('.')) {
        event.preventDefault(); // second decimal block
      }
      return;
    }

    // Block everything else
    event.preventDefault();
  }

  addCustomAgent(tag) {
    if (tag.includes('@') == true) {
      return { _id: tag, full_name: tag };
    }
  }
  added_appt_agent() {
    this.insertEvent?.agent?.forEach(e => {
      if (e.includes('@')) {
        this.showErrorForExternalAgent = true;
      }
    });
  }
  onLegalSellingDocument(event) {
    if (event.target.files && event.target.files.length) {
      for (let i = 0; i < event.target.files.length; i++) {
        let logoName = event.target.files[i].name;
        const fileReader: FileReader = new FileReader();
        fileReader.readAsDataURL(event.target.files[i]);
        fileReader.onload = () => {
          // this.property_img = null;
          // this.imagesLogo.push({ name: logoName, file: fileReader.result });
          let reqObject = {
            user_id: this.api.getUserId(),
            office_id: this.api.getOfficeId(),
            propertyId: this.select_property_id,
            library_type: 'office',
            contractId: null,
            parentId: null,
            item_category: 'useroffice',
            type: 'file',
            file: [{ name: logoName, fileSrc: fileReader.result }],
          };

          this._libraryGalleryService.addDocumentsInOfficeLibraryForListing(reqObject).subscribe({
            next: res => {
              if (res.status && res.status == true) {
                this.toast.success('Added successfully');
                this.existEditProperty();
              } else {
                this.toast.error('Something went wrong');
              }
            },
            error: () => {
              this.toast.error('Something went wrong');
            },
          });
        };
      }
    }
  }

  auctionStartHourChange() {
    /**
     * Updates the start time of the auction based on the selected hour and minute.
     * @returns {void}
     */
    if (this.selectedAuctionStartMinutes == null || this.selectedAuctionStartMinutes == '---') {
      this.selectedAuctionStartMinutes = '00';
    }
    if (this.selectedAuctionStartHour == null || this.selectedAuctionStartHour == '') {
      this.selectedAuctionStartHour = '9';
    }
    let startTime = moment().format();
    if (this.selectedAuctionStartDuration == 'PM' && this.selectedAuctionStartHour != '12') {
      // If the duration is PM and the hour is not 12, add 12 to the hour.
      startTime = moment()
        .hour(Number(this.selectedAuctionStartHour) + 12)
        .minute(this.selectedAuctionStartMinutes)
        .format();
    } else {
      // If the duration is AM and the hour is 12, subtract 12 from the hour.
      if (this.selectedAuctionStartHour == '12' && this.selectedAuctionStartDuration == 'AM') {
        startTime = moment()
          .hour(Number(this.selectedAuctionStartHour) + 12)
          .minute(this.selectedAuctionStartMinutes)
          .format();
      } else {
        // If the duration is AM and the hour is not 12, set the hour as it is.
        startTime = moment().hour(this.selectedAuctionStartHour).minute(this.selectedAuctionStartMinutes).format();
      }
    }
    this.editProperty.patchValue({
      startTime: new Date(startTime),
    });
  }
  auctionStartMinuteChange() {
    /**
     * Updates the start time of the auction based on the selected hour and minute.
     * @returns {void}
     */
    if (this.selectedAuctionStartMinutes != null && this.selectedAuctionStartMinutes != '---') {
      // Get the current time in the ISO 8601 format.
      let startTime = moment().format();
      // If the hour is not selected, set it to 9 by default.
      if (this.selectedAuctionStartHour == null || this.selectedAuctionStartHour == '') {
        this.selectedAuctionStartHour = '9';
      }
      // If the duration is PM and the hour is not 12, add 12 to the hour.
      if (this.selectedAuctionStartDuration == 'PM' && this.selectedAuctionStartHour != '12') {
        startTime = moment()
          .hour(Number(this.selectedAuctionStartHour) + 12)
          .minute(this.selectedAuctionStartMinutes)
          .format();
      } else {
        // If the hour is 12 and the duration is AM, add 12 to the hour.
        if (this.selectedAuctionStartHour == '12' && this.selectedAuctionStartDuration == 'AM') {
          startTime = moment()
            .hour(Number(this.selectedAuctionStartHour) + 12)
            .minute(this.selectedAuctionStartMinutes)
            .format();
        } else {
          // Otherwise, set the hour to the selected hour.
          startTime = moment().hour(this.selectedAuctionStartHour).minute(this.selectedAuctionStartMinutes).format();
        }
      }
      // Update the start time of the auction in the form.
      this.editProperty.patchValue({
        startTime: new Date(startTime),
      });
    }
  }

  isPaginatorVisible(tableType) {
    /**
     * Checks if the paginator should be visible for the given table type.
     * @param {string} tableType The type of the table.
     * @returns {boolean} True if the paginator should be visible, false otherwise.
     */
    if (tableType == 'tomorrow') {
      // If there are more than 5 tasks for tomorrow, show the paginator.
      return this.tomorrowTasks?.length > 5;
    }
    if (tableType == 'today') {
      // If there are more than 5 tasks for today, show the paginator.
      return this.todayTasks?.length > 5;
    }
  }
  deleteTask(task) {
    /**
     * Deletes a task from the API.
     * @param {Object} task The task to delete.
     * @returns {void}
     */
    this.remmiConfirm
      .delete({ title: 'Delete Task?', message: 'This task will be permanently deleted.', subject: task?.title })
      .subscribe(isConfirmed => {
        if (!isConfirmed) return;
        this._taskService.deleteTask(task?._id).subscribe({
          next: () => {
            this.getTasks();
            this.toast.success('Task deleted successfully');
          },
        });
      });
  }

  application() {
    /**
     * Applies the selected status to the selected tasks.
     * @param {*} closeStatusId The status to apply to the selected tasks.
     * @returns {void}
     */
    if (this.selectedRows.length === 0) {
      return false;
    }
    if (this.closeStatusId != null) {
      // Loop through the selected tasks and apply the selected status to each of them.
      for (let i = 0; i < this.selectedRows.length; i++) {
        const id = this.selectedRows[i]._id;
        this._taskService.changeTaskStatus(id, this.closeStatusId).subscribe(() => {});
      }
      // Update the task list by calling the getTasks method again.
      this.getTasks();
      // Reset the selected tasks.
      this.selectedRows = [];
      // Show a success message.
      this.toast.success('Task status has changed');
    }
  }

  async openModal() {
    this.contractDeleteDialog.show();
    await this.getEmailTemplate();
    setTimeout(() => {
      this.getTemplateBody('open');
    }, 500);
  }

  selectedTemplate;
  firstTemplate = [];
  getEmailTemplate() {
    // Get email templates for the current office
    this._sharedService.getEmailTemplate().subscribe({
      next: rs => {
        // Store the email templates in the component
        this.emailTemplates = rs.data;
        // Filter the templates to only show the contract templates
        this.emailTemplates = this.emailTemplates.filter(x => x.type == 'contract');
      },
    });
    // Wait 5 seconds before selecting the first template in the list
    // This is to allow the UI to update before selecting the first template
    setTimeout(() => {
      // Store the first template in the list in the firstTemplate array
      this.firstTemplate?.push(this.emailTemplates[0]);
    }, 5000);
  }
  tempContracts: any;
  getTemplateBody(type) {
    this.tempContracts = this.selectedRows;
    this.tempContracts = this.tempContracts.map(contractIndex => {
      if (contractIndex.contractDate) {
        contractIndex.contractDate = moment(contractIndex.contractDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.contractDate = '';
      }
      if (contractIndex.dateOffer) {
        contractIndex.dateOffer = moment(contractIndex.dateOffer, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.dateOffer = '';
      }
      if (contractIndex.dateOfferTerms) {
        contractIndex.dateOfferTerms = moment(contractIndex.dateOfferTerms, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.dateOfferTerms = '';
      }
      if (contractIndex.contractIssuedDate) {
        contractIndex.contractIssuedDate = moment(contractIndex.contractIssuedDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.contractIssuedDate = '';
      }
      if (contractIndex.contractReceivedDate) {
        contractIndex.contractReceivedDate = moment(contractIndex.contractReceivedDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.contractReceivedDate = '';
      }
      if (contractIndex.collingExpire) {
        contractIndex.collingExpire = moment(contractIndex.collingExpire, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.collingExpire = '';
      }
      if (contractIndex.unconditionalDate) {
        contractIndex.unconditionalDate = moment(contractIndex.unconditionalDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.unconditionalDate = '';
      }
      if (contractIndex.financeDate) {
        contractIndex.financeDate = moment(contractIndex.financeDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.financeDate = '';
      }
      if (contractIndex.depositeDue) {
        contractIndex.depositeDue = moment(contractIndex.depositeDue, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.depositeDue = '';
      }
      if (contractIndex.pastDue) {
        contractIndex.pastDue = moment(contractIndex.pastDue, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.pastDue = '';
      }
      if (contractIndex.balanceDepositeDue) {
        contractIndex.balanceDepositeDue = moment(contractIndex.balanceDepositeDue, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.balanceDepositeDue = '';
      }
      if (contractIndex.settlement) {
        contractIndex.settlement = moment(contractIndex.settlement, 'YYYY-MM-DD').format('DD/MM/YYYY');
      } else {
        contractIndex.settlement = '';
      }
      return contractIndex;
    });
    let selectedSeller =
      this.tempContracts[0].seller && this.tempContracts[0].seller.length > 0
        ? this.lmService.shortContactCompany.filter(x => x.full_name === this.tempContracts[0].seller[0])
        : null;
    this.contractEmail.to = selectedSeller && selectedSeller.length > 0 ? selectedSeller[0].email : '';
    if (type == 'open') {
      this.selectedTemplate = this.firstTemplate;
      this.contractEmail.emailTemplate = this.selectedTemplate[0]._id;
    } else if (type == 'change') {
      this.selectedTemplate = this.emailTemplates.filter(x => x._id == this.contractEmail.emailTemplate);
    }
    let body = this.selectedTemplate[0].body;
    let subject = this.selectedTemplate[0].subject;
    const regex = /{([^}]+)}/g;
    let selectedBody = body;
    let selectedSubject = subject;
    let repeatTags = selectedBody.match(/&lt;repeatStart&gt;(.+?)&lt;repeatEnd&gt;/gs);
    let appendTags = '';
    if (repeatTags !== null) {
      const matchesBody = repeatTags.toString().match(regex);
      for (let i of this.tempContracts) {
        let newRepeatTags = repeatTags;
        if (matchesBody) {
          for (let match of matchesBody) {
            const propertyName = match.substring(1, match.length - 1);
            const propertyValue = i[propertyName];
            newRepeatTags = newRepeatTags.toString().replace(match, propertyValue);
          }
          appendTags += newRepeatTags + '<br>';
        }
      }
      selectedBody = selectedBody.replace(/&lt;repeatStart&gt;(.+?)&lt;repeatEnd&gt;/gs, appendTags);
    }
    const matchesBodyRepeat = selectedBody.match(regex);
    if (matchesBodyRepeat) {
      matchesBodyRepeat.forEach(match => {
        const propertyName = match.substring(1, match.length - 1);
        const propertyValue = this.tempContracts[0][propertyName];
        selectedBody = selectedBody.replace(match, propertyValue);
      });
    }
    const matchesSubject = subject.match(regex);
    if (matchesSubject) {
      matchesSubject.forEach(match => {
        const propertyName = match.substring(1, match.length - 1);
        const propertyValue = this.tempContracts[0][propertyName];
        selectedSubject = selectedSubject.replace(match, propertyValue);
      });
      this.contractEmail.subject = selectedSubject;
    } else {
      this.contractEmail.subject = subject;
    }
    selectedBody = selectedBody.replace(/&lt;repeatStart&gt;/gs, '');
    selectedBody = selectedBody.replace(/&lt;repeatEnd&gt;/gs, '');
    this.contractEmail.body = selectedBody;
  }

  onUpdateSelect(event) {
    this.contractEmail.to = event;
  }

  sendEmail() {
    /**
     * Sends the selected contracts to the recipients via email.
     * It sends a POST request to the /contracts/present-offer endpoint with the selected contracts, subject, body and to fields.
     * If the response is successful, it shows a success toast message.
     * If the response is unsuccessful, it shows an error toast message.
     */
    this.contract_id = [];
    this.selectedRows.forEach(x => this.contract_id.push(x?._id));
    this._contractApiService
      .contractPresentOffer({
        to: this.contractEmail.to,
        subject: this.contractEmail.subject,
        body: this.contractEmail.body,
        contractid: this.contract_id,
      })
      .subscribe((rs: any) => {
        if (rs.message == 'Mail Sent Successfully') {
          this.toast.success(rs.message);
        } else {
          this.toast.error(rs.message);
        }
      });
    /**
     * Retrieves the contracts based on the selected property.
     * It is called after sending the contracts to the recipients via email.
     */
    this.getContractAccordingProperty();
  }
  public checkCharacterLimit(): void {
    // Truncates the display price field to 50 characters if it exceeds that limit.
    // This is done to prevent a UI issue where the field becomes too wide.
    if (this.editProperty.get('display_price').value.length >= 50) {
      const fieldValue = this.editProperty.get('display_price').value;
      this.editProperty.patchValue({
        display_price: fieldValue.substring(0, 50), // Truncate the value to 50 characters
      });
    }
  }

  public checkCharacterLimitForLease(): void {
    // Truncates the display price field to 50 characters if it exceeds that limit.
    // This is done to prevent a UI issue where the field becomes too wide.
    if (this.editProperty.get('display_price').value.length >= 50) {
      const fieldValue = this.editProperty.get('display_price').value;
      this.editProperty.patchValue({
        display_price: fieldValue.substring(0, 50),
      });
    }
  }
  inCall: boolean = false;
  inCall2: boolean = false;

  paras: any = [1, 2, 3, 4, 5, 6];
  tones: any = ['Professional', 'Conversational', 'Humorous', 'Empathic', 'Simple', 'Academic', 'Creative'];
  suggestions: any = [];
  noPara: any = 3;
  customWords: any = '';
  customWords1: any = '';
  selectedTone = 'Professional';

  public suggestHeading() {
    if (this.inCall) return;

    this.inCall = true;
    this._sharedService
      .getPhraseSuggestionByAi({
        customWords: this.customWords,
        office_id: this.api.getOfficeId(),
        listing_id: this.property_id ? this.property_id : this.insertedPropertyId,
      })
      .subscribe(res => {
        this.inCall = false;
        this.editProperty.patchValue({ heading: res.data[0].completion.choices[0].text.toString().trim() });
      });
  }
  setDesc(txt) {
    this.editProperty.patchValue({ description_garax: txt });
  }
  public suggestDesc() {
    if (this.inCall2) return;

    this.inCall2 = true;
    if (this.noPara < 1 || this.noPara == null || this.noPara == '') {
      this.noPara = 3;
    }

    var data = JSON.stringify({
      tone: this.selectedTone,
      customWords: this.customWords1,
      noPara: this.noPara,
      office_id: this.api.getOfficeId(),
      listing_id: this.property_id ? this.property_id : this.insertedPropertyId,
    });

    var xhr = new XMLHttpRequest();
    var baseUrl = environment.nodeApiUrl + '/' + environment.api_prefix;
    var token = Crypto.decrypt(this.localStorageService.GetItem('token'));
    xhr.open('POST', baseUrl + '/ai/gpt/suggest/description/stream');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Authorization', 'Bearer ' + token);

    xhr.send(data);
    var timer;
    timer = window.setInterval(() => {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        this.inCall2 = false;
        window.clearTimeout(timer);
      }

      let desc = xhr.responseText;
      let sp = desc.split('\n');
      desc = '';
      var gotFirstText: any = false;
      sp.forEach(n => {
        if (gotFirstText) {
          gotFirstText = true;
          desc += `<p>${n}</p>`;
        } else {
          if (n != '') {
            gotFirstText = true;
            desc += `<p>${n}</p>`;
          }
        }
      });
      this.editProperty.patchValue({ description_garax: desc.toString().trim() });
    }, 100);
  }

  // ------------- Popup Leads Pagination ------------------------------

  leadRows: number = 5;
  leadScrollTop: number = 0;
  @ViewChild('leadScrollableElement') leadScrollableElement!: ElementRef;
  leadScrollToTop(): void {
    const element = this.leadScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onLeadScroll(event: Event): void {
    const element = event.target;
    this.leadScrollTop = element['scrollTop'];
  }

  // ------------- Popup Tasks Pagination ------------------------------

  taskRows: number = 5;
  taskScrollTop: number = 0;
  @ViewChild('taskScrollableElement') taskScrollableElement!: ElementRef;
  taskScrollToTop(): void {
    const element = this.taskScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onTaskScroll(event: Event): void {
    const element = event.target;
    this.taskScrollTop = element['scrollTop'];
  }

  // ------------- Popup Contract Pagination ------------------------------

  contractRows: number = 5;
  contractScrollTop: number = 0;
  @ViewChild('contractScrollableElement') contractScrollableElement!: ElementRef;
  contractScrollToTop(): void {
    const element = this.contractScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onContractScroll(event: Event): void {
    const element = event.target;
    this.contractScrollTop = element['scrollTop'];
  }

  // ------------- Popup Related Pagination ------------------------------

  relatedRows: number = 5;
  relatedScrollTop: number = 0;
  @ViewChild('relatedScrollableElement') relatedScrollableElement!: ElementRef;
  relatedScrollToTop(): void {
    const element = this.relatedScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onRelatedScroll(event: Event): void {
    const element = event.target;
    this.relatedScrollTop = element['scrollTop'];
  }

  // ------------- Legal Pagination ------------------------------

  legalRows: number = 10;
  legalScrollTop: number = 0;
  @ViewChild('legalScrollableElement') legalScrollableElement!: ElementRef;
  legalScrollToTop(): void {
    const element = this.legalScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onLegalScroll(event: Event): void {
    const element = event.target;
    this.legalScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Related Contacts Pagination ------------------------------

  relContactRows: number = 10;
  relContactScrollTop: number = 0;
  @ViewChild('relContactScrollableElement') relContactScrollableElement!: ElementRef;
  relContactScrollToTop(): void {
    const element = this.relContactScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onRelContactScroll(event: Event): void {
    const element = event.target;
    this.relContactScrollTop = element['scrollTop'];
  }

  previousScrollTop: number = 0;

  // ------------- SideBar Leads Pagination ------------------------------

  sideLeadRows: number = 10;
  sideLeadScrollTop: number = 0;
  @ViewChild('sideLeadScrollableElement') sideLeadScrollableElement!: ElementRef;
  sideLeadScrollToTop(): void {
    const element = this.sideLeadScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onsideLeadScroll(event: Event): void {
    const element = event.target;
    this.sideLeadScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Tasks Pagination ------------------------------

  sideTaskRows: number = 10;
  sideTaskScrollTop: number = 0;
  @ViewChild('sideTaskScrollableElement') sideTaskScrollableElement!: ElementRef;
  sideTaskScrollToTop(): void {
    const element = this.sideTaskScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onSideTaskScroll(event: Event): void {
    const element = event.target;
    this.sideTaskScrollTop = element['scrollTop'];
  }

  // ------------ SideBar Approval Listing History Pagination -------------------------------

  aprHistoryRows: number = 10;
  aprHistoryPage: number = 1;
  isAprHistoryLoading: boolean = true;
  aprHistoryScrollTop: number = 0;
  @ViewChild('aprHistoryScrollableElement') aprHistoryScrollableElement!: ElementRef;
  aprHistoryScrollToTop(): void {
    const element = this.aprHistoryScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onAprHistoryScroll(event: Event): void {
    /**
     * Handles the scroll event for the approval history section.
     *
     * This function detects when the user has scrolled to the bottom of the
     * approval history list and triggers loading of the next page of approval
     * history records.
     *
     * @param event The scroll event.
     */
    const element = event.target;
    this.aprHistoryScrollTop = element['scrollTop'];
    const scrollHeight = element['scrollHeight'];
    const scrollTop = element['scrollTop'];
    const clientHeight = element['clientHeight'];

    // Check if the user has scrolled to the bottom of the list
    const isScrolledToBottom =
      parseInt(scrollHeight) - parseInt(scrollTop) - 5 < parseInt(clientHeight) ||
      parseInt(scrollHeight) - parseInt(scrollTop) === parseInt(clientHeight);

    if (isScrolledToBottom && this.isAprHistoryLoading) {
      // Increment the page number to load the next set of records
      this.aprHistoryPage += 1;
      this.isAprHistoryLoading = false;
      // Fetch the next page of approval history records
      this.getApprovalHistory(this.selectedProperty, this.aprHistoryPage, 10, true);
    }
  }

  onKeydown(event: KeyboardEvent): void {
    /**
     * Prevents the user from typing any character other than
     * numbers and the allowed keys.
     *
     * @param event The keyboard event.
     */
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'];
    const key = event.key;
    if (!allowedKeys.includes(key) && !/^\d$/.test(key)) {
      // Prevent the default action of the event.
      event.preventDefault();
    }
  }

  onUpdateMSelect = (eve: any[], type: string) => {
    let ids = eve.map(f => f._id); // More concise way to extract IDs

    if (type === 'to') {
      this.contractEmail.to = ids;
    } else {
      this.editProperty.patchValue({ [type]: ids }); // Dynamically set field name
    }
  };

  adminView() {
    this.loadAdmin = false;
    this.existEditProperty();
    setTimeout(() => {
      this.is_agentModel = false;
      this.dynamicPanelSizes = this.copyDynamicPanelSizes;
      this.cdr.detectChanges();
      this.refreshCalendarSize();
    }, 500);
  }
}
